var items = {
  "block.minecraft.acacia_button": "Pihi Koa",
  "block.minecraft.acacia_door": "ʻĪpuka Koa",
  "block.minecraft.acacia_fence": "Pālāʻau Koa",
  "block.minecraft.acacia_fence_gate": "ʻĪpuka Pālāʻau Koa",
  "block.minecraft.acacia_hanging_sign": "Papa Hōʻike Koa Kaulia",
  "block.minecraft.acacia_leaves": "Lau Koa",
  "block.minecraft.acacia_log": "Kualāʻau Koa",
  "block.minecraft.acacia_planks": "Papalāʻau Koa",
  "block.minecraft.acacia_pressure_plate": "Papa Kaumaha Koa",
  "block.minecraft.acacia_sapling": "Koa ʻŌpiopio",
  "block.minecraft.acacia_shelf": "Hakakau Koa",
  "block.minecraft.acacia_sign": "Papa Hōʻike Koa",
  "block.minecraft.acacia_slab": "Paukū Koa",
  "block.minecraft.acacia_stairs": "Alapiʻi Koa",
  "block.minecraft.acacia_trapdoor": "ʻĪpuka ʻŪmiʻi Koa",
  "block.minecraft.acacia_wall_hanging_sign": "Papa Hōʻike Koa Kūlewa",
  "block.minecraft.acacia_wall_sign": "Papa Hōʻike Koa Pili Paia",
  "block.minecraft.acacia_wood": "Lāʻau Koa",
  "block.minecraft.activator_rail": "Alahao Hoʻoui",
  "block.minecraft.air": "Ea",
  "block.minecraft.allium": "ʻAkaʻakai",
  "block.minecraft.amethyst_block": "Palaka ʻAmeki",
  "block.minecraft.amethyst_cluster": "ʻĀhui ʻAmeki",
  "block.minecraft.ancient_debris": "Koena Kahiko",
  "block.minecraft.andesite": "ʻElekū",
  "block.minecraft.andesite_slab": "Paukū ʻElekū",
  "block.minecraft.andesite_stairs": "Alapiʻi ʻElekū",
  "block.minecraft.andesite_wall": "Pāpōhaku ʻElekū",
  "block.minecraft.anvil": "Kua Hao",
  "block.minecraft.attached_melon_stem": "Hiʻanakiʻu Ipuhaole",
  "block.minecraft.attached_pumpkin_stem": "Hiʻanakiʻu Palaʻai",
  "block.minecraft.azalea": "Kaʻūmana",
  "block.minecraft.azalea_leaves": "Lau Kaʻūmana",
  "block.minecraft.azure_bluet": "Hinahina",
  "block.minecraft.bamboo": "ʻOhe",
  "block.minecraft.bamboo_block": "Palaka ʻOhe",
  "block.minecraft.bamboo_button": "Pihi ʻOhe",
  "block.minecraft.bamboo_door": "ʻĪpuka ʻOhe",
  "block.minecraft.bamboo_fence": "Pālāʻau ʻOhe",
  "block.minecraft.bamboo_fence_gate": "ʻĪpuka Pālāʻau ʻOhe",
  "block.minecraft.bamboo_hanging_sign": "Papa Hōʻike ʻOhe Kaulia",
  "block.minecraft.bamboo_mosaic": "Mokaika ʻOhe",
  "block.minecraft.bamboo_mosaic_slab": "Paukū Mokaika ʻOhe",
  "block.minecraft.bamboo_mosaic_stairs": "Alapiʻi Mokaika ʻOhe",
  "block.minecraft.bamboo_planks": "Papalāʻau ʻOhe",
  "block.minecraft.bamboo_pressure_plate": "Papa Kaumaha ʻOhe",
  "block.minecraft.bamboo_sapling": "Keiki ʻOhe",
  "block.minecraft.bamboo_shelf": "Hakakau ʻOhe",
  "block.minecraft.bamboo_sign": "Hōʻailona ʻOhe",
  "block.minecraft.bamboo_slab": "Paukū ʻOhe",
  "block.minecraft.bamboo_stairs": "Alapiʻi ʻOhe",
  "block.minecraft.bamboo_trapdoor": "ʻĪpuka ʻŪmiʻi ʻOhe",
  "block.minecraft.bamboo_wall_hanging_sign": "Papa Hōʻike ʻOhe Kūlewa",
  "block.minecraft.bamboo_wall_sign": "Papa Hōʻike ʻOhe Pili Paia",
  "block.minecraft.banner.base.black": "Honua ʻEleʻele Piha Pono",
  "block.minecraft.banner.base.blue": "Honua Uliuli Piha Pono",
  "block.minecraft.banner.base.brown": "Honua Mākuʻe Piha Pono",
  "block.minecraft.banner.base.cyan": "Honua Wale Mamaʻo",
  "block.minecraft.banner.base.gray": "Honua ʻĀhinahina Piha Pono",
  "block.minecraft.banner.base.green": "Honua ʻŌmaʻomaʻo Piha Pono",
  "block.minecraft.banner.base.light_blue": "Honua ʻUkiʻuki Piha Pono",
  "block.minecraft.banner.base.light_gray": "Honua ʻĀhiehie Piha Pono",
  "block.minecraft.banner.base.lime": "Honua Laimi Piha Pono",
  "block.minecraft.banner.base.magenta": "Honua ʻUlamākuʻe Piha Pono",
  "block.minecraft.banner.base.orange": "Honua ʻAlani Piha Pono",
  "block.minecraft.banner.base.pink": "Honua ʻĀkala Piha Pono",
  "block.minecraft.banner.base.purple": "Honua Poni Piha Pono",
  "block.minecraft.banner.base.red": "Honua ʻUlaʻula Piha Pono",
  "block.minecraft.banner.base.white": "Honua Keʻokeʻo Piha Pono",
  "block.minecraft.banner.base.yellow": "Honua Melemele Piha Pono",
  "block.minecraft.banner.border.black": "Alahiʻi ʻEleʻele",
  "block.minecraft.banner.border.blue": "Alahiʻi Uliuli",
  "block.minecraft.banner.border.brown": "Alahiʻi Mākuʻe",
  "block.minecraft.banner.border.cyan": "Alahiʻi Mamaʻo",
  "block.minecraft.banner.border.gray": "Alahiʻi ʻĀhinahina",
  "block.minecraft.banner.border.green": "Alahiʻi ʻŌmaʻomaʻo",
  "block.minecraft.banner.border.light_blue": "Alahiʻi ʻUkiʻuki",
  "block.minecraft.banner.border.light_gray": "Alahiʻi ʻĀhiehie",
  "block.minecraft.banner.border.lime": "Alahiʻi Laimi",
  "block.minecraft.banner.border.magenta": "Alahiʻi ʻUlamākuʻe",
  "block.minecraft.banner.border.orange": "Alahiʻi ʻAlani",
  "block.minecraft.banner.border.pink": "Alahiʻi ʻĀkala",
  "block.minecraft.banner.border.purple": "Alahiʻi Poni",
  "block.minecraft.banner.border.red": "Alahiʻi ʻUlaʻula",
  "block.minecraft.banner.border.white": "Alahiʻi Keʻokeʻo",
  "block.minecraft.banner.border.yellow": "Alahiʻi Melemele",
  "block.minecraft.banner.bricks.black": "Honua Winihapa ʻEleʻele",
  "block.minecraft.banner.bricks.blue": "Honua Winihapa Uliuli",
  "block.minecraft.banner.bricks.brown": "Honua Winihapa Mākuʻe",
  "block.minecraft.banner.bricks.cyan": "Honua Winihapa Mamaʻo",
  "block.minecraft.banner.bricks.gray": "Honua Winihapa ʻĀhinahina",
  "block.minecraft.banner.bricks.green": "Honua Winihapa ʻŌmaʻomaʻo",
  "block.minecraft.banner.bricks.light_blue": "Honua Winihapa ʻUkiʻuki",
  "block.minecraft.banner.bricks.light_gray": "Honua Winihapa ʻĀhiehie",
  "block.minecraft.banner.bricks.lime": "Honua Winihapa Laimi",
  "block.minecraft.banner.bricks.magenta": "Honua Winihapa ʻUlamākuʻe",
  "block.minecraft.banner.bricks.orange": "Honua Winihapa ʻAlani",
  "block.minecraft.banner.bricks.pink": "Honua Winihapa ʻĀkala",
  "block.minecraft.banner.bricks.purple": "Honua Winihapa Poni",
  "block.minecraft.banner.bricks.red": "Honua Winihapa ʻUlaʻula",
  "block.minecraft.banner.bricks.white": "Honua Winihapa Keʻokeʻo",
  "block.minecraft.banner.bricks.yellow": "Honua Winihapa Melemele",
  "block.minecraft.banner.circle.black": "Pōʻai-waena ʻEleʻele",
  "block.minecraft.banner.circle.blue": "Pōʻai-waena Uliuli",
  "block.minecraft.banner.circle.brown": "Pōʻai-waena Mākuʻe",
  "block.minecraft.banner.circle.cyan": "Pōʻai-waena Mamaʻo",
  "block.minecraft.banner.circle.gray": "Pōʻai-waena ʻĀhinahina",
  "block.minecraft.banner.circle.green": "Pōʻai-waena ʻŌmaʻomaʻo",
  "block.minecraft.banner.circle.light_blue": "Pōʻai-waena ʻUkiʻuki",
  "block.minecraft.banner.circle.light_gray": "Pōʻai-waena ʻĀhiehie",
  "block.minecraft.banner.circle.lime": "Pōʻai-waena Laimi",
  "block.minecraft.banner.circle.magenta": "Pōʻai-waena ʻUlamākuʻe",
  "block.minecraft.banner.circle.orange": "Pōʻai-waena ʻAlani",
  "block.minecraft.banner.circle.pink": "Pōʻai-waena ʻĀkala",
  "block.minecraft.banner.circle.purple": "Pōʻai-waena Poni",
  "block.minecraft.banner.circle.red": "Pōʻai-waena ʻUlaʻula",
  "block.minecraft.banner.circle.white": "Pōʻai-waena Keʻokeʻo",
  "block.minecraft.banner.circle.yellow": "Pōʻai-waena Melemele",
  "block.minecraft.banner.creeper.black": "Lepa ʻAno Creeper ʻEleʻele",
  "block.minecraft.banner.creeper.blue": "Lepa ʻAno Creeper Uliuli",
  "block.minecraft.banner.creeper.brown": "Lepa ʻAno Creeper Mākuʻe",
  "block.minecraft.banner.creeper.cyan": "Lepa ʻAno Creeper Mamaʻo",
  "block.minecraft.banner.creeper.gray": "Lepa ʻAno Creeper ʻĀhinahina",
  "block.minecraft.banner.creeper.green": "Lepa ʻAno Creeper ʻŌmaʻomaʻo",
  "block.minecraft.banner.creeper.light_blue": "Lepa ʻAno Creeper ʻUkiʻuki",
  "block.minecraft.banner.creeper.light_gray": "Lepa ʻAno Creeper ʻĀhiehie",
  "block.minecraft.banner.creeper.lime": "Lepa ʻAno Creeper Laimi",
  "block.minecraft.banner.creeper.magenta": "Lepa ʻAno Creeper ʻUlamākuʻe",
  "block.minecraft.banner.creeper.orange": "Lepa ʻAno Creeper ʻAlani",
  "block.minecraft.banner.creeper.pink": "Lepa ʻAno Creeper ʻĀkala",
  "block.minecraft.banner.creeper.purple": "Lepa ʻAno Creeper Poni",
  "block.minecraft.banner.creeper.red": "Lepa ʻAno Creeper ʻUlaʻula",
  "block.minecraft.banner.creeper.white": "Lepa ʻAno Creeper Keʻokeʻo",
  "block.minecraft.banner.creeper.yellow": "Lepa ʻAno Creeper Melemele",
  "block.minecraft.banner.cross.black": "Peʻa ʻEleʻele",
  "block.minecraft.banner.cross.blue": "Peʻa Uliuli",
  "block.minecraft.banner.cross.brown": "Peʻa Mākuʻe",
  "block.minecraft.banner.cross.cyan": "Peʻa Mamaʻo",
  "block.minecraft.banner.cross.gray": "Peʻa ʻĀhinahina",
  "block.minecraft.banner.cross.green": "Peʻa ʻŌmaʻomaʻo",
  "block.minecraft.banner.cross.light_blue": "Peʻa ʻUkiʻuki",
  "block.minecraft.banner.cross.light_gray": "Peʻa ʻĀhiehie",
  "block.minecraft.banner.cross.lime": "Peʻa Laimi",
  "block.minecraft.banner.cross.magenta": "Peʻa ʻUlamākuʻe",
  "block.minecraft.banner.cross.orange": "Peʻa ʻĀlani",
  "block.minecraft.banner.cross.pink": "Peʻa ʻĀkala",
  "block.minecraft.banner.cross.purple": "Peʻa Poni",
  "block.minecraft.banner.cross.red": "Peʻa ʻUlaʻula",
  "block.minecraft.banner.cross.white": "Peʻa Keʻokeʻo",
  "block.minecraft.banner.cross.yellow": "Peʻa Melemele",
  "block.minecraft.banner.curly_border.black": "Alahiʻi ʻEleʻele Poʻopoʻo",
  "block.minecraft.banner.curly_border.blue": "Alahiʻi Uliuli Poʻopoʻo",
  "block.minecraft.banner.curly_border.brown": "Alahiʻi Mākuʻe Poʻopoʻo",
  "block.minecraft.banner.curly_border.cyan": "Alahiʻi Mamaʻo Poʻopoʻo",
  "block.minecraft.banner.curly_border.gray": "Alahiʻi ʻĀhinahina Poʻopoʻo",
  "block.minecraft.banner.curly_border.green": "Alahiʻi ʻŌmaʻomaʻo Poʻopoʻo",
  "block.minecraft.banner.curly_border.light_blue": "Alahiʻi ʻUkiʻuki Poʻopoʻo",
  "block.minecraft.banner.curly_border.light_gray": "Alahiʻi ʻĀhiehie Poʻopoʻo",
  "block.minecraft.banner.curly_border.lime": "Alahiʻi Laimi Poʻopoʻo",
  "block.minecraft.banner.curly_border.magenta": "Alahiʻi ʻUlamākuʻe",
  "block.minecraft.banner.curly_border.orange": "Alahiʻi ʻAlani Poʻopoʻo",
  "block.minecraft.banner.curly_border.pink": "Alahiʻi ʻĀkala Poʻopoʻo",
  "block.minecraft.banner.curly_border.purple": "Alahiʻi Poni Poʻopoʻo",
  "block.minecraft.banner.curly_border.red": "Alahiʻi ʻUlaʻula Poʻopoʻo",
  "block.minecraft.banner.curly_border.white": "Alahiʻi Keʻokeʻo Poʻopoʻo",
  "block.minecraft.banner.curly_border.yellow": "Alahiʻi Melemele Poʻopoʻo",
  "block.minecraft.banner.diagonal_left.black": "Hapahuinakolu Kahalala-Hema ʻEleʻele",
  "block.minecraft.banner.diagonal_left.blue": "Hapahuinakolu Kahalala-Hema Uliuli",
  "block.minecraft.banner.diagonal_left.brown": "Hapahuinakolu Kahalala-Hema Mākuʻe",
  "block.minecraft.banner.diagonal_left.cyan": "Hapahuinakolu Kahalala-Hema Mamaʻo",
  "block.minecraft.banner.diagonal_left.gray": "Hapahuinakolu Kahalala-Hema ʻĀhiehie",
  "block.minecraft.banner.diagonal_left.green": "Hapahuinakolu Kahalala-Hema ʻŌmaʻomaʻo",
  "block.minecraft.banner.diagonal_left.light_blue": "Hapahuinakolu Kahalala-Hema ʻUkiʻuki",
  "block.minecraft.banner.diagonal_left.light_gray": "Hapahuinakolu Kahalala-Hema ʻĀhiehie",
  "block.minecraft.banner.diagonal_left.lime": "Hapahuinakolu Kahalala-Hema Laimi",
  "block.minecraft.banner.diagonal_left.magenta": "Hapahuinakolu Kahalala-Hema ʻUlamākuʻe",
  "block.minecraft.banner.diagonal_left.orange": "Hapahuinakolu Kahalala-Hema ʻAlani",
  "block.minecraft.banner.diagonal_left.pink": "Hapahuinakolu Kahalala-Hema ʻĀkala",
  "block.minecraft.banner.diagonal_left.purple": "Hapahuinakolu Kahalala-Hema Poni",
  "block.minecraft.banner.diagonal_left.red": "Hapahuinakolu Kahalala-Hema ʻUlaʻula",
  "block.minecraft.banner.diagonal_left.white": "Hapahuinakolu Kahalala-Hema Keʻokeʻo",
  "block.minecraft.banner.diagonal_left.yellow": "Hapahuinakolu Kahalala-Hema Melemele",
  "block.minecraft.banner.diagonal_right.black": "Hapahuinakolu Kahalala ʻEleʻele",
  "block.minecraft.banner.diagonal_right.blue": "Hapahuinakolu Kahalala Uliuli",
  "block.minecraft.banner.diagonal_right.brown": "Hapahuinakolu Kahalala Mākuʻe",
  "block.minecraft.banner.diagonal_right.cyan": "Hapahuinakolu Kahalala Mamaʻo",
  "block.minecraft.banner.diagonal_right.gray": "Hapahuinakolu Kahalala ʻĀhinahina",
  "block.minecraft.banner.diagonal_right.green": "Hapahuinakolu Kahalala ʻŌmaʻomaʻo",
  "block.minecraft.banner.diagonal_right.light_blue": "Papamoe ʻUkiʻuki",
  "block.minecraft.banner.diagonal_right.light_gray": "Hapahuinakolu Kahalala ʻĀhiehie",
  "block.minecraft.banner.diagonal_right.lime": "Hapahuinakolu Kahalala Laimi",
  "block.minecraft.banner.diagonal_right.magenta": "Papamoe ʻUlamākuʻe",
  "block.minecraft.banner.diagonal_right.orange": "Papamoe ʻAlani",
  "block.minecraft.banner.diagonal_right.pink": "Hapahuinakolu Kahalala ʻĀkala",
  "block.minecraft.banner.diagonal_right.purple": "Hapahuinakolu Kahalala Poni",
  "block.minecraft.banner.diagonal_right.red": "Hapahuinakolu Kahalala ʻUlaʻula",
  "block.minecraft.banner.diagonal_right.white": "Hapahuinakolu Kahalala Keʻokeʻo",
  "block.minecraft.banner.diagonal_right.yellow": "Papamoe Melemele",
  "block.minecraft.banner.diagonal_up_left.black": "Hapahuinakolu Kahalala-Hulia ʻEleʻele",
  "block.minecraft.banner.diagonal_up_left.blue": "Hapahuinakolu Kahalala-Hulia Uliuli",
  "block.minecraft.banner.diagonal_up_left.brown": "Hapahuinakolu Kahalala-Hulia Mākuʻe",
  "block.minecraft.banner.diagonal_up_left.cyan": "Hapahuinakolu Kahalala-Hulia Mamaʻo",
  "block.minecraft.banner.diagonal_up_left.gray": "Hapahuinakolu Kahalala-Hulia ʻĀhinahina",
  "block.minecraft.banner.diagonal_up_left.green": "Hapahuinakolu Kahalala-Hulia ʻŌmaʻomaʻo",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Hapahuinakolu Kahalala-Hulia ʻUkiʻuki",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Hapahuinakolu Kahalala-Hulia ʻĀhiehie",
  "block.minecraft.banner.diagonal_up_left.lime": "Hapahuinakolu Kahalala-Hulia Laimi",
  "block.minecraft.banner.diagonal_up_left.magenta": "Hapahuinakolu Kahalala-Hulia ʻUlamākuʻe",
  "block.minecraft.banner.diagonal_up_left.orange": "Hapahuinakolu Kahalala-Hulia ʻAlani",
  "block.minecraft.banner.diagonal_up_left.pink": "Hapahuinakolu Kahalala-Hulia ʻĀkala",
  "block.minecraft.banner.diagonal_up_left.purple": "Hapahuinakolu Kahalala-Hulia Poni",
  "block.minecraft.banner.diagonal_up_left.red": "Hapahuinakolu Kahalala-Hulia ʻUlaʻula",
  "block.minecraft.banner.diagonal_up_left.white": "Hapahuinakolu Kahalala-Hulia Keʻokeʻo",
  "block.minecraft.banner.diagonal_up_left.yellow": "Hapahuinakolu Kahalala-Hulia Melemele",
  "block.minecraft.banner.diagonal_up_right.black": "Hapahuinakolu Kahalala-Hema-Hulia ʻEleʻele",
  "block.minecraft.banner.diagonal_up_right.blue": "Hapahuinakolu Kahalala-Hema-Hulia Uliuli",
  "block.minecraft.banner.diagonal_up_right.brown": "Hapahuinakolu Kahalala-Hema-Hulia Mākuʻe",
  "block.minecraft.banner.diagonal_up_right.cyan": "Hapahuinakolu Kahalala-Hema-Hulia Mamaʻo",
  "block.minecraft.banner.diagonal_up_right.gray": "Hapahuinakolu Kahalala-Hema-Hulia ʻĀhinahina",
  "block.minecraft.banner.diagonal_up_right.green": "Hapahuinakolu Kahalala-Hema-Hulia ʻŌmaʻomaʻo",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Hapahuinakolu Kahalala-Hema-Hulia ʻUkiʻuki",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Hapahuinakolu Kahalala-Hema-Hulia ʻĀhiehie",
  "block.minecraft.banner.diagonal_up_right.lime": "Lime Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.orange": "Hoʻohuli ʻia ka ʻAlani no kēlā me kēia Bend",
  "block.minecraft.banner.diagonal_up_right.pink": "Hoʻohuli ʻia ka ʻulaʻula ma kēlā me kēia Bend",
  "block.minecraft.banner.diagonal_up_right.purple": "Poni no kēlā me kēia Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.red": "ʻO Red Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.white": "Keʻokeʻo Per Bend Kinster Inverted",
  "block.minecraft.banner.diagonal_up_right.yellow": "Melemele Per Bend Sinister Inverted",
  "block.minecraft.banner.flow.black": "Nalu ʻEleʻele",
  "block.minecraft.banner.flow.blue": "Nalu Uliuli",
  "block.minecraft.banner.flow.brown": "Nalu Mākuʻe",
  "block.minecraft.banner.flow.cyan": "Nalu Mamaʻo",
  "block.minecraft.banner.flow.gray": "Nalu ʻĀhinahina",
  "block.minecraft.banner.flow.green": "Nalu ʻŌmaʻomaʻo",
  "block.minecraft.banner.flow.light_blue": "Nalu ʻUkiʻuki",
  "block.minecraft.banner.flow.light_gray": "Nalu ʻĀhiehie",
  "block.minecraft.banner.flow.lime": "Nalu Laimi",
  "block.minecraft.banner.flow.magenta": "Nalu ʻUlamākuʻe",
  "block.minecraft.banner.flow.orange": "Nalu ʻAlani",
  "block.minecraft.banner.flow.pink": "Nalu ʻĀkala",
  "block.minecraft.banner.flow.purple": "Nalu Poni",
  "block.minecraft.banner.flow.red": "Nalu ʻUlaʻula",
  "block.minecraft.banner.flow.white": "Nalu Keʻokeʻo",
  "block.minecraft.banner.flow.yellow": "Nalu Melemele",
  "block.minecraft.banner.flower.black": "Lepa Pua ʻEleʻele",
  "block.minecraft.banner.flower.blue": "Lepa Pua Uliuli",
  "block.minecraft.banner.flower.brown": "Lepa Pua Mākuʻe",
  "block.minecraft.banner.flower.cyan": "Lepa Pua Mamaʻo",
  "block.minecraft.banner.flower.gray": "Lepa Pua ʻĀhinahina",
  "block.minecraft.banner.flower.green": "Lepa Pua ʻŌmaʻomaʻo",
  "block.minecraft.banner.flower.light_blue": "Lepa Pua ʻUkiʻuki",
  "block.minecraft.banner.flower.light_gray": "Lepa Pua ʻĀhiehie",
  "block.minecraft.banner.flower.lime": "Lepa Pua Laimi",
  "block.minecraft.banner.flower.magenta": "Lepa Pua ʻUlamākuʻe",
  "block.minecraft.banner.flower.orange": "Lepa Pua ʻAlani",
  "block.minecraft.banner.flower.pink": "Lepa Pua ʻĀkala",
  "block.minecraft.banner.flower.purple": "Lepa Pua Poni",
  "block.minecraft.banner.flower.red": "Lepa Pua ʻUlaʻula",
  "block.minecraft.banner.flower.white": "Lepa Pua Keʻokeʻo",
  "block.minecraft.banner.flower.yellow": "Lepa Pua Melemele",
  "block.minecraft.banner.globe.black": "Poepoehonua ʻEleʻele",
  "block.minecraft.banner.globe.blue": "Poepoehonua Uliuli",
  "block.minecraft.banner.globe.brown": "Poepoehonua Mākuʻe",
  "block.minecraft.banner.globe.cyan": "Poepoehonua Mamaʻo",
  "block.minecraft.banner.globe.gray": "Poepoehonua ʻĀhinahina",
  "block.minecraft.banner.globe.green": "Poepoehonua ʻŌmaʻomaʻo",
  "block.minecraft.banner.globe.light_blue": "Poepoehonua ʻUkiʻuki",
  "block.minecraft.banner.globe.light_gray": "Poepoehonua ʻĀhiehie",
  "block.minecraft.banner.globe.lime": "Poepoehonua Laimi",
  "block.minecraft.banner.globe.magenta": "Poepoehonua ʻUlamākuʻe",
  "block.minecraft.banner.globe.orange": "Poepoehonua ʻAlani",
  "block.minecraft.banner.globe.pink": "Poepoehonua ʻĀkala",
  "block.minecraft.banner.globe.purple": "Poepoehonua Poni",
  "block.minecraft.banner.globe.red": "Poepoehonua ʻUlaʻula",
  "block.minecraft.banner.globe.white": "Poepoehonua Keʻokeʻo",
  "block.minecraft.banner.globe.yellow": "Poepoehonua Melemele",
  "block.minecraft.banner.gradient.black": "ʻAuina Kala Hoʻouli ʻEleʻele",
  "block.minecraft.banner.gradient.blue": "ʻAuina Kala Hoʻouli Uliuli",
  "block.minecraft.banner.gradient.brown": "ʻAuina Kala Hoʻouli Mākuʻe",
  "block.minecraft.banner.gradient.cyan": "ʻAuina Kala Hoʻouli Mamaʻo",
  "block.minecraft.banner.gradient.gray": "ʻAuina Kala Hoʻouli ʻĀhinahina",
  "block.minecraft.banner.gradient.green": "ʻAuina Kala Hoʻouli ʻŌmaʻomaʻo",
  "block.minecraft.banner.gradient.light_blue": "ʻAuina Kala Hoʻouli ʻUkiʻuki",
  "block.minecraft.banner.gradient.light_gray": "ʻAuina Kala Hoʻouli ʻĀhiehie",
  "block.minecraft.banner.gradient.lime": "ʻAuina Kala Hoʻouli Laimi",
  "block.minecraft.banner.gradient.magenta": "ʻAuina Kala Hoʻouli ʻUlamākuʻe",
  "block.minecraft.banner.gradient.orange": "ʻAuina Kala Hoʻouli ʻAlani",
  "block.minecraft.banner.gradient.pink": "ʻAuina Kala Hoʻouli ʻĀkala",
  "block.minecraft.banner.gradient.purple": "ʻAuina Kala Hoʻouli Poni",
  "block.minecraft.banner.gradient.red": "ʻAuina Kala Hoʻouli ʻUlaʻula",
  "block.minecraft.banner.gradient.white": "ʻAuina Kala Hoʻouli Keʻokeʻo",
  "block.minecraft.banner.gradient.yellow": "ʻAuina Kala Hoʻouli Melemele",
  "block.minecraft.banner.gradient_up.black": "ʻAuina Kala Hoʻomāmā ʻEleʻele",
  "block.minecraft.banner.gradient_up.blue": "ʻAuina Kala Hoʻomāmā Uliuli",
  "block.minecraft.banner.gradient_up.brown": "ʻAuina Kala Hoʻomāmā Mākuʻe",
  "block.minecraft.banner.gradient_up.cyan": "ʻAuina Kala Hoʻomāmā Mamaʻo",
  "block.minecraft.banner.gradient_up.gray": "ʻAuina Kala Hoʻomāmā ʻĀhinahina",
  "block.minecraft.banner.gradient_up.green": "ʻAuina Kala Hoʻomāmā ʻŌmaʻomaʻo",
  "block.minecraft.banner.gradient_up.light_blue": "ʻAuina Kala Hoʻomāmā ʻUkiʻuki",
  "block.minecraft.banner.gradient_up.light_gray": "ʻAuina Kala Hoʻomāmā ʻĀhiehie",
  "block.minecraft.banner.gradient_up.lime": "ʻAuina Kala Hoʻomāmā Laimi",
  "block.minecraft.banner.gradient_up.magenta": "ʻAuina Kala Hoʻomāmā ʻUlamākuʻe",
  "block.minecraft.banner.gradient_up.orange": "ʻAuina Kala Hoʻomāmā ʻAlani",
  "block.minecraft.banner.gradient_up.pink": "ʻAuina Kala Hoʻomāmā ʻĀkala",
  "block.minecraft.banner.gradient_up.purple": "ʻAuina Kala Hoʻomāmā Poni",
  "block.minecraft.banner.gradient_up.red": "ʻAuina Kala Hoʻomāmā ʻUlaʻula",
  "block.minecraft.banner.gradient_up.white": "ʻAuina Kala Hoʻomāmā Keʻokeʻo",
  "block.minecraft.banner.gradient_up.yellow": "ʻAuina Kala Hoʻomāmā Melemele",
  "block.minecraft.banner.guster.black": "Hae Puahio ʻEleʻele",
  "block.minecraft.banner.guster.blue": "Hae Puahio Uliuli",
  "block.minecraft.banner.guster.brown": "Hae Puahio Mākuʻe",
  "block.minecraft.banner.guster.cyan": "Hae Puahio Mamaʻo",
  "block.minecraft.banner.guster.gray": "Hae Puahio ʻĀhinahina",
  "block.minecraft.banner.guster.green": "Hae Puahio ʻŌmaʻomaʻo",
  "block.minecraft.banner.guster.light_blue": "Hae Puahio ʻUkiʻuki",
  "block.minecraft.banner.guster.light_gray": "Hae Puahio ʻĀhiehie",
  "block.minecraft.banner.guster.lime": "Hae Puahio Laimi",
  "block.minecraft.banner.guster.magenta": "Hae Puahio ʻUlamākuʻe",
  "block.minecraft.banner.guster.orange": "Hae Puahio ʻĀlani",
  "block.minecraft.banner.guster.pink": "Hae Puahio ʻĀkala",
  "block.minecraft.banner.guster.purple": "Hae Puahio Poni",
  "block.minecraft.banner.guster.red": "Hae Puahio ʻUlaʻula",
  "block.minecraft.banner.guster.white": "Hae Puahio Keʻokeʻo",
  "block.minecraft.banner.guster.yellow": "Hae Puahio Melemele",
  "block.minecraft.banner.half_horizontal.black": "Hapa Papamoe-o-Luna ʻEleʻele",
  "block.minecraft.banner.half_horizontal.blue": "Hapa Papamoe-o-Luna Uliuli",
  "block.minecraft.banner.half_horizontal.brown": "Hapa Papamoe-o-Luna Mākuʻe",
  "block.minecraft.banner.half_horizontal.cyan": "Hapa Papamoe-o-Luna Mamaʻo",
  "block.minecraft.banner.half_horizontal.gray": "Hapa Papamoe-o-Luna ʻĀhinahina",
  "block.minecraft.banner.half_horizontal.green": "Hapa Papamoe-o-Luna ʻŌmaʻomaʻo",
  "block.minecraft.banner.half_horizontal.light_blue": "Papamoe ʻUkiʻuki",
  "block.minecraft.banner.half_horizontal.light_gray": "Hapa Papamoe-o-Luna ʻĀhiehie",
  "block.minecraft.banner.half_horizontal.lime": "Hapa Papamoe-o-Luna Laimi",
  "block.minecraft.banner.half_horizontal.magenta": "Hapa Papamoe-o-Luna ʻUlamākuʻe",
  "block.minecraft.banner.half_horizontal.orange": "Hapa Papamoe-o-Luna ʻAlani",
  "block.minecraft.banner.half_horizontal.pink": "Hapa Papamoe-o-Luna ʻĀkala",
  "block.minecraft.banner.half_horizontal.purple": "Hapa Papamoe-o-Luna Poni",
  "block.minecraft.banner.half_horizontal.red": "Hapa Papamoe-o-Luna ʻUlaʻula",
  "block.minecraft.banner.half_horizontal.white": "Hapa Papamoe-o-Luna Keʻokeʻo",
  "block.minecraft.banner.half_horizontal.yellow": "Hapa Papamoe-o-Luna Melemele",
  "block.minecraft.banner.half_horizontal_bottom.black": "Hapa Papamoe-o-Lalo ʻEleʻele",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Hapa Papamoe-o-Lalo Uliuli",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Hapa Papamoe-o-Lalo Mākuʻe",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Hapa Papamoe-o-Lalo Mamaʻo",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Hapa Papamoe-o-Lalo ʻĀhinahina",
  "block.minecraft.banner.half_horizontal_bottom.green": "Hapa Papamoe-o-Lalo ʻŌmaʻomaʻo",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Hapa Papamoe-o-Lalo",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Hapa Papamoe-o-Lalo ʻĀhiehie",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Hapa Papamoe-o-Lalo Laimi",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Hapa Papamoe-o-Lalo ʻUlamākuʻe",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Hapa Papamoe-o-Lalo ʻAlani",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Hapa Papamoe-o-Lalo ʻĀkala",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Hapa Papamoe-o-Lalo Poni",
  "block.minecraft.banner.half_horizontal_bottom.red": "Hapa Papamoe-o-Lalo ʻUlaʻula",
  "block.minecraft.banner.half_horizontal_bottom.white": "Hapa Papamoe-o-Lalo Keʻokeʻo",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Hapa Papamoe-o-Lalo Melemele",
  "block.minecraft.banner.half_vertical.black": "Hapalua-Papakū ʻEleʻele",
  "block.minecraft.banner.half_vertical.blue": "Hapalua-Papakū Uliuli",
  "block.minecraft.banner.half_vertical.brown": "Hapalua-Papakū Mākuʻe",
  "block.minecraft.banner.half_vertical.cyan": "Hapalua-Papakū Mamaʻo",
  "block.minecraft.banner.half_vertical.gray": "Hapalua-Papakū ʻŌmaʻomaʻo",
  "block.minecraft.banner.half_vertical.green": "Hapalua-Papakū ʻŌmaʻomaʻo",
  "block.minecraft.banner.half_vertical.light_blue": "Hapalua-Papakū ʻUkiʻuki",
  "block.minecraft.banner.half_vertical.light_gray": "Hapalua-Papakū ʻĀhiehie",
  "block.minecraft.banner.half_vertical.lime": "Hapalua-Papakū Laimi",
  "block.minecraft.banner.half_vertical.magenta": "Hapalua-Papakū ʻUlamākuʻe",
  "block.minecraft.banner.half_vertical.orange": "Hapalua-Papakū ʻAlani",
  "block.minecraft.banner.half_vertical.pink": "Hapalua-Papakū ʻĀkala",
  "block.minecraft.banner.half_vertical.purple": "Hapalua-Papakū Poni",
  "block.minecraft.banner.half_vertical.red": "Hapalua-Papakū ʻUlaʻula",
  "block.minecraft.banner.half_vertical.white": "Hapalua-Papakū Keʻokeʻo",
  "block.minecraft.banner.half_vertical.yellow": "Hapalua-Papakū Melemele",
  "block.minecraft.banner.half_vertical_right.black": "Hapalua-Papakū-Hulia ʻEleʻele",
  "block.minecraft.banner.half_vertical_right.blue": "Hapalua-Papakū-Hulia Uliuli",
  "block.minecraft.banner.half_vertical_right.brown": "Hapalua-Papakū-Hulia Mākuʻe",
  "block.minecraft.banner.half_vertical_right.cyan": "Hapalua-Papakū-Hulia Mamaʻo",
  "block.minecraft.banner.half_vertical_right.gray": "Hapalua-Papakū-Hulia ʻĀhinahina",
  "block.minecraft.banner.half_vertical_right.green": "Hapalua-Papakū-Hulia ʻŌmaʻomaʻo",
  "block.minecraft.banner.half_vertical_right.light_blue": "Hapalua-Papakū-Hulia ʻUkiʻuki",
  "block.minecraft.banner.half_vertical_right.light_gray": "Hapalua-Papakū-Hulia ʻĀhiehie",
  "block.minecraft.banner.half_vertical_right.lime": "Hapalua-Papakū-Hulia Laimi",
  "block.minecraft.banner.half_vertical_right.magenta": "Hapalua-Papakū-Hulia ʻUlamākuʻe",
  "block.minecraft.banner.half_vertical_right.orange": "Hapalua-Papakū-Hulia ʻAlani",
  "block.minecraft.banner.half_vertical_right.pink": "Hapalua-Papakū-Hulia ʻĀkala",
  "block.minecraft.banner.half_vertical_right.purple": "Hapalua-Papakū-Hulia Poni",
  "block.minecraft.banner.half_vertical_right.red": "Hapalua-Papakū-Hulia ʻUlaʻula",
  "block.minecraft.banner.half_vertical_right.white": "Hapalua-Papakū-Hulia Keʻokeʻo",
  "block.minecraft.banner.half_vertical_right.yellow": "Hapalua-Papakū-Hulia Melemele",
  "block.minecraft.banner.mojang.black": "Mea ʻEleʻele",
  "block.minecraft.banner.mojang.blue": "Mea Uliuli",
  "block.minecraft.banner.mojang.brown": "Mea Mākuʻe",
  "block.minecraft.banner.mojang.cyan": "Mea Mamaʻo",
  "block.minecraft.banner.mojang.gray": "Mea ʻĀhinahina",
  "block.minecraft.banner.mojang.green": "Mea ʻŌmaʻomaʻo",
  "block.minecraft.banner.mojang.light_blue": "Mea ʻUkiʻuki",
  "block.minecraft.banner.mojang.light_gray": "Mea ʻĀhinahina",
  "block.minecraft.banner.mojang.lime": "Mea Laimi",
  "block.minecraft.banner.mojang.magenta": "Mea ʻUlamākuʻe",
  "block.minecraft.banner.mojang.orange": "Mea ʻAlani",
  "block.minecraft.banner.mojang.pink": "Mea ʻĀkala",
  "block.minecraft.banner.mojang.purple": "Mea Poni",
  "block.minecraft.banner.mojang.red": "Mea ʻUlaʻula",
  "block.minecraft.banner.mojang.white": "Mea Keʻokeʻo",
  "block.minecraft.banner.mojang.yellow": "Mea Melemele",
  "block.minecraft.banner.piglin.black": "Nuku ʻEleʻele",
  "block.minecraft.banner.piglin.blue": "Nuku Uliuli",
  "block.minecraft.banner.piglin.brown": "Nuku Mākuʻe",
  "block.minecraft.banner.piglin.cyan": "Nuku Mamaʻo",
  "block.minecraft.banner.piglin.gray": "Nuku ʻĀhinahina",
  "block.minecraft.banner.piglin.green": "Nuku ʻŌmaʻomaʻo",
  "block.minecraft.banner.piglin.light_blue": "Nuku ʻUkiʻuki",
  "block.minecraft.banner.piglin.light_gray": "Nuku ʻĀhiehie",
  "block.minecraft.banner.piglin.lime": "Nuku Laimi",
  "block.minecraft.banner.piglin.magenta": "Nuku ʻUlamākuʻe",
  "block.minecraft.banner.piglin.orange": "Nuku ʻAlani",
  "block.minecraft.banner.piglin.pink": "Nuku ʻĀkala",
  "block.minecraft.banner.piglin.purple": "Nuku Poni",
  "block.minecraft.banner.piglin.red": "Nuku ʻUlaʻula",
  "block.minecraft.banner.piglin.white": "Nuku Keʻokeʻo",
  "block.minecraft.banner.piglin.yellow": "Nuku Melemele",
  "block.minecraft.banner.rhombus.black": "Huinahā Hiō Like ʻEleʻele",
  "block.minecraft.banner.rhombus.blue": "Huinahā Hiō Like Uliuli",
  "block.minecraft.banner.rhombus.brown": "Huinahā Hiō Like Mākuʻe",
  "block.minecraft.banner.rhombus.cyan": "Huinahā Hiō Like Mamaʻo",
  "block.minecraft.banner.rhombus.gray": "Huinahā Hiō Like ʻĀhinahina",
  "block.minecraft.banner.rhombus.green": "Huinahā Hiō Like ʻŌmaʻomaʻo",
  "block.minecraft.banner.rhombus.light_blue": "Huinahā Hiō Like ʻUkiʻuki",
  "block.minecraft.banner.rhombus.light_gray": "Huinahā Hiō Like ʻĀhiehie",
  "block.minecraft.banner.rhombus.lime": "Huinahā Hiō Like Laimi",
  "block.minecraft.banner.rhombus.magenta": "Huinahā Hiō Like ʻUlamākuʻe",
  "block.minecraft.banner.rhombus.orange": "Huinahā Hiō Like ʻAlani",
  "block.minecraft.banner.rhombus.pink": "Huinahā Hiō Like ʻĀkala",
  "block.minecraft.banner.rhombus.purple": "Huinahā Hiō Like Poni",
  "block.minecraft.banner.rhombus.red": "Huinahā Hiō Like ʻUlaʻula",
  "block.minecraft.banner.rhombus.white": "Huinahā Hiō Like Keʻokeʻo",
  "block.minecraft.banner.rhombus.yellow": "Huinahā Hiō Like Melemele",
  "block.minecraft.banner.skull.black": "Poʻo Iwi ʻEleʻele",
  "block.minecraft.banner.skull.blue": "Poʻo Iwi Uliuli",
  "block.minecraft.banner.skull.brown": "Poʻo Iwi Mākuʻe",
  "block.minecraft.banner.skull.cyan": "Poʻo Iwi Mamaʻo",
  "block.minecraft.banner.skull.gray": "Poʻo Iwi ʻĀhinahina",
  "block.minecraft.banner.skull.green": "Poʻo Iwi ʻŌmaʻomaʻo",
  "block.minecraft.banner.skull.light_blue": "Poʻo Iwi ʻUkiʻuki",
  "block.minecraft.banner.skull.light_gray": "Poʻo Iwi ʻĀhiehie",
  "block.minecraft.banner.skull.lime": "Poʻo Iwi Laimi",
  "block.minecraft.banner.skull.magenta": "Poʻo Iwi ʻUlamākuʻe",
  "block.minecraft.banner.skull.orange": "Poʻo Iwi ʻAlani",
  "block.minecraft.banner.skull.pink": "Poʻo Iwi ʻĀkala",
  "block.minecraft.banner.skull.purple": "Poʻo Iwi Poni",
  "block.minecraft.banner.skull.red": "Poʻo Iwi ʻUlaʻula",
  "block.minecraft.banner.skull.white": "Poʻo Iwi Keʻokeʻo",
  "block.minecraft.banner.skull.yellow": "Poʻo Iwi Melemele",
  "block.minecraft.banner.small_stripes.black": "Kahakahana ʻEleʻele",
  "block.minecraft.banner.small_stripes.blue": "Kahakahana Uliuli",
  "block.minecraft.banner.small_stripes.brown": "Kahakahana Mākuʻe",
  "block.minecraft.banner.small_stripes.cyan": "Kahakahana Mamaʻo",
  "block.minecraft.banner.small_stripes.gray": "Kahakahana ʻĀhinahina",
  "block.minecraft.banner.small_stripes.green": "Kahakahana ʻŌmaʻomaʻo",
  "block.minecraft.banner.small_stripes.light_blue": "Kahakahana ʻUkiʻuki",
  "block.minecraft.banner.small_stripes.light_gray": "Kahakahana ʻĀhiehie",
  "block.minecraft.banner.small_stripes.lime": "Kahakahana Laimi",
  "block.minecraft.banner.small_stripes.magenta": "Kahakahana ʻUlamākuʻe",
  "block.minecraft.banner.small_stripes.orange": "Kahakahana ʻAlani",
  "block.minecraft.banner.small_stripes.pink": "Kahakahana ʻĀkala",
  "block.minecraft.banner.small_stripes.purple": "Kahakahana Poni",
  "block.minecraft.banner.small_stripes.red": "Kahakahana ʻUlaʻula",
  "block.minecraft.banner.small_stripes.white": "Kahakahana Keʻokeʻo",
  "block.minecraft.banner.small_stripes.yellow": "Kahakahana Melemele",
  "block.minecraft.banner.square_bottom_left.black": "Kihi-i-ʻĀkau-ma-Lalo ʻEleʻele",
  "block.minecraft.banner.square_bottom_left.blue": "Kihi-i-ʻĀkau-ma-Lalo Uliuli",
  "block.minecraft.banner.square_bottom_left.brown": "Kihi-i-ʻĀkau-ma-Lalo Mākuʻe",
  "block.minecraft.banner.square_bottom_left.cyan": "Kihi-i-ʻĀkau-ma-Lalo Mamaʻo",
  "block.minecraft.banner.square_bottom_left.gray": "Kihi-i-ʻĀkau-ma-Lalo ʻĀhinahina",
  "block.minecraft.banner.square_bottom_left.green": "Kihi-i-ʻĀkau-ma-Lalo ʻŌmaʻomaʻo",
  "block.minecraft.banner.square_bottom_left.light_blue": "Kihi-i-ʻĀkau-ma-Lalo ʻUkiʻuki",
  "block.minecraft.banner.square_bottom_left.light_gray": "Kihi-i-ʻĀkau-ma-Lalo ʻĀhiehie",
  "block.minecraft.banner.square_bottom_left.lime": "Kihi-i-ʻĀkau-ma-Lalo Laimi",
  "block.minecraft.banner.square_bottom_left.magenta": "Kihi-i-ʻĀkau-ma-Lalo ʻUlamākuʻe",
  "block.minecraft.banner.square_bottom_left.orange": "Kihi-i-ʻĀkau-ma-Lalo ʻAlani",
  "block.minecraft.banner.square_bottom_left.pink": "Kihi-i-ʻĀkau-ma-Lalo ʻĀkala",
  "block.minecraft.banner.square_bottom_left.purple": "Kihi-i-ʻĀkau-ma-Lalo Poni",
  "block.minecraft.banner.square_bottom_left.red": "Kihi-i-ʻĀkau-ma-Lalo ʻUlaʻula",
  "block.minecraft.banner.square_bottom_left.white": "Kihi-i-ʻĀkau-ma-Lalo Keʻokeʻo",
  "block.minecraft.banner.square_bottom_left.yellow": "Kihi-i-ʻĀkau-ma-Lalo Melemele",
  "block.minecraft.banner.square_bottom_right.black": "Kihi-i-Lalo-Hema ʻEleʻele",
  "block.minecraft.banner.square_bottom_right.blue": "Kihi-i-Lalo-Hema Uliuli",
  "block.minecraft.banner.square_bottom_right.brown": "Kihi-i-Lalo-Hema Mākuʻe",
  "block.minecraft.banner.square_bottom_right.cyan": "Kihi-i-Lalo-Hema Mamaʻo",
  "block.minecraft.banner.square_bottom_right.gray": "Kihi-i-Lalo-Hema ʻĀhinahina",
  "block.minecraft.banner.square_bottom_right.green": "Kihi-i-Lalo-Hema ʻŌmaʻomaʻo",
  "block.minecraft.banner.square_bottom_right.light_blue": "Kihi-i-Lalo-Hema ʻUkiʻuki",
  "block.minecraft.banner.square_bottom_right.light_gray": "Kihi-i-Lalo-Hema ʻĀhiehie",
  "block.minecraft.banner.square_bottom_right.lime": "Kihi-i-Lalo-Hema Laimi",
  "block.minecraft.banner.square_bottom_right.magenta": "Kihi-i-Lalo-Hema ʻUlamākuʻe",
  "block.minecraft.banner.square_bottom_right.orange": "Kihi-i-Lalo-Hema ʻAlani",
  "block.minecraft.banner.square_bottom_right.pink": "Kihi-i-Lalo-Hema ʻĀkala",
  "block.minecraft.banner.square_bottom_right.purple": "Kihi-i-Lalo-Hema Poni",
  "block.minecraft.banner.square_bottom_right.red": "Kihi-i-Lalo-Hema ʻUlaʻula",
  "block.minecraft.banner.square_bottom_right.white": "Kihi-i-Lalo-Hema Keʻokeʻo",
  "block.minecraft.banner.square_bottom_right.yellow": "Kihi-i-Lalo-Hema Melemele",
  "block.minecraft.banner.square_top_left.black": "Kihi-i-ʻĀkau-ma-Luna ʻEleʻele",
  "block.minecraft.banner.square_top_left.blue": "Kihi-i-ʻĀkau-ma-Luna Uliuli",
  "block.minecraft.banner.square_top_left.brown": "Kihi-i-ʻĀkau-ma-Luna Mākuʻe",
  "block.minecraft.banner.square_top_left.cyan": "Kihi-i-ʻĀkau-ma-Luna Mamaʻo",
  "block.minecraft.banner.square_top_left.gray": "Kihi-i-ʻĀkau-ma-Luna ʻĀhinahina",
  "block.minecraft.banner.square_top_left.green": "Kihi-i-ʻĀkau-ma-Luna ʻŌmaʻomaʻo",
  "block.minecraft.banner.square_top_left.light_blue": "Kihi-i-ʻĀkau-ma-Luna ʻUkiʻuki",
  "block.minecraft.banner.square_top_left.light_gray": "Kihi-i-ʻĀkau-ma-Luna ʻĀhiehie",
  "block.minecraft.banner.square_top_left.lime": "Kihi-i-ʻĀkau-ma-Luna Laimi",
  "block.minecraft.banner.square_top_left.magenta": "Kihi-i-ʻĀkau-ma-Luna ʻUlamākuʻe",
  "block.minecraft.banner.square_top_left.orange": "Kihi-i-ʻĀkau-ma-Luna ʻAlani",
  "block.minecraft.banner.square_top_left.pink": "Kihi-i-ʻĀkau-ma-Luna ʻĀkala",
  "block.minecraft.banner.square_top_left.purple": "Kihi-i-ʻĀkau-ma-Luna Poni",
  "block.minecraft.banner.square_top_left.red": "Kihi-i-ʻĀkau-ma-Luna ʻUlaʻula",
  "block.minecraft.banner.square_top_left.white": "Kihi-i-ʻĀkau-ma-Luna Keʻokeʻo",
  "block.minecraft.banner.square_top_left.yellow": "Kihi-i-ʻĀkau-ma-Luna Melemele",
  "block.minecraft.banner.square_top_right.black": "Kihi-i-Luna-Hema ʻEleʻele",
  "block.minecraft.banner.square_top_right.blue": "Kihi-i-Luna-Hema Uliuli",
  "block.minecraft.banner.square_top_right.brown": "Kihi-i-Luna-Hema Mākuʻe",
  "block.minecraft.banner.square_top_right.cyan": "Kihi-i-Luna-Hema Mamaʻo",
  "block.minecraft.banner.square_top_right.gray": "Kihi-i-Luna-Hema ʻĀhinahina",
  "block.minecraft.banner.square_top_right.green": "Kihi-i-Luna-Hema ʻŌmaʻomaʻo",
  "block.minecraft.banner.square_top_right.light_blue": "Kihi-i-Luna-Hema ʻUkiʻuki",
  "block.minecraft.banner.square_top_right.light_gray": "Kihi-i-Luna-Hema ʻĀhiehie",
  "block.minecraft.banner.square_top_right.lime": "Kihi-i-Luna-Hema Laimi",
  "block.minecraft.banner.square_top_right.magenta": "Kihi-i-Luna-Hema ʻUlamākuʻe",
  "block.minecraft.banner.square_top_right.orange": "Kihi-i-Luna-Hema ʻAlani",
  "block.minecraft.banner.square_top_right.pink": "Kihi-i-Luna-Hema ʻĀkala",
  "block.minecraft.banner.square_top_right.purple": "Kihi-i-Luna-Hema Poni",
  "block.minecraft.banner.square_top_right.red": "Kihi-i-Luna-Hema ʻUlaʻula",
  "block.minecraft.banner.square_top_right.white": "Kihi-i-Luna-Hema Keʻokeʻo",
  "block.minecraft.banner.square_top_right.yellow": "Kihi-i-Luna-Hema Melemele",
  "block.minecraft.banner.straight_cross.black": "Keʻa ʻEleʻele",
  "block.minecraft.banner.straight_cross.blue": "Keʻa Uliuli",
  "block.minecraft.banner.straight_cross.brown": "Keʻa Mākuʻe",
  "block.minecraft.banner.straight_cross.cyan": "Keʻa Mamaʻo",
  "block.minecraft.banner.straight_cross.gray": "Keʻa ʻĀhinahina",
  "block.minecraft.banner.straight_cross.green": "Keʻa ʻŌmaʻomaʻo",
  "block.minecraft.banner.straight_cross.light_blue": "Keʻa ʻUkiʻuki",
  "block.minecraft.banner.straight_cross.light_gray": "Keʻa ʻĀhiehie",
  "block.minecraft.banner.straight_cross.lime": "Ke'a Laimi",
  "block.minecraft.banner.straight_cross.magenta": "Keʻa ʻUlamākuʻe",
  "block.minecraft.banner.straight_cross.orange": "Keʻa ʻAlani",
  "block.minecraft.banner.straight_cross.pink": "Keʻa ʻĀkala",
  "block.minecraft.banner.straight_cross.purple": "Keʻa Poni",
  "block.minecraft.banner.straight_cross.red": "Keʻa ʻUlaʻula",
  "block.minecraft.banner.straight_cross.white": "Keʻa Keʻokeʻo",
  "block.minecraft.banner.straight_cross.yellow": "Keʻa Melemele",
  "block.minecraft.banner.stripe_bottom.black": "Kahua ʻEleʻele",
  "block.minecraft.banner.stripe_bottom.blue": "Kahua Uliuli",
  "block.minecraft.banner.stripe_bottom.brown": "Kahua Mākuʻe",
  "block.minecraft.banner.stripe_bottom.cyan": "Kahua Mamaʻo",
  "block.minecraft.banner.stripe_bottom.gray": "Kahua ʻĀhinahina",
  "block.minecraft.banner.stripe_bottom.green": "Kahua ʻŌmaʻomaʻo",
  "block.minecraft.banner.stripe_bottom.light_blue": "Kahua ʻUkiʻuki",
  "block.minecraft.banner.stripe_bottom.light_gray": "Kahua ʻĀhiehie",
  "block.minecraft.banner.stripe_bottom.lime": "Kahua Laimi",
  "block.minecraft.banner.stripe_bottom.magenta": "Kahua ʻUlamākuʻe",
  "block.minecraft.banner.stripe_bottom.orange": "Kahua ʻAlani",
  "block.minecraft.banner.stripe_bottom.pink": "Kahua ʻĀkala",
  "block.minecraft.banner.stripe_bottom.purple": "Kahua Poni",
  "block.minecraft.banner.stripe_bottom.red": "Kahua ʻUlaʻula",
  "block.minecraft.banner.stripe_bottom.white": "Kahua Keʻokeʻo",
  "block.minecraft.banner.stripe_bottom.yellow": "Kahua Melemele",
  "block.minecraft.banner.stripe_center.black": "Kahawaena-Kū ʻEleʻele",
  "block.minecraft.banner.stripe_center.blue": "Kahawaena-Kū Uliuli",
  "block.minecraft.banner.stripe_center.brown": "Kahawaena-Kū Mākuʻe",
  "block.minecraft.banner.stripe_center.cyan": "Kahawaena-Kū Mamaʻo",
  "block.minecraft.banner.stripe_center.gray": "Kahawaena-Kū ʻĀhinahina",
  "block.minecraft.banner.stripe_center.green": "Kahawaena-Kū ʻŌmaʻomaʻo",
  "block.minecraft.banner.stripe_center.light_blue": "Kahawaena-Kū ʻUkiʻuki",
  "block.minecraft.banner.stripe_center.light_gray": "Kahawaena-Kū ʻĀhiehie",
  "block.minecraft.banner.stripe_center.lime": "Kahawaena-Kū Laimi",
  "block.minecraft.banner.stripe_center.magenta": "Kahawaena-Kū ʻUlamākuʻe",
  "block.minecraft.banner.stripe_center.orange": "Kahawaena-Kū ʻAlani",
  "block.minecraft.banner.stripe_center.pink": "Kahawaena-Kū ʻĀkala",
  "block.minecraft.banner.stripe_center.purple": "Kahawaena-Kū Poni",
  "block.minecraft.banner.stripe_center.red": "Kahawaena-Kū ʻUlaʻula",
  "block.minecraft.banner.stripe_center.white": "Kahawaena-Kū Keʻokeʻo",
  "block.minecraft.banner.stripe_center.yellow": "Kahawaena-Kū Melemele",
  "block.minecraft.banner.stripe_downleft.black": "Kahalala-Hema ʻEleʻele",
  "block.minecraft.banner.stripe_downleft.blue": "Kahalala-Hema Uliuli",
  "block.minecraft.banner.stripe_downleft.brown": "Kahalala-Hema Mākuʻe",
  "block.minecraft.banner.stripe_downleft.cyan": "Kahalala-Hema Mamaʻo",
  "block.minecraft.banner.stripe_downleft.gray": "Kahalala-Hema ʻĀhinahina",
  "block.minecraft.banner.stripe_downleft.green": "Kahalala-Hema ʻŌmaʻomaʻo",
  "block.minecraft.banner.stripe_downleft.light_blue": "Kahalala-Hema ʻUkiʻuki",
  "block.minecraft.banner.stripe_downleft.light_gray": "Kahalala-Hema ʻĀhiehie",
  "block.minecraft.banner.stripe_downleft.lime": "Kahalala-Hema Laimi",
  "block.minecraft.banner.stripe_downleft.magenta": "Kahalala-Hema ʻUlamākuʻe",
  "block.minecraft.banner.stripe_downleft.orange": "Kahalala-Hema ʻAlani",
  "block.minecraft.banner.stripe_downleft.pink": "Kahalala-Hema ʻĀkala",
  "block.minecraft.banner.stripe_downleft.purple": "Kahalala-Hema Poni",
  "block.minecraft.banner.stripe_downleft.red": "Kahalala-Hema ʻUlaʻula",
  "block.minecraft.banner.stripe_downleft.white": "Kahalala-Hema Keʻokeʻo",
  "block.minecraft.banner.stripe_downleft.yellow": "Kahalala-Hema Melemele",
  "block.minecraft.banner.stripe_downright.black": "Kahalala ʻEleʻele",
  "block.minecraft.banner.stripe_downright.blue": "Kahalala Uliuli",
  "block.minecraft.banner.stripe_downright.brown": "Kahalala Mākue",
  "block.minecraft.banner.stripe_downright.cyan": "Kahalala Mamaʻo",
  "block.minecraft.banner.stripe_downright.gray": "Kahalala ʻĀhinahina",
  "block.minecraft.banner.stripe_downright.green": "Kahalala ʻŌmaʻomaʻo",
  "block.minecraft.banner.stripe_downright.light_blue": "Kahalala ʻUkiʻuki",
  "block.minecraft.banner.stripe_downright.light_gray": "Kahalala ʻĀhiehie",
  "block.minecraft.banner.stripe_downright.lime": "Kahalala Laimi",
  "block.minecraft.banner.stripe_downright.magenta": "Kahalala ʻUlamākuʻe",
  "block.minecraft.banner.stripe_downright.orange": "Kahalala ʻAlani",
  "block.minecraft.banner.stripe_downright.pink": "Kahalala ʻĀkala",
  "block.minecraft.banner.stripe_downright.purple": "Kahalala Poni",
  "block.minecraft.banner.stripe_downright.red": "Kahalala ʻUlaʻula",
  "block.minecraft.banner.stripe_downright.white": "Kahalala Keʻokeʻo",
  "block.minecraft.banner.stripe_downright.yellow": "Kahalala Melemele",
  "block.minecraft.banner.stripe_left.black": "Kaha-ʻĀkau-Kū ʻEleʻele",
  "block.minecraft.banner.stripe_left.blue": "Kaha-ʻĀkau-Kū Uliuli",
  "block.minecraft.banner.stripe_left.brown": "Kaha-ʻĀkau-Kū Mākuʻe",
  "block.minecraft.banner.stripe_left.cyan": "Kaha-ʻĀkau-Kū Mamaʻo",
  "block.minecraft.banner.stripe_left.gray": "Kaha-ʻĀkau-Kū ʻĀhinahina",
  "block.minecraft.banner.stripe_left.green": "Kaha-ʻĀkau-Kū ʻŌmaʻomaʻo",
  "block.minecraft.banner.stripe_left.light_blue": "Kaha-ʻĀkau-Kū ʻUkiʻuki",
  "block.minecraft.banner.stripe_left.light_gray": "Kaha-ʻĀkau-Kū ʻĀhiehie",
  "block.minecraft.banner.stripe_left.lime": "Kaha-ʻĀkau-Kū Laimi",
  "block.minecraft.banner.stripe_left.magenta": "Kaha-ʻĀkau-Kū ʻUlamākuʻe",
  "block.minecraft.banner.stripe_left.orange": "Kaha-ʻĀkau-Kū ʻAlani",
  "block.minecraft.banner.stripe_left.pink": "Kaha-ʻĀkau-Kū ʻĀkala",
  "block.minecraft.banner.stripe_left.purple": "Kaha-ʻĀkau-Kū Poni",
  "block.minecraft.banner.stripe_left.red": "Kaha-ʻĀkau-Kū ʻUlaʻula",
  "block.minecraft.banner.stripe_left.white": "Kaha-ʻĀkau-Kū Keʻokeʻo",
  "block.minecraft.banner.stripe_left.yellow": "Kaha-ʻĀkau-Kū Melemele",
  "block.minecraft.banner.stripe_middle.black": "Kaha ʻEleʻele",
  "block.minecraft.banner.stripe_middle.blue": "Kaha Uliuli",
  "block.minecraft.banner.stripe_middle.brown": "Kaha Mākuʻe",
  "block.minecraft.banner.stripe_middle.cyan": "Kaha Mamaʻo",
  "block.minecraft.banner.stripe_middle.gray": "Kaha ʻĀhinahina",
  "block.minecraft.banner.stripe_middle.green": "Kaha ʻŌmaʻomaʻo",
  "block.minecraft.banner.stripe_middle.light_blue": "Kaha ʻUkiʻuki",
  "block.minecraft.banner.stripe_middle.light_gray": "Kaha ʻĀhiehie",
  "block.minecraft.banner.stripe_middle.lime": "Kaha Laimi",
  "block.minecraft.banner.stripe_middle.magenta": "Kaha ʻUlamākuʻe",
  "block.minecraft.banner.stripe_middle.orange": "Kaha ʻAlani",
  "block.minecraft.banner.stripe_middle.pink": "Kaha ʻĀkala",
  "block.minecraft.banner.stripe_middle.purple": "Kaha Poni",
  "block.minecraft.banner.stripe_middle.red": "Kaha ʻUlaʻula",
  "block.minecraft.banner.stripe_middle.white": "Kaha Keʻokeʻo",
  "block.minecraft.banner.stripe_middle.yellow": "Kaha Melemele",
  "block.minecraft.banner.stripe_right.black": "Kaha-Hema-Kū ʻEleʻele",
  "block.minecraft.banner.stripe_right.blue": "Kaha-Hema-Kū Uliuli",
  "block.minecraft.banner.stripe_right.brown": "Kaha-Hema-Kū Mākuʻe",
  "block.minecraft.banner.stripe_right.cyan": "Kaha-Hema-Kū Mamaʻo",
  "block.minecraft.banner.stripe_right.gray": "Kaha-Hema-Kū ʻĀhinahina",
  "block.minecraft.banner.stripe_right.green": "Kaha-Hema-Kū ʻŌmaʻomaʻo",
  "block.minecraft.banner.stripe_right.light_blue": "Kaha-Hema-Kū ʻUkiʻuki",
  "block.minecraft.banner.stripe_right.light_gray": "Kaha-Hema-Kū ʻĀhiehie",
  "block.minecraft.banner.stripe_right.lime": "Kaha-Hema-Kū Laimi",
  "block.minecraft.banner.stripe_right.magenta": "Kaha-Hema-Kū ʻUlamākuʻe",
  "block.minecraft.banner.stripe_right.orange": "Kaha-Hema-Kū ʻAlani",
  "block.minecraft.banner.stripe_right.pink": "Kaha-Hema-Kū ʻĀkala",
  "block.minecraft.banner.stripe_right.purple": "Kaha-Hema-Kū Poni",
  "block.minecraft.banner.stripe_right.red": "Kaha-Hema-Kū ʻUlaʻula",
  "block.minecraft.banner.stripe_right.white": "Kaha-Hema-Kū Keʻokeʻo",
  "block.minecraft.banner.stripe_right.yellow": "Kaha-Hema-Kū Melemele",
  "block.minecraft.banner.stripe_top.black": "Pane ʻEleʻele",
  "block.minecraft.banner.stripe_top.blue": "Pane Uliuli",
  "block.minecraft.banner.stripe_top.brown": "Pane Mākuʻe",
  "block.minecraft.banner.stripe_top.cyan": "Pane Mamaʻo",
  "block.minecraft.banner.stripe_top.gray": "Pane ʻĀhinahina",
  "block.minecraft.banner.stripe_top.green": "Pane ʻŌmaʻomaʻo",
  "block.minecraft.banner.stripe_top.light_blue": "Pane ʻUkiʻuki",
  "block.minecraft.banner.stripe_top.light_gray": "Pane ʻĀhiehie",
  "block.minecraft.banner.stripe_top.lime": "Pane Laimi",
  "block.minecraft.banner.stripe_top.magenta": "Pane ʻUlamākuʻe",
  "block.minecraft.banner.stripe_top.orange": "Pane ʻAlani",
  "block.minecraft.banner.stripe_top.pink": "Pane ʻĀkala",
  "block.minecraft.banner.stripe_top.purple": "Pane Poni",
  "block.minecraft.banner.stripe_top.red": "Pane ʻUlaʻula",
  "block.minecraft.banner.stripe_top.white": "Pane Keʻokeʻo",
  "block.minecraft.banner.stripe_top.yellow": "Pane Melemele",
  "block.minecraft.banner.triangle_bottom.black": "Mauna ʻEleʻele",
  "block.minecraft.banner.triangle_bottom.blue": "Mauna Uliuli",
  "block.minecraft.banner.triangle_bottom.brown": "Mauna Mākuʻe",
  "block.minecraft.banner.triangle_bottom.cyan": "Mauna Mamaʻo",
  "block.minecraft.banner.triangle_bottom.gray": "Mauna ʻĀhinahina",
  "block.minecraft.banner.triangle_bottom.green": "Mauna ʻŌmaʻomaʻo",
  "block.minecraft.banner.triangle_bottom.light_blue": "Mauna ʻUkiuki",
  "block.minecraft.banner.triangle_bottom.light_gray": "Mauna ʻĀhiehie",
  "block.minecraft.banner.triangle_bottom.lime": "Mauna Laimi",
  "block.minecraft.banner.triangle_bottom.magenta": "Mauna ʻUlamākuʻe",
  "block.minecraft.banner.triangle_bottom.orange": "Mauna ʻAlani",
  "block.minecraft.banner.triangle_bottom.pink": "Mauna ʻĀkala",
  "block.minecraft.banner.triangle_bottom.purple": "Mauna Poni",
  "block.minecraft.banner.triangle_bottom.red": "Mauna ʻUlaʻula",
  "block.minecraft.banner.triangle_bottom.white": "Mauna Keʻokeʻo",
  "block.minecraft.banner.triangle_bottom.yellow": "Mauna Melemele",
  "block.minecraft.banner.triangle_top.black": "Niho ʻEleʻele",
  "block.minecraft.banner.triangle_top.blue": "Niho Uliuli",
  "block.minecraft.banner.triangle_top.brown": "Niho Mākuʻe",
  "block.minecraft.banner.triangle_top.cyan": "Niho Mamaʻo",
  "block.minecraft.banner.triangle_top.gray": "Niho ʻĀhinahina",
  "block.minecraft.banner.triangle_top.green": "Niho ʻŌmaʻomaʻo",
  "block.minecraft.banner.triangle_top.light_blue": "Niho ʻUkiʻuki",
  "block.minecraft.banner.triangle_top.light_gray": "Niho ʻĀhiehie",
  "block.minecraft.banner.triangle_top.lime": "Niho Laimi",
  "block.minecraft.banner.triangle_top.magenta": "Niho ʻUlamākuʻe",
  "block.minecraft.banner.triangle_top.orange": "Niho ʻAlani",
  "block.minecraft.banner.triangle_top.pink": "Niho ʻĀkala",
  "block.minecraft.banner.triangle_top.purple": "Niho Poni",
  "block.minecraft.banner.triangle_top.red": "Niho ʻUlaʻula",
  "block.minecraft.banner.triangle_top.white": "Niho Keʻokeʻo",
  "block.minecraft.banner.triangle_top.yellow": "Niho Melemele",
  "block.minecraft.banner.triangles_bottom.black": "Nihoniho-o-Lalo ʻEleʻele",
  "block.minecraft.banner.triangles_bottom.blue": "Nihoniho-o-Lalo Uliuli",
  "block.minecraft.banner.triangles_bottom.brown": "Nihoniho-o-Lalo Mākuʻe",
  "block.minecraft.banner.triangles_bottom.cyan": "Nihoniho-o-Lalo Mamaʻo",
  "block.minecraft.banner.triangles_bottom.gray": "Nihoniho-o-Lalo ʻĀhinahina",
  "block.minecraft.banner.triangles_bottom.green": "Nihoniho-o-Lalo ʻŌmaʻomaʻo",
  "block.minecraft.banner.triangles_bottom.light_blue": "Nihoniho-o-Lalo ʻUkiʻuki",
  "block.minecraft.banner.triangles_bottom.light_gray": "Nihoniho-o-Lalo ʻĀhiehie",
  "block.minecraft.banner.triangles_bottom.lime": "Nihoniho-o-Lalo Laimi",
  "block.minecraft.banner.triangles_bottom.magenta": "Nihoniho-o-Lalo ʻUlamākuʻe",
  "block.minecraft.banner.triangles_bottom.orange": "Nihoniho-o-Lalo ʻAlani",
  "block.minecraft.banner.triangles_bottom.pink": "Nihoniho-o-Lalo ʻĀkala",
  "block.minecraft.banner.triangles_bottom.purple": "Nihoniho-o-Lalo Poni",
  "block.minecraft.banner.triangles_bottom.red": "Nihoniho-o-Lalo ʻUlaʻula",
  "block.minecraft.banner.triangles_bottom.white": "Nihoniho-o-Lalo Keʻokeʻo",
  "block.minecraft.banner.triangles_bottom.yellow": "Nihoniho-o-Lalo Melemele",
  "block.minecraft.banner.triangles_top.black": "Nihoniho-o-Luna ʻEleʻele",
  "block.minecraft.banner.triangles_top.blue": "Nihoniho-o-Luna Uliuli",
  "block.minecraft.banner.triangles_top.brown": "Nihoniho-o-Luna Mākuʻe",
  "block.minecraft.banner.triangles_top.cyan": "Nihoniho-o-Luna Mamaʻo",
  "block.minecraft.banner.triangles_top.gray": "Nihoniho-o-Luna ʻĀhinahina",
  "block.minecraft.banner.triangles_top.green": "Nihoniho-o-Luna ʻŌmaʻomaʻo",
  "block.minecraft.banner.triangles_top.light_blue": "Nihoniho-o-Luna ʻUkiʻuki",
  "block.minecraft.banner.triangles_top.light_gray": "Nihoniho-o-Luna ʻĀhiehie",
  "block.minecraft.banner.triangles_top.lime": "Nihoniho-o-Luna Laimi",
  "block.minecraft.banner.triangles_top.magenta": "Nihoniho-o-Luna ʻUlamākuʻe",
  "block.minecraft.banner.triangles_top.orange": "Nihoniho-o-Luna ʻAlani",
  "block.minecraft.banner.triangles_top.pink": "Nihoniho-o-Luna ʻĀkala",
  "block.minecraft.banner.triangles_top.purple": "Nihoniho-o-Luna Poni",
  "block.minecraft.banner.triangles_top.red": "Nihoniho-o-Luna ʻUlaʻula",
  "block.minecraft.banner.triangles_top.white": "Nihoniho-o-Luna Keʻokeʻo",
  "block.minecraft.banner.triangles_top.yellow": "Nihoniho-o-Luna Melemele",
  "block.minecraft.barrel": "Palela",
  "block.minecraft.barrier": "Kaupale",
  "block.minecraft.basalt": "Pōhaku-Paʻa",
  "block.minecraft.beacon": "Lama Kuhikuhi",
  "block.minecraft.beacon.primary": "Mana Mua",
  "block.minecraft.beacon.secondary": "Mana Lua",
  "block.minecraft.bed.no_sleep": "Hiamoe i loko o ka pō a i loko o ka ʻinoʻino",
  "block.minecraft.bed.not_safe": "ʻAʻole hiki ke moe i kēia manawa; aia nō he mau pilikua kokoke",
  "block.minecraft.bed.obstructed": "Ālai ʻia kēia moena",
  "block.minecraft.bed.occupied": "Noho ʻia kēia moena",
  "block.minecraft.bed.too_far_away": "ʻAʻole hiki ke moe i kēia manawa; he keu a mamao ka moena",
  "block.minecraft.bedrock": "Kūpapakū",
  "block.minecraft.bee_nest": "Pūnana Nalomeli",
  "block.minecraft.beehive": "Pahumeli",
  "block.minecraft.beetroots": "Mole Pike",
  "block.minecraft.bell": "Pele",
  "block.minecraft.big_dripleaf": "Lau-luhe Nui",
  "block.minecraft.big_dripleaf_stem": "Iwi Lau-luhe Nui",
  "block.minecraft.birch_button": "Pihi Pūkowi",
  "block.minecraft.birch_door": "ʻĪpuka Pūkowi",
  "block.minecraft.birch_fence": "Pālāʻau Pūkowi",
  "block.minecraft.birch_fence_gate": "ʻĪpuka Pālāʻau Pūkowi",
  "block.minecraft.birch_hanging_sign": "Papa Hōʻike Pūkowi Kaulia",
  "block.minecraft.birch_leaves": "Lau Pūkowi",
  "block.minecraft.birch_log": "Kualā'au Pūkowi",
  "block.minecraft.birch_planks": "Papalāʻau Pūkowi",
  "block.minecraft.birch_pressure_plate": "Papa Kaumaha Pūkowi",
  "block.minecraft.birch_sapling": "Pūkowi ʻŌpiopio",
  "block.minecraft.birch_shelf": "Hakakau Pūkowi",
  "block.minecraft.birch_sign": "Papa Hōʻike Pūkowi",
  "block.minecraft.birch_slab": "Paukū Pūkowi",
  "block.minecraft.birch_stairs": "Alapiʻi Pūkowi",
  "block.minecraft.birch_trapdoor": "ʻĪpuka ʻŪmiʻi Pūkowi",
  "block.minecraft.birch_wall_hanging_sign": "Papa Hōʻike Pūkowi Kūlewa",
  "block.minecraft.birch_wall_sign": "Papa Hōʻike Pūkowi Pili Paia",
  "block.minecraft.birch_wood": "Lāʻau Pūkowi",
  "block.minecraft.black_banner": "Lepa ʻEleʻele",
  "block.minecraft.black_bed": "Moena ʻEleʻele",
  "block.minecraft.black_candle": "Ihoiho ʻEleʻele",
  "block.minecraft.black_candle_cake": "Meaʻono me Ihoiho ʻEleʻele",
  "block.minecraft.black_carpet": "Kāpeka ʻEleʻele",
  "block.minecraft.black_concrete": "Kimeki ʻEleʻele",
  "block.minecraft.black_concrete_powder": "Pauka Kimeki ʻEleʻele",
  "block.minecraft.black_glazed_terracotta": "Pālolo ʻEleʻele ʻIliki ʻia",
  "block.minecraft.black_shulker_box": "Pahu-o-ke-Shulker ʻEleʻele",
  "block.minecraft.black_stained_glass": "Aniani Luaʻehu ʻEleʻele",
  "block.minecraft.black_stained_glass_pane": "ʻĀpana Aniani Luaʻehu ʻEleʻele",
  "block.minecraft.black_terracotta": "Pālolo ʻEleʻele",
  "block.minecraft.black_wool": "Huluhipa ʻEleʻele",
  "block.minecraft.blackstone": "Pāhoehoe",
  "block.minecraft.blackstone_slab": "Paukū Pāhoehoe",
  "block.minecraft.blackstone_stairs": "Alapiʻi Pāhoehoe",
  "block.minecraft.blackstone_wall": "Pā Pāhoehoe",
  "block.minecraft.blast_furnace": "Umu Hoʻoheheʻe Hao",
  "block.minecraft.blue_banner": "Lepa Uliuli",
  "block.minecraft.blue_bed": "Moena Uliuli",
  "block.minecraft.blue_candle": "Ihoiho Uliuli",
  "block.minecraft.blue_candle_cake": "Meaʻono me Ihoiho Uliuli",
  "block.minecraft.blue_carpet": "Kāpeka Uliuli",
  "block.minecraft.blue_concrete": "Kimeki Uliuli",
  "block.minecraft.blue_concrete_powder": "Pauka Kimeki Uliuli",
  "block.minecraft.blue_glazed_terracotta": "Pālolo Uliuli ʻIliki ʻia",
  "block.minecraft.blue_ice": "Hauʻoki Uliuli",
  "block.minecraft.blue_orchid": "ʻOkika Uliuli",
  "block.minecraft.blue_shulker_box": "Pahu-o-ke-Shulker Uliuli",
  "block.minecraft.blue_stained_glass": "Aniani Luaʻehu Uliuli",
  "block.minecraft.blue_stained_glass_pane": "ʻĀpana Aniani Luaʻehu Uliuli",
  "block.minecraft.blue_terracotta": "Pālolo Uliuli",
  "block.minecraft.blue_wool": "Huluhipa Uliuli",
  "block.minecraft.bone_block": "Palaka Iwi",
  "block.minecraft.bookshelf": "Hakakaupuke",
  "block.minecraft.brain_coral": "Puna",
  "block.minecraft.brain_coral_block": "Palaka Puna",
  "block.minecraft.brain_coral_fan": "Mākoʻa Puna",
  "block.minecraft.brain_coral_wall_fan": "Mākoʻa Puna",
  "block.minecraft.brewing_stand": "Kūleʻa",
  "block.minecraft.brick_slab": "Paukū Pōhakulepo",
  "block.minecraft.brick_stairs": "Alapiʻi Pōhakulepo",
  "block.minecraft.brick_wall": "Pā Pōhakuʻula",
  "block.minecraft.bricks": "Palaka Pōhakulepo",
  "block.minecraft.brown_banner": "Lepa Mākuʻe",
  "block.minecraft.brown_bed": "Moena Mākuʻe",
  "block.minecraft.brown_candle": "Ihoiho Mākuʻe",
  "block.minecraft.brown_candle_cake": "Meaʻono me Ihoiho Mākuʻe",
  "block.minecraft.brown_carpet": "Kāpeka Mākuʻe",
  "block.minecraft.brown_concrete": "Kimeki Mākuʻe",
  "block.minecraft.brown_concrete_powder": "Pauka Kimeki Mākuʻe",
  "block.minecraft.brown_glazed_terracotta": "Pālolo Mākuʻe ʻIliki ʻia",
  "block.minecraft.brown_mushroom": "Melehune Mākuʻe",
  "block.minecraft.brown_mushroom_block": "Palaka Melehune Mākuʻe",
  "block.minecraft.brown_shulker_box": "Pahu-o-ke-Shulker Mākuʻe",
  "block.minecraft.brown_stained_glass": "Aniani Luaʻehu Mākuʻe",
  "block.minecraft.brown_stained_glass_pane": "ʻĀpana Aniani Luaʻehu Mākuʻe",
  "block.minecraft.brown_terracotta": "Pālolo Mākuʻe",
  "block.minecraft.brown_wool": "Huluhipa Mākuʻe",
  "block.minecraft.bubble_column": "Kālamu maha",
  "block.minecraft.bubble_coral": "Koʻakoʻa Huʻa",
  "block.minecraft.bubble_coral_block": "Palaka Koʻakoʻa Huʻa",
  "block.minecraft.bubble_coral_fan": "Mākoʻa Huʻa",
  "block.minecraft.bubble_coral_wall_fan": "Mākoʻa Huʻa",
  "block.minecraft.budding_amethyst": "ʻAmeki Hāliko",
  "block.minecraft.bush": "Laʻalāʻau",
  "block.minecraft.cactus": "Pānini",
  "block.minecraft.cactus_flower": "Pua Pānini",
  "block.minecraft.cake": "Meaʻono",
  "block.minecraft.calcite": "Puna",
  "block.minecraft.calibrated_sculk_sensor": "ʻIke-o-ka-Sculk Mākaukau",
  "block.minecraft.campfire": "Luaahi",
  "block.minecraft.candle": "Ihoiho",
  "block.minecraft.candle_cake": "Meaʻono me Ihoiho",
  "block.minecraft.carrots": "Kāloke",
  "block.minecraft.cartography_table": "Papa Kaha Palapalaʻāina",
  "block.minecraft.carved_pumpkin": "Palaʻai Kālaia",
  "block.minecraft.cauldron": "Ipuhao",
  "block.minecraft.cave_air": "Ea Ana",
  "block.minecraft.cave_vines": "Lāʻau-hihī Ana",
  "block.minecraft.cave_vines_plant": "Mea Lāʻau-hihī Ana",
  "block.minecraft.chain": "Kaula",
  "block.minecraft.chain_command_block": "Palaka Kauoha Kuʻina",
  "block.minecraft.cherry_button": "Pihi Keli",
  "block.minecraft.cherry_door": "ʻĪpuka Keli",
  "block.minecraft.cherry_fence": "Pālāʻau Keli",
  "block.minecraft.cherry_fence_gate": "ʻĪpuka Pālāʻau Keli",
  "block.minecraft.cherry_hanging_sign": "Papa Hōʻike Keli Kaulia",
  "block.minecraft.cherry_leaves": "Lau Keli",
  "block.minecraft.cherry_log": "Kualāʻau Keli",
  "block.minecraft.cherry_planks": "Papalāʻau Keli",
  "block.minecraft.cherry_pressure_plate": "Papa Kaumaha Keli",
  "block.minecraft.cherry_sapling": "Keli ʻŌpiopio",
  "block.minecraft.cherry_shelf": "Hakakau Keli",
  "block.minecraft.cherry_sign": "Papa Hōʻike Keli",
  "block.minecraft.cherry_slab": "Paukū Keli",
  "block.minecraft.cherry_stairs": "Alapiʻi Keli",
  "block.minecraft.cherry_trapdoor": "ʻĪpuka ʻŪmiʻi Keli",
  "block.minecraft.cherry_wall_hanging_sign": "Papa Hōʻike Keli Kūlewa",
  "block.minecraft.cherry_wall_sign": "Papa Hōʻike Keli Pili Paia",
  "block.minecraft.cherry_wood": "Lāʻau Keli",
  "block.minecraft.chest": "Pahu",
  "block.minecraft.chipped_anvil": "Kua Hao Waluhia",
  "block.minecraft.chiseled_bookshelf": "Hakakaupuke Kālaia",
  "block.minecraft.chiseled_copper": "Keleawe Kālaia",
  "block.minecraft.chiseled_deepslate": "Pōhakuhonu Kālaia",
  "block.minecraft.chiseled_nether_bricks": "Pōhakulepo-o-ka-Nether Kālaia",
  "block.minecraft.chiseled_polished_blackstone": "Pāhoehoe Hinua Kālaia",
  "block.minecraft.chiseled_quartz_block": "Palaka Pōhakuaʻiaʻi Kālaia",
  "block.minecraft.chiseled_red_sandstone": "Kumuone Maʻalaea Kālaia",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "Kumuone Kālaia",
  "block.minecraft.chiseled_stone_bricks": "Hakulepo Kālaia",
  "block.minecraft.chiseled_tuff": "Pōhakuhune Kālaia",
  "block.minecraft.chiseled_tuff_bricks": "Pōhakuhune Lepo Kālaia",
  "block.minecraft.chorus_flower": "Pua-o-ka-Hui",
  "block.minecraft.chorus_plant": "Kanu-o-ka-Hui",
  "block.minecraft.clay": "Lepo Kāwili",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Palaka Lānahu",
  "block.minecraft.coal_ore": "Pōhaku Lānahu",
  "block.minecraft.coarse_dirt": "Lepo Mānoanoa",
  "block.minecraft.cobbled_deepslate": "Pōhakuhonu ʻIliʻili",
  "block.minecraft.cobbled_deepslate_slab": "Paukū Pōhakuhonu ʻIliʻili",
  "block.minecraft.cobbled_deepslate_stairs": "Alapiʻi Pōhakuhonu ʻIliʻili",
  "block.minecraft.cobbled_deepslate_wall": "Pā Pōhakuhonu ʻIliʻili",
  "block.minecraft.cobblestone": "Pōhaku ʻIliʻili",
  "block.minecraft.cobblestone_slab": "Paukū Pōhaku ʻIliʻili",
  "block.minecraft.cobblestone_stairs": "Alapiʻi Pōhaku ʻIliʻili",
  "block.minecraft.cobblestone_wall": "Pā Pōhaku ʻIliʻili",
  "block.minecraft.cobweb": "Pūnāwelewele",
  "block.minecraft.cocoa": "Kōkō",
  "block.minecraft.command_block": "Palaka Kauoha",
  "block.minecraft.comparator": "Ana Uila o Redstone",
  "block.minecraft.composter": "Hana Kīpulu",
  "block.minecraft.conduit": "Pāpū",
  "block.minecraft.copper_bars": "Kaola Keleawe",
  "block.minecraft.copper_block": "Palaka Keleawe",
  "block.minecraft.copper_bulb": "ʻŌpuʻu Keleawe",
  "block.minecraft.copper_chain": "Kaula Keleawe",
  "block.minecraft.copper_chest": "Pahu Keleawe",
  "block.minecraft.copper_door": "ʻĪpuka Keleawe",
  "block.minecraft.copper_golem_statue": "Kiʻi Akua-nuʻa Keleawe",
  "block.minecraft.copper_grate": "Haomanamana Keleawe",
  "block.minecraft.copper_lantern": "Ipukukui Keleawe",
  "block.minecraft.copper_ore": "Pōhaku Keleawe",
  "block.minecraft.copper_torch": "Pūlama Keleawe",
  "block.minecraft.copper_trapdoor": "ʻĪpuka ʻŪmiʻi Keleawe",
  "block.minecraft.copper_wall_torch": "Pūlama Pā Keleawe",
  "block.minecraft.cornflower": "ʻĀwiwi Uliuli",
  "block.minecraft.cracked_deepslate_bricks": "Pōhakuhonu-lepo Nahā",
  "block.minecraft.cracked_deepslate_tiles": "Kile Pōhakuhonu Nahā",
  "block.minecraft.cracked_nether_bricks": "Pōhakulepo-o-ka-Nether Nahā",
  "block.minecraft.cracked_polished_blackstone_bricks": "Pōhakulepo Pāhoehoe Hinua Nahā",
  "block.minecraft.cracked_stone_bricks": "Hakulepo Nahā",
  "block.minecraft.crafter": "Mea Hanalima",
  "block.minecraft.crafting_table": "Papa Hanalima",
  "block.minecraft.creaking_heart": "Puʻuwai-o-ka-Manunu",
  "block.minecraft.creeper_head": "Poʻo ʻAno Creeper",
  "block.minecraft.creeper_wall_head": "Pā Poʻo Creeper",
  "block.minecraft.crimson_button": "Pihi Pūkoko",
  "block.minecraft.crimson_door": "ʻĪpuka Pūkoko",
  "block.minecraft.crimson_fence": "Pā Pūkoko",
  "block.minecraft.crimson_fence_gate": "ʻĪpuka Pā Pūkoko",
  "block.minecraft.crimson_fungus": "Kalina Pūkoko",
  "block.minecraft.crimson_hanging_sign": "Papa Hōʻike Pūkoko Kaulia",
  "block.minecraft.crimson_hyphae": "Maʻawe Pūkoko",
  "block.minecraft.crimson_nylium": "Hakuʻula",
  "block.minecraft.crimson_planks": "Papalāʻau Pūkoko",
  "block.minecraft.crimson_pressure_plate": "Papa Kaumaha Pūkoko",
  "block.minecraft.crimson_roots": "Maʻalewa Pūkoko",
  "block.minecraft.crimson_shelf": "Hakakau Pūkoko",
  "block.minecraft.crimson_sign": "Papa Hōʻike Pūkoko",
  "block.minecraft.crimson_slab": "Paukū Pūkoko",
  "block.minecraft.crimson_stairs": "Alapiʻi Pūkoko",
  "block.minecraft.crimson_stem": "Hā Pūkoko",
  "block.minecraft.crimson_trapdoor": "ʻĪpuka ʻŪmiʻi Pūkoko",
  "block.minecraft.crimson_wall_hanging_sign": "Papa Hōʻike Pūkoko Kūlewa",
  "block.minecraft.crimson_wall_sign": "Papa Hōʻike Pūkoko Pili Paia",
  "block.minecraft.crying_obsidian": "Mākā Makena",
  "block.minecraft.cut_copper": "Keleawe ʻŌpaka",
  "block.minecraft.cut_copper_slab": "Paukū Keleawe ʻŌpaka",
  "block.minecraft.cut_copper_stairs": "Alapiʻi Keleawe ʻŌpaka",
  "block.minecraft.cut_red_sandstone": "Kumuone Maʻalaea ʻŌpaka",
  "block.minecraft.cut_red_sandstone_slab": "Kumuone Maʻalaea",
  "block.minecraft.cut_sandstone": "Kumuone ʻŌpaka",
  "block.minecraft.cut_sandstone_slab": "Paukū Kumuone ʻŌpaka",
  "block.minecraft.cyan_banner": "Lepa Mamaʻo",
  "block.minecraft.cyan_bed": "Moekū Mamaʻo",
  "block.minecraft.cyan_candle": "Ihoiho Mamaʻo",
  "block.minecraft.cyan_candle_cake": "Meaʻono me Ihoiho Mamaʻo",
  "block.minecraft.cyan_carpet": "Kāpeka Mamaʻo",
  "block.minecraft.cyan_concrete": "Kimeki Mamaʻo",
  "block.minecraft.cyan_concrete_powder": "Pauka Kimeki Mamaʻo",
  "block.minecraft.cyan_glazed_terracotta": "Pālolo Mamaʻo ʻIliki ʻia",
  "block.minecraft.cyan_shulker_box": "Pahu-o-ka-Shulker Mamaʻo",
  "block.minecraft.cyan_stained_glass": "Aniani Luaʻehu Mamaʻo",
  "block.minecraft.cyan_stained_glass_pane": "ʻĀpana Aniani Luaʻehu Mamaʻo",
  "block.minecraft.cyan_terracotta": "Pālolo Mamaʻo",
  "block.minecraft.cyan_wool": "Huluhipa Mamaʻo",
  "block.minecraft.damaged_anvil": "Kua Hao Manuheʻu",
  "block.minecraft.dandelion": "Laulele",
  "block.minecraft.dark_oak_button": "Pihi ʻOka ʻElemoe",
  "block.minecraft.dark_oak_door": "ʻĪpuka ʻOka ʻElemoe",
  "block.minecraft.dark_oak_fence": "Pālāʻau ʻOka ʻElemoe",
  "block.minecraft.dark_oak_fence_gate": "ʻĪpuka Pālāʻau ʻOka ʻElemoe",
  "block.minecraft.dark_oak_hanging_sign": "Papa Hōʻike ʻOka ʻElemoe Kaulia",
  "block.minecraft.dark_oak_leaves": "Lau ʻOka ʻElemoe",
  "block.minecraft.dark_oak_log": "Kualāʻau ʻOka ʻElemoe",
  "block.minecraft.dark_oak_planks": "Papalāʻau ʻOka ʻElemoe",
  "block.minecraft.dark_oak_pressure_plate": "Papa Kaumaha ʻOka ʻElemoe",
  "block.minecraft.dark_oak_sapling": "ʻOka ʻElemoe ʻŌpiopio",
  "block.minecraft.dark_oak_shelf": "Hakakau ʻOka ʻElemoe",
  "block.minecraft.dark_oak_sign": "Papa Hōʻike ʻOka ʻElemoe",
  "block.minecraft.dark_oak_slab": "Paukū ʻOka ʻElemoe",
  "block.minecraft.dark_oak_stairs": "Alapiʻi ʻOka ʻElemoe",
  "block.minecraft.dark_oak_trapdoor": "ʻĪpuka ʻŪmiʻi ʻOka ʻElemoe",
  "block.minecraft.dark_oak_wall_hanging_sign": "Papa Hōʻike ʻOka ʻElemoe Kūlewa",
  "block.minecraft.dark_oak_wall_sign": "Papa Hōʻike ʻOka ʻElemoe Pili Paia",
  "block.minecraft.dark_oak_wood": "Lāʻau ʻOka ʻElemoe",
  "block.minecraft.dark_prismarine": "Pelikamalina ʻĀhiwa",
  "block.minecraft.dark_prismarine_slab": "Paukū Pelikamalina ʻĀhiwa",
  "block.minecraft.dark_prismarine_stairs": "Alapiʻi Pelikamalina ʻĀhiwa",
  "block.minecraft.daylight_detector": "Mea ʻIke Ao",
  "block.minecraft.dead_brain_coral": "Puna Kaʻeʻe",
  "block.minecraft.dead_brain_coral_block": "Palaka Puna Kaʻeʻe",
  "block.minecraft.dead_brain_coral_fan": "Mākoʻa Puna Kaʻeʻe",
  "block.minecraft.dead_brain_coral_wall_fan": "Mākoʻa Puna Kaʻeʻe",
  "block.minecraft.dead_bubble_coral": "Koʻakoʻa Huʻa Kaʻeʻe",
  "block.minecraft.dead_bubble_coral_block": "Palaka Koʻakoʻa Huʻa Kaʻeʻe",
  "block.minecraft.dead_bubble_coral_fan": "Mākoʻa Huʻa Kaʻeʻe",
  "block.minecraft.dead_bubble_coral_wall_fan": "Mākoʻa Huʻa Kaʻeʻe",
  "block.minecraft.dead_bush": "Laʻalāʻau Make",
  "block.minecraft.dead_fire_coral": "Koʻakoʻa ʻUla Kaʻeʻe",
  "block.minecraft.dead_fire_coral_block": "Palaka Koʻakoʻa ʻUla Kaʻeʻe",
  "block.minecraft.dead_fire_coral_fan": "Mākoʻa ʻUla Kaʻeʻe",
  "block.minecraft.dead_fire_coral_wall_fan": "Mākoʻa ʻUla Kaʻeʻe",
  "block.minecraft.dead_horn_coral": "ʻĀkoʻakoʻa Kaʻeʻe",
  "block.minecraft.dead_horn_coral_block": "Palaka ʻĀkoʻakoʻa Kaʻeʻe",
  "block.minecraft.dead_horn_coral_fan": "Mākoʻa ʻĀkoʻakoʻa Kaʻeʻe",
  "block.minecraft.dead_horn_coral_wall_fan": "Mākoʻa ʻĀkoʻakoʻa Kaʻeʻe",
  "block.minecraft.dead_tube_coral": "Koʻakoʻa ʻOhe Kaʻeʻe",
  "block.minecraft.dead_tube_coral_block": "Palaka Koʻakoʻa ʻOhe Kaʻeʻe",
  "block.minecraft.dead_tube_coral_fan": "Koʻakoʻa ʻOhe Kaʻeʻe",
  "block.minecraft.dead_tube_coral_wall_fan": "Koʻakoʻa ʻOhe Kaʻeʻe",
  "block.minecraft.decorated_pot": "Poho Hoʻonani",
  "block.minecraft.deepslate": "Pōhakuhonu",
  "block.minecraft.deepslate_brick_slab": "Paukū Pōhakuhonu-lepo",
  "block.minecraft.deepslate_brick_stairs": "Alapiʻi Pōhakuhonu-lepo",
  "block.minecraft.deepslate_brick_wall": "Pā Pōhakuhonu-lepo",
  "block.minecraft.deepslate_bricks": "Pōhakuhonu-lepo",
  "block.minecraft.deepslate_coal_ore": "Pōhakuhonu Lānahu",
  "block.minecraft.deepslate_copper_ore": "Pōhakuhonu Keleawe",
  "block.minecraft.deepslate_diamond_ore": "Pōhakuhonu Kaimana",
  "block.minecraft.deepslate_emerald_ore": "Pōhakuhonu ʻŌmaʻomaʻo",
  "block.minecraft.deepslate_gold_ore": "Pōhakuhonu Kula Hou",
  "block.minecraft.deepslate_iron_ore": "Pōhakuhonu Hao",
  "block.minecraft.deepslate_lapis_ore": "Pōhakuhonu Uliuli",
  "block.minecraft.deepslate_redstone_ore": "Pōhakuhonu o Redstone",
  "block.minecraft.deepslate_tile_slab": "Paukū Pōhakuhonu Kile",
  "block.minecraft.deepslate_tile_stairs": "Alapiʻi Kile Pōhakuhonu",
  "block.minecraft.deepslate_tile_wall": "Pā Kile Pōhakuhonu",
  "block.minecraft.deepslate_tiles": "Kile Pōhakuhonu",
  "block.minecraft.detector_rail": "Alahao Kali Kaumaha",
  "block.minecraft.diamond_block": "Palaka Kaimana",
  "block.minecraft.diamond_ore": "Kaimana Hou",
  "block.minecraft.diorite": "Māono",
  "block.minecraft.diorite_slab": "Paukū Māono",
  "block.minecraft.diorite_stairs": "Alapiʻi Māono",
  "block.minecraft.diorite_wall": "Pā Māono",
  "block.minecraft.dirt": "Lepo",
  "block.minecraft.dirt_path": "Alahele Lepo",
  "block.minecraft.dispenser": "Pana Palaka",
  "block.minecraft.dragon_egg": "Hua Kalekona",
  "block.minecraft.dragon_head": "Poʻo Kalekona",
  "block.minecraft.dragon_wall_head": "Pā Poʻo Kalekona",
  "block.minecraft.dried_ghast": "Ghast Maloʻo",
  "block.minecraft.dried_kelp_block": "Palaka Limu Pīkaʻo",
  "block.minecraft.dripstone_block": "Palaka Hakukulu",
  "block.minecraft.dropper": "Hoʻokuʻu Palaka",
  "block.minecraft.emerald_block": "Palaka ʻŌmaʻomaʻo",
  "block.minecraft.emerald_ore": "Pōhaku ʻŌmaʻomaʻo",
  "block.minecraft.enchanting_table": "Pākaukau Hoʻokalakupua",
  "block.minecraft.end_gateway": "Mokuna ʻĪpuka-o-ke-End",
  "block.minecraft.end_portal": "ʻĪpuka-o-ke-End",
  "block.minecraft.end_portal_frame": "Kikihi ʻĪpuka-o-ke-End",
  "block.minecraft.end_rod": "Loka-o-ke-End",
  "block.minecraft.end_stone": "Pōhaku-o-ke-End",
  "block.minecraft.end_stone_brick_slab": "Paukū Pōhakulepo-o-ka-End",
  "block.minecraft.end_stone_brick_stairs": "Alapiʻi Pōhakulepo-o-ke-End",
  "block.minecraft.end_stone_brick_wall": "Pā Pōhakulepo-o-ke-End",
  "block.minecraft.end_stone_bricks": "Pōhakulepo-o-ke-End",
  "block.minecraft.ender_chest": "Pahu-o-Ender",
  "block.minecraft.exposed_chiseled_copper": "Keleawe Kahaʻia Ahuwale",
  "block.minecraft.exposed_copper": "Keleawe Ahuwale",
  "block.minecraft.exposed_copper_bars": "Kaola Keleawe Ahuwale",
  "block.minecraft.exposed_copper_bulb": "ʻŌpuʻu Keleawe Ahuwale",
  "block.minecraft.exposed_copper_chain": "Kaula Keleawe Ahuwale",
  "block.minecraft.exposed_copper_chest": "Pahu Keleawe Ahuwale",
  "block.minecraft.exposed_copper_door": "ʻĪpuka Keleawe Ahuwale",
  "block.minecraft.exposed_copper_golem_statue": "Kiʻi Akua-nuʻa Keleawe Ahuwale",
  "block.minecraft.exposed_copper_grate": "Haomanamana Keleawe Ahuwale",
  "block.minecraft.exposed_copper_lantern": "Ipukukui Keleawe Ahuwale",
  "block.minecraft.exposed_copper_trapdoor": "ʻĪpuka ʻŪmiʻi Keleawe Ahuwale",
  "block.minecraft.exposed_cut_copper": "Keleawe ʻŌpaka Ahuwale",
  "block.minecraft.exposed_cut_copper_slab": "Paukū Keleawe ʻŌpaka Ahuwale",
  "block.minecraft.exposed_cut_copper_stairs": "Alapiʻi Keleawe ʻŌpaka Ahuwale",
  "block.minecraft.exposed_lightning_rod": "Loka Pā Uila Ahuwale",
  "block.minecraft.farmland": "Mahakea",
  "block.minecraft.fern": "Kupukupu",
  "block.minecraft.fire": "Ahi",
  "block.minecraft.fire_coral": "Koʻakoʻa ʻUla",
  "block.minecraft.fire_coral_block": "Palaka Koʻakoʻa ʻUla",
  "block.minecraft.fire_coral_fan": "Mākoʻa ʻUla",
  "block.minecraft.fire_coral_wall_fan": "Mākoʻa ʻUla",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Papa Panapua",
  "block.minecraft.flower_pot": "Poho Meakanu",
  "block.minecraft.flowering_azalea": "Kaʻūmana Makalapua",
  "block.minecraft.flowering_azalea_leaves": "Lau Kaʻūmana Makalapua",
  "block.minecraft.frogspawn": "ʻĀhua Poloka",
  "block.minecraft.frosted_ice": "Hauʻoki Hoʻopaʻa ʻia",
  "block.minecraft.furnace": "Umu",
  "block.minecraft.gilded_blackstone": "Pāhoehoe ʻAʻā",
  "block.minecraft.glass": "Aniani",
  "block.minecraft.glass_pane": "ʻĀpana Aniani",
  "block.minecraft.glow_lichen": "Limu Liko",
  "block.minecraft.glowstone": "Pōhaku-lohi",
  "block.minecraft.gold_block": "Palaka Kula",
  "block.minecraft.gold_ore": "Pōhaku Kula",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Māpala",
  "block.minecraft.granite_slab": "Paukū Māpala",
  "block.minecraft.granite_stairs": "Alapiʻi Māpala",
  "block.minecraft.granite_wall": "Pā Māpala",
  "block.minecraft.grass": "Mauʻu",
  "block.minecraft.grass_block": "Palaka Mauʻu",
  "block.minecraft.gravel": "ʻIliʻili Makaliʻi",
  "block.minecraft.gray_banner": "Lepa Haehina",
  "block.minecraft.gray_bed": "Moekū ʻĀhinahina",
  "block.minecraft.gray_candle": "Ihoiho ʻĀhinahina",
  "block.minecraft.gray_candle_cake": "Meaʻono me Ihoiho ʻĀhinahina",
  "block.minecraft.gray_carpet": "Kāpeka ʻĀhinahina",
  "block.minecraft.gray_concrete": "Kimeki ʻĀhinahina",
  "block.minecraft.gray_concrete_powder": "Pauka Kimeki ʻĀhinahina",
  "block.minecraft.gray_glazed_terracotta": "Pālolo ʻĀhinahina ʻIliki ʻia",
  "block.minecraft.gray_shulker_box": "Pahu-o-ke-Shulker ʻĀhinahina",
  "block.minecraft.gray_stained_glass": "Aniani Luaʻehu ʻĀhinahina",
  "block.minecraft.gray_stained_glass_pane": "ʻĀpana Aniani Luaʻehu ʻĀhinahina",
  "block.minecraft.gray_terracotta": "Pālolo ʻĀhinahina",
  "block.minecraft.gray_wool": "Huluhipa ʻĀhinahina",
  "block.minecraft.green_banner": "Lepa ʻŌmaʻomaʻo",
  "block.minecraft.green_bed": "Moekū ʻŌmaʻomaʻo",
  "block.minecraft.green_candle": "Ihoiho ʻŌmaʻomaʻo",
  "block.minecraft.green_candle_cake": "Meaʻono me Ihoiho ʻŌmaʻomaʻo",
  "block.minecraft.green_carpet": "Kāpeka ʻŌmaʻomaʻo",
  "block.minecraft.green_concrete": "Kimeki ʻŌmaʻomaʻo",
  "block.minecraft.green_concrete_powder": "Pauka Kimeki ʻŌmaʻomaʻo",
  "block.minecraft.green_glazed_terracotta": "Pālolo ʻŌmaʻomaʻo ʻIliki ʻia",
  "block.minecraft.green_shulker_box": "Pahu-o-ke-Shulker ʻŌmaʻomaʻo",
  "block.minecraft.green_stained_glass": "Aniani Luaʻehu ʻŌmaʻomaʻo",
  "block.minecraft.green_stained_glass_pane": "ʻĀpana Aniani Luaʻehu ʻŌmaʻomaʻo",
  "block.minecraft.green_terracotta": "Pālolo ʻŌmaʻomaʻo",
  "block.minecraft.green_wool": "Huluhipa ʻŌmaʻomaʻo",
  "block.minecraft.grindstone": "Hoana",
  "block.minecraft.hanging_roots": "Mole Lewalewa",
  "block.minecraft.hay_block": "Pela Mauʻu Maloʻo",
  "block.minecraft.heavy_core": "Poʻo Koʻokoʻo",
  "block.minecraft.heavy_weighted_pressure_plate": "Papa Kaumaha Nui",
  "block.minecraft.honey_block": "Palaka Meli",
  "block.minecraft.honeycomb_block": "Palaka Waihona Meli",
  "block.minecraft.hopper": "Kānuku",
  "block.minecraft.horn_coral": "ʻĀkoʻakoʻa",
  "block.minecraft.horn_coral_block": "Palaka ʻĀkoʻakoʻa",
  "block.minecraft.horn_coral_fan": "Mākoʻa ʻĀkoʻakoʻa",
  "block.minecraft.horn_coral_wall_fan": "Mākoʻa ʻĀkoʻakoʻa",
  "block.minecraft.ice": "Hauʻoki",
  "block.minecraft.infested_chiseled_stone_bricks": "Hakulepo Kālaia Nohoʻia",
  "block.minecraft.infested_cobblestone": "Pōhaku ʻIliʻili Noho ʻia",
  "block.minecraft.infested_cracked_stone_bricks": "Hakulepo Nahā Noho ʻia",
  "block.minecraft.infested_deepslate": "Pōhakupapa-honu Noho ʻia",
  "block.minecraft.infested_mossy_stone_bricks": "Hakulepo Limua a Noho ʻia",
  "block.minecraft.infested_stone": "Pōhaku Noho ʻia",
  "block.minecraft.infested_stone_bricks": "Hakulepo Noho ʻia",
  "block.minecraft.iron_bars": "Kaola Hao",
  "block.minecraft.iron_block": "Palaka Hao",
  "block.minecraft.iron_chain": "Kaula Hao",
  "block.minecraft.iron_door": "ʻĪpuka Hao",
  "block.minecraft.iron_ore": "Pōhaku Hao",
  "block.minecraft.iron_trapdoor": "ʻĪpuka ʻŪmiʻi Hao",
  "block.minecraft.jack_o_lantern": "Palaʻai Heleuī",
  "block.minecraft.jigsaw": "Palaka Nane ʻĀpana",
  "block.minecraft.jukebox": "Mīkini Pāʻōlelo",
  "block.minecraft.jungle_button": "Pihi Ulunahele",
  "block.minecraft.jungle_door": "ʻĪpuka Ulunahele",
  "block.minecraft.jungle_fence": "Pālāʻau Ulunahele",
  "block.minecraft.jungle_fence_gate": "ʻĪpuka Pālāʻau Ulunahele",
  "block.minecraft.jungle_hanging_sign": "Papa Hōʻike Ulunahele Kaulia",
  "block.minecraft.jungle_leaves": "Lau Ulunahele",
  "block.minecraft.jungle_log": "Kualāʻau Ulunahele",
  "block.minecraft.jungle_planks": "Papalāʻau Ulunahele",
  "block.minecraft.jungle_pressure_plate": "Papa Kaumaha Ulunahele",
  "block.minecraft.jungle_sapling": "Ulunahele ʻŌpiopio",
  "block.minecraft.jungle_shelf": "Hakakau Ulunahele",
  "block.minecraft.jungle_sign": "Papa Hōʻike Ulunahele",
  "block.minecraft.jungle_slab": "Paukū Ulunahele",
  "block.minecraft.jungle_stairs": "Alapiʻi Ulunahele",
  "block.minecraft.jungle_trapdoor": "ʻĪpuka ʻŪmiʻi Ulunahele",
  "block.minecraft.jungle_wall_hanging_sign": "Papa Hōʻike Ulunahele Kūlewa",
  "block.minecraft.jungle_wall_sign": "Papa Hōʻike Ulunahele Pili Paia",
  "block.minecraft.jungle_wood": "Lāʻau Ulunahele",
  "block.minecraft.kelp": "Limu",
  "block.minecraft.kelp_plant": "Limu",
  "block.minecraft.ladder": "Alahaka",
  "block.minecraft.lantern": "Ipukukui",
  "block.minecraft.lapis_block": "Palaka Uliuli",
  "block.minecraft.lapis_ore": "Pōhaku Uliuli",
  "block.minecraft.large_amethyst_bud": "Liko ʻAmeki Nui",
  "block.minecraft.large_fern": "Kupukupu Nui",
  "block.minecraft.lava": "Pele",
  "block.minecraft.lava_cauldron": "Ipuhao o Pele",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "Pākau Haʻiʻōlelo",
  "block.minecraft.lever": "Une",
  "block.minecraft.light": "Malama",
  "block.minecraft.light_blue_banner": "Lepa ʻUkiʻuki",
  "block.minecraft.light_blue_bed": "Moekū ʻUkiʻuki",
  "block.minecraft.light_blue_candle": "Ihoiho ʻUkiʻuki",
  "block.minecraft.light_blue_candle_cake": "Meaʻono me Ihoiho ʻUkiʻuki",
  "block.minecraft.light_blue_carpet": "Kāpeka ʻUkiʻuki",
  "block.minecraft.light_blue_concrete": "Kimeki ʻUkiʻuki",
  "block.minecraft.light_blue_concrete_powder": "Pauka Kimeki ʻUkiʻuki",
  "block.minecraft.light_blue_glazed_terracotta": "Pālolo ʻUkiʻuki ʻIliki ʻia",
  "block.minecraft.light_blue_shulker_box": "Pahu-o-ke-Shulker ʻUkiʻuki",
  "block.minecraft.light_blue_stained_glass": "Aniani Luaʻehu ʻUkiʻuki",
  "block.minecraft.light_blue_stained_glass_pane": "ʻĀpana Aniani Luaʻehu ʻUkiʻuki",
  "block.minecraft.light_blue_terracotta": "Pālolo ʻUkiʻuki",
  "block.minecraft.light_blue_wool": "Huluhipa ʻUkiʻuki",
  "block.minecraft.light_gray_banner": "Lepa ʻĀhiehie",
  "block.minecraft.light_gray_bed": "Moekū ʻĀhiehie",
  "block.minecraft.light_gray_candle": "Ihoiho ʻĀhiehie",
  "block.minecraft.light_gray_candle_cake": "Meaʻono me Ihoiho ʻĀhiehie",
  "block.minecraft.light_gray_carpet": "Kāpeka ʻĀhiehie",
  "block.minecraft.light_gray_concrete": "Kimeki ʻĀhiehie",
  "block.minecraft.light_gray_concrete_powder": "Pauka Kimeki ʻĀhiehie",
  "block.minecraft.light_gray_glazed_terracotta": "Pālolo ʻĀhiehie ʻIliki ʻia",
  "block.minecraft.light_gray_shulker_box": "Pahu-o-ke-Shulker ʻĀhiehie",
  "block.minecraft.light_gray_stained_glass": "Aniani Luaʻehu ʻĀhiehie",
  "block.minecraft.light_gray_stained_glass_pane": "ʻĀpana Aniani Luaʻehu ʻĀhiehie",
  "block.minecraft.light_gray_terracotta": "Pālolo ʻĀhiehie",
  "block.minecraft.light_gray_wool": "Huluhipa ʻĀhiehie",
  "block.minecraft.light_weighted_pressure_plate": "Papa Kaumaha Iki",
  "block.minecraft.lightning_rod": "Loka Pā Uila",
  "block.minecraft.lilac": "Hueloʻīlio",
  "block.minecraft.lily_of_the_valley": "Lilia-o-ke-awāwa",
  "block.minecraft.lily_pad": "Lilia-lana-i-ka-wai",
  "block.minecraft.lime_banner": "Lepa Laimi",
  "block.minecraft.lime_bed": "Moekū Laimi",
  "block.minecraft.lime_candle": "Ihoiho Laimi",
  "block.minecraft.lime_candle_cake": "Meaʻono me Ihoiho Laimi",
  "block.minecraft.lime_carpet": "Kāpeka Laimi",
  "block.minecraft.lime_concrete": "Kimeki Laimi",
  "block.minecraft.lime_concrete_powder": "Pauka Kimeki Laimi",
  "block.minecraft.lime_glazed_terracotta": "Pālolo Laimi ʻIliki ʻia",
  "block.minecraft.lime_shulker_box": "Pahu-o-ke-Shulker Laimi",
  "block.minecraft.lime_stained_glass": "Aniani Luaʻehu Laimi",
  "block.minecraft.lime_stained_glass_pane": "ʻĀpana Aniani Luaʻehu Laimi",
  "block.minecraft.lime_terracotta": "Pālolo Laimi",
  "block.minecraft.lime_wool": "Huluhipa Laimi",
  "block.minecraft.lodestone": "Pōhaku Mākēneki",
  "block.minecraft.loom": "ʻŌmau",
  "block.minecraft.magenta_banner": "Lepa ʻUlamākuʻe",
  "block.minecraft.magenta_bed": "Moekū ʻUlamākuʻe",
  "block.minecraft.magenta_candle": "Ihoiho ʻUlamākuʻe",
  "block.minecraft.magenta_candle_cake": "Meaʻono me Ihoiho ʻUlamākuʻe",
  "block.minecraft.magenta_carpet": "Kāpeka ʻUlamākuʻe",
  "block.minecraft.magenta_concrete": "Kimeki ʻUlamākuʻe",
  "block.minecraft.magenta_concrete_powder": "Pauka Kimeki ʻUlamākuʻe",
  "block.minecraft.magenta_glazed_terracotta": "Pālolo ʻUlamākuʻe ʻIliki ʻia",
  "block.minecraft.magenta_shulker_box": "Pahu-o-ke-Shulker ʻUlamākuʻe",
  "block.minecraft.magenta_stained_glass": "Aniani Luaʻehu ʻUlamākuʻe",
  "block.minecraft.magenta_stained_glass_pane": "ʻĀpana Aniani Luaʻehu ʻUlamākuʻe",
  "block.minecraft.magenta_terracotta": "Pālolo ʻUlamākuʻe",
  "block.minecraft.magenta_wool": "Huluhipa ʻUlamākuʻe",
  "block.minecraft.magma_block": "Palaka Pelemaka",
  "block.minecraft.mangrove_button": "Pihi Kukunaokalā",
  "block.minecraft.mangrove_door": "ʻĪpuka Kukunaokalā",
  "block.minecraft.mangrove_fence": "Pālāʻau Kukunaokalā",
  "block.minecraft.mangrove_fence_gate": "ʻĪpuka Pālāʻau Kukunaokalā",
  "block.minecraft.mangrove_hanging_sign": "Papa Hōʻike Kukunaokalā Kaulia",
  "block.minecraft.mangrove_leaves": "Lau Kukunaokalā",
  "block.minecraft.mangrove_log": "Kualāʻau Kukunaokalā",
  "block.minecraft.mangrove_planks": "Papalāʻau Kukunaokalā",
  "block.minecraft.mangrove_pressure_plate": "Papa Kaumaha Kukunaokalā",
  "block.minecraft.mangrove_propagule": "Pulapula Kukunaokalā",
  "block.minecraft.mangrove_roots": "Aʻa Kukunaokalā",
  "block.minecraft.mangrove_shelf": "Hakakau Kukunaokalā",
  "block.minecraft.mangrove_sign": "Papa Hōʻike Kukunaokalā",
  "block.minecraft.mangrove_slab": "Paukū Kukunaokalā",
  "block.minecraft.mangrove_stairs": "Alapiʻi Kukunaokalā",
  "block.minecraft.mangrove_trapdoor": "ʻĪpuka ʻŪmiʻi Kukunaokalā",
  "block.minecraft.mangrove_wall_hanging_sign": "Papa Hōʻike Kukunaokalā Kūlewa",
  "block.minecraft.mangrove_wall_sign": "Papa Hōʻike Kukunaokalā Pili Paia",
  "block.minecraft.mangrove_wood": "Laau Mangrove",
  "block.minecraft.medium_amethyst_bud": "Liko ʻAmeki Waena",
  "block.minecraft.melon": "Ipuhaole",
  "block.minecraft.melon_stem": "Kano Ipuhaole",
  "block.minecraft.moss_block": "Palaka Mākōpiʻi",
  "block.minecraft.moss_carpet": "Hāliʻi Mākōpiʻi",
  "block.minecraft.mossy_cobblestone": "Pōhaku ʻIliʻili Limua",
  "block.minecraft.mossy_cobblestone_slab": "Paukū Pōhaku ʻIliʻili Limua",
  "block.minecraft.mossy_cobblestone_stairs": "Alapiʻi Pōhaku ʻIliʻili Limua",
  "block.minecraft.mossy_cobblestone_wall": "Pā Pōhaku ʻIliʻili Limua",
  "block.minecraft.mossy_stone_brick_slab": "Paukū Hakulepo Limua",
  "block.minecraft.mossy_stone_brick_stairs": "Alapiʻi Hakulepo Limua",
  "block.minecraft.mossy_stone_brick_wall": "Pā Hakulepo Limua",
  "block.minecraft.mossy_stone_bricks": "Hakulepo Limua",
  "block.minecraft.moving_piston": "Kuʻe Hao Neʻe",
  "block.minecraft.mud": "ʻŪkele",
  "block.minecraft.mud_brick_slab": "Paukū ʻŪkele",
  "block.minecraft.mud_brick_stairs": "Alapiʻi ʻŪkele",
  "block.minecraft.mud_brick_wall": "Pā ʻŪkele",
  "block.minecraft.mud_bricks": "Pōhakulepo ʻŪkele",
  "block.minecraft.muddy_mangrove_roots": "Aʻa Kukunaokalā ʻŌkelekele",
  "block.minecraft.mushroom_stem": "Hā Melehune",
  "block.minecraft.mycelium": "Aʻakolo Melehune",
  "block.minecraft.nether_brick_fence": "Pā Pōhakulepo-o-ka-Nether",
  "block.minecraft.nether_brick_slab": "Paukū Pōhakulepo-o-ka-Nether",
  "block.minecraft.nether_brick_stairs": "Alapiʻi Pōhakulepo-o-ka-Nether",
  "block.minecraft.nether_brick_wall": "Pā Pōhakulepo-o-ka-Nether",
  "block.minecraft.nether_bricks": "Pōhaku-o-Nether Lepo",
  "block.minecraft.nether_gold_ore": "Pōhaku Kula o ka Nether",
  "block.minecraft.nether_portal": "ʻĪpuka-o-ka-Nether",
  "block.minecraft.nether_quartz_ore": "Pōhakuaʻiaʻi-o-ka-Nether Hou",
  "block.minecraft.nether_sprouts": "Kupu Nekele",
  "block.minecraft.nether_wart": "Pepeiao-o-ka-Nether",
  "block.minecraft.nether_wart_block": "Palaka Pepeiao-o-ka-Nether",
  "block.minecraft.netherite_block": "Palaka Hao-o-ka-Nether",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Palaka Hoʻokani Hua Mele",
  "block.minecraft.oak_button": "Pihi ʻOka",
  "block.minecraft.oak_door": "ʻĪpuka ʻOka",
  "block.minecraft.oak_fence": "Pālāʻau ʻOka",
  "block.minecraft.oak_fence_gate": "ʻĪpuka Pālāʻau ʻOka",
  "block.minecraft.oak_hanging_sign": "Papa Hōʻike ʻOka Kaulia",
  "block.minecraft.oak_leaves": "Lau ʻOka",
  "block.minecraft.oak_log": "Kualāʻau ʻOka",
  "block.minecraft.oak_planks": "Papalāʻau ʻOka",
  "block.minecraft.oak_pressure_plate": "Papa Kaumaha ʻOka",
  "block.minecraft.oak_sapling": "ʻOka ʻŌpiopio",
  "block.minecraft.oak_shelf": "Hakakau ʻOka",
  "block.minecraft.oak_sign": "Papa Hōʻike ʻOka",
  "block.minecraft.oak_slab": "Paukū ʻOka",
  "block.minecraft.oak_stairs": "Alapiʻi ʻOka",
  "block.minecraft.oak_trapdoor": "ʻĪpuka ʻŪmiʻi ʻOka",
  "block.minecraft.oak_wall_hanging_sign": "Papa Hōʻike ʻOka Kaulia",
  "block.minecraft.oak_wall_sign": "Papa Hōʻike ʻOka Pili Paia",
  "block.minecraft.oak_wood": "Lāʻau ʻOka",
  "block.minecraft.observer": "Kaulona",
  "block.minecraft.obsidian": "Mākā",
  "block.minecraft.ochre_froglight": "Lamalana Maʻalaea",
  "block.minecraft.ominous_banner": "Puwalu Pōʻino",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Lepa ʻAlani",
  "block.minecraft.orange_bed": "Moekū ʻAlani",
  "block.minecraft.orange_candle": "Ihoiho ʻAlani",
  "block.minecraft.orange_candle_cake": "Meaʻono me Ihoiho ʻAlani",
  "block.minecraft.orange_carpet": "Kāpeka ʻAlani",
  "block.minecraft.orange_concrete": "Kimeki ʻAlani",
  "block.minecraft.orange_concrete_powder": "Pauka Kimeki ʻAlani",
  "block.minecraft.orange_glazed_terracotta": "Pālolo ʻAlani ʻIliki ʻia",
  "block.minecraft.orange_shulker_box": "Pahu-o-ke-Shulker ʻAlani",
  "block.minecraft.orange_stained_glass": "Aniani Luaʻehu ʻAlani",
  "block.minecraft.orange_stained_glass_pane": "ʻĀpana Aniani Luaʻehu ʻAlani",
  "block.minecraft.orange_terracotta": "Pālolo ʻAlani",
  "block.minecraft.orange_tulip": "Kulipa ʻAlani",
  "block.minecraft.orange_wool": "Huluhipa ʻAlani",
  "block.minecraft.oxeye_daisy": "Makalike",
  "block.minecraft.oxidized_chiseled_copper": "Keleawe Lepohao Kālaia",
  "block.minecraft.oxidized_copper": "Keleawe Lepohao",
  "block.minecraft.oxidized_copper_bars": "Kaola Keleawe Kūkaehao",
  "block.minecraft.oxidized_copper_bulb": "ʻŌpuʻu Keleawe Lepohao",
  "block.minecraft.oxidized_copper_chain": "Kaula Keleawe Kūkaehao",
  "block.minecraft.oxidized_copper_chest": "Pahu Keleawe Kūkaehao",
  "block.minecraft.oxidized_copper_door": "ʻĪpuka Keleawe Lepohao",
  "block.minecraft.oxidized_copper_golem_statue": "Kiʻi Akua-nuʻa Keleawe Kūkaehao",
  "block.minecraft.oxidized_copper_grate": "Haomanamana Keleawe Lepohao",
  "block.minecraft.oxidized_copper_lantern": "Ipukukui Keleawe Kūkaehao",
  "block.minecraft.oxidized_copper_trapdoor": "ʻĪpuka ʻŪmiʻi Keleawe Lepohao",
  "block.minecraft.oxidized_cut_copper": "Keleawe ʻoki ʻoki ʻia",
  "block.minecraft.oxidized_cut_copper_slab": "'Okikokiʻokiʻoki keleawe papa",
  "block.minecraft.oxidized_cut_copper_stairs": "ʻO nā alapiʻi keleawe ʻoki ʻokiʻoki",
  "block.minecraft.oxidized_lightning_rod": "Loka Pā Uila Kūkaehao",
  "block.minecraft.packed_ice": "Kēhaupaʻa",
  "block.minecraft.packed_mud": "Pālolo",
  "block.minecraft.pale_hanging_moss": "Manamana Limu Hākea",
  "block.minecraft.pale_moss_block": "Palaka Limu Hākea",
  "block.minecraft.pale_moss_carpet": "Papa Limu Hākea",
  "block.minecraft.pale_oak_button": "Pihi ʻOka Haʻakea",
  "block.minecraft.pale_oak_door": "ʻĪpuka ʻOka Haʻakea",
  "block.minecraft.pale_oak_fence": "Pālā'au ʻOka Haʻakea",
  "block.minecraft.pale_oak_fence_gate": "ʻĪpuka Pālāʻau ʻOka Haʻakea",
  "block.minecraft.pale_oak_hanging_sign": "Papa Hōʻike ʻOka Haʻakea Kaulia",
  "block.minecraft.pale_oak_leaves": "Lau ʻOka Haʻakea",
  "block.minecraft.pale_oak_log": "Kualāʻau ʻOka Haʻakea",
  "block.minecraft.pale_oak_planks": "Papalāʻau ʻOka Haʻakea",
  "block.minecraft.pale_oak_pressure_plate": "Papa Kaumaha ʻOka Haʻakea",
  "block.minecraft.pale_oak_sapling": "ʻOka Haʻakea ʻŌpiopio",
  "block.minecraft.pale_oak_shelf": "Hakakau ʻOka Haʻakea",
  "block.minecraft.pale_oak_sign": "Papa Hōʻike ʻOka Haʻakea",
  "block.minecraft.pale_oak_slab": "Paukū ʻOka Haʻakea",
  "block.minecraft.pale_oak_stairs": "Alapiʻi ʻOka Haʻakea",
  "block.minecraft.pale_oak_trapdoor": "ʻĪpuka ʻŪmiʻi ʻOka Haʻakea",
  "block.minecraft.pale_oak_wall_hanging_sign": "Papa Hōʻike ʻOka Haʻakea Kūlewa",
  "block.minecraft.pale_oak_wall_sign": "Papa Hōʻike ʻOka Haʻakea Pili Paia",
  "block.minecraft.pale_oak_wood": "Lāʻau ʻOka Haʻakea",
  "block.minecraft.pearlescent_froglight": "Lamalana Kōnane",
  "block.minecraft.peony": "Lōkālia",
  "block.minecraft.petrified_oak_slab": "Paukū ʻOka Pōhaku",
  "block.minecraft.piglin_head": "Poʻo Piglin",
  "block.minecraft.piglin_wall_head": "Pā Poʻo Piglin",
  "block.minecraft.pink_banner": "Lepa ʻĀkala",
  "block.minecraft.pink_bed": "Moekū ʻĀkala",
  "block.minecraft.pink_candle": "Ihoiho ʻĀkala",
  "block.minecraft.pink_candle_cake": "Meaʻono me Ihoiho ʻĀkala",
  "block.minecraft.pink_carpet": "Kāpeka ʻĀkala",
  "block.minecraft.pink_concrete": "Kimeki ʻĀkala",
  "block.minecraft.pink_concrete_powder": "Pauka Kimeki ʻĀkala",
  "block.minecraft.pink_glazed_terracotta": "Pālolo ʻĀkala ʻIliki ʻia",
  "block.minecraft.pink_petals": "Lihilihi ʻĀkala",
  "block.minecraft.pink_shulker_box": "Pahu-o-ke-Shulker ʻĀkala",
  "block.minecraft.pink_stained_glass": "Aniani Luaʻehu ʻĀkala",
  "block.minecraft.pink_stained_glass_pane": "ʻĀpana Aniani Luaʻehu ʻĀkala",
  "block.minecraft.pink_terracotta": "Pālolo ʻĀkala",
  "block.minecraft.pink_tulip": "Kulipa ʻĀkala",
  "block.minecraft.pink_wool": "Huluhipa ʻĀkala",
  "block.minecraft.piston": "Kuʻe Hao",
  "block.minecraft.piston_head": "Poʻo Kuʻe Hao",
  "block.minecraft.pitcher_crop": "Kanu Pīkela",
  "block.minecraft.pitcher_plant": "Pikele",
  "block.minecraft.player_head": "Poʻo Mea Pāʻani",
  "block.minecraft.player_head.named": "Poʻo o %s",
  "block.minecraft.player_wall_head": "Poʻo Mea Pāʻani Kaulia",
  "block.minecraft.podzol": "Lepo Momona",
  "block.minecraft.pointed_dripstone": "Hakukulu Puʻuʻoiʻoi",
  "block.minecraft.polished_andesite": "ʻElekū Hinua",
  "block.minecraft.polished_andesite_slab": "Paukū ʻElekū Hinua",
  "block.minecraft.polished_andesite_stairs": "Alapiʻi ʻElekū Hinua",
  "block.minecraft.polished_basalt": "Pōhaku-Paʻa Hinua",
  "block.minecraft.polished_blackstone": "Pāhoehoe Hinua",
  "block.minecraft.polished_blackstone_brick_slab": "Paukū Pōhakulepo Pāhoehoe Hinua",
  "block.minecraft.polished_blackstone_brick_stairs": "Alapiʻi Pōhakulepo Pāhoehoe Hinua",
  "block.minecraft.polished_blackstone_brick_wall": "Pā Pōhakulepo Pāhoehoe Hinua",
  "block.minecraft.polished_blackstone_bricks": "Pōhakulepo Pāhoehoe Hinua",
  "block.minecraft.polished_blackstone_button": "Pihi Pāhoehoe Hinua",
  "block.minecraft.polished_blackstone_pressure_plate": "Papa Kaumaha Pāhoehoe Hinua",
  "block.minecraft.polished_blackstone_slab": "Paukū Pāhoehoe Hinua",
  "block.minecraft.polished_blackstone_stairs": "Alapiʻi Pāhoehoe Hinua",
  "block.minecraft.polished_blackstone_wall": "Pā Pāhoehoe Hinua",
  "block.minecraft.polished_deepslate": "Pōhakuhonu Hinua",
  "block.minecraft.polished_deepslate_slab": "Paukū Pōhakuhonu Hinua",
  "block.minecraft.polished_deepslate_stairs": "Alapiʻi Pōhakuhonu Hinua",
  "block.minecraft.polished_deepslate_wall": "Pā Pōhakuhonu Hinua",
  "block.minecraft.polished_diorite": "Māono Hinua",
  "block.minecraft.polished_diorite_slab": "Paukū Māono Hinua",
  "block.minecraft.polished_diorite_stairs": "Alapiʻi Māono Hinua",
  "block.minecraft.polished_granite": "Māpala Hinua",
  "block.minecraft.polished_granite_slab": "Paukū Māpala Hinua",
  "block.minecraft.polished_granite_stairs": "Alapiʻi Māpala Hinua",
  "block.minecraft.polished_tuff": "Pōhakuhune Hinua",
  "block.minecraft.polished_tuff_slab": "Paukū Pōhakuhune Hinua",
  "block.minecraft.polished_tuff_stairs": "Alapiʻi Pōhakuhune Hinua",
  "block.minecraft.polished_tuff_wall": "Pā Pōhakuhune Hinua",
  "block.minecraft.poppy": "Pua Papi",
  "block.minecraft.potatoes": "ʻUala Kahiki",
  "block.minecraft.potted_acacia_sapling": "Koa ʻŌpiopio Poho ʻia",
  "block.minecraft.potted_allium": "ʻAkaʻakai Poho ʻia",
  "block.minecraft.potted_azalea_bush": "Kaʻūmana Poha ʻia",
  "block.minecraft.potted_azure_bluet": "Pua Kueka Poho ʻia",
  "block.minecraft.potted_bamboo": "ʻOhe Poha ʻia",
  "block.minecraft.potted_birch_sapling": "Pūkowi ʻŌpiopio Poho ʻia",
  "block.minecraft.potted_blue_orchid": "ʻOkika Uliuli Poha ʻia",
  "block.minecraft.potted_brown_mushroom": "Melehune Mākuʻe Poha ʻia",
  "block.minecraft.potted_cactus": "Pānini Poha ʻia",
  "block.minecraft.potted_cherry_sapling": "Keli ʻŌpiopio Poha ʻia",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "ʻĀwiwi Uliuli Poho ʻia",
  "block.minecraft.potted_crimson_fungus": "Kalina Pūkoko Poho ʻia",
  "block.minecraft.potted_crimson_roots": "Maʻalewa Pūkoko Poho ʻia",
  "block.minecraft.potted_dandelion": "Laulele Poho ʻia",
  "block.minecraft.potted_dark_oak_sapling": "ʻOka ʻElemoe ʻŌpiopio Poha ʻia",
  "block.minecraft.potted_dead_bush": "Laʻalāʻau Make Poha ʻia",
  "block.minecraft.potted_fern": "Kupukupu Poha ʻia",
  "block.minecraft.potted_flowering_azalea_bush": "Kaʻūmana Makalapua Poho ʻia",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Ulunahele ʻŌpiopio Poha ʻia",
  "block.minecraft.potted_lily_of_the_valley": "Lilia-o-ke-Awāwa Poha ʻia",
  "block.minecraft.potted_mangrove_propagule": "Pulapula Kukunaokalā Poho ʻia",
  "block.minecraft.potted_oak_sapling": "ʻOka ʻŌpiopio Poho ʻia",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Kulipa ʻAlani Poho ʻia",
  "block.minecraft.potted_oxeye_daisy": "Makalike Poho ʻia",
  "block.minecraft.potted_pale_oak_sapling": "ʻOka Haʻakea ʻŌpiopio Poho ʻia",
  "block.minecraft.potted_pink_tulip": "Kulipa ʻĀkala Poho ʻia",
  "block.minecraft.potted_poppy": "Kala Poho ʻia",
  "block.minecraft.potted_red_mushroom": "Melehune ʻUlaʻula Poho ʻia",
  "block.minecraft.potted_red_tulip": "Kulipa ʻUlaʻula Poho ʻia",
  "block.minecraft.potted_spruce_sapling": "Lāʻauhū ʻŌpiopio Poho ʻia",
  "block.minecraft.potted_torchflower": "ʻAwapuhi Koʻokoʻo Poho ʻia",
  "block.minecraft.potted_warped_fungus": "Pepeiao ʻEʻepa Poho ʻia",
  "block.minecraft.potted_warped_roots": "Aʻa ʻEʻepa Poho ʻia",
  "block.minecraft.potted_white_tulip": "Kulipa Keʻokeʻo Poho ʻia",
  "block.minecraft.potted_wither_rose": "Loke-o-ka-Wither Poha ʻia",
  "block.minecraft.powder_snow": "Haukea Pauka",
  "block.minecraft.powder_snow_cauldron": "Ipuhau me ka Haukea",
  "block.minecraft.powered_rail": "Alahao Hoʻohikiwawe",
  "block.minecraft.prismarine": "Pelikamalina",
  "block.minecraft.prismarine_brick_slab": "Paukū Pōhakulepo Pelikamalina",
  "block.minecraft.prismarine_brick_stairs": "Alapiʻi Pōhakulepo Pelikamalina",
  "block.minecraft.prismarine_bricks": "Pōhakulepo Pelikamalina",
  "block.minecraft.prismarine_slab": "Paukū Pelikamalina",
  "block.minecraft.prismarine_stairs": "Alapiʻi Pelikamalina",
  "block.minecraft.prismarine_wall": "Pā Pelikamalina",
  "block.minecraft.pumpkin": "Palaʻai",
  "block.minecraft.pumpkin_stem": "Kano Palaʻai",
  "block.minecraft.purple_banner": "Lepa Poni",
  "block.minecraft.purple_bed": "Moekū Poni",
  "block.minecraft.purple_candle": "Ihoiho Poni",
  "block.minecraft.purple_candle_cake": "Meaʻono me Ihoiho Poni",
  "block.minecraft.purple_carpet": "Kāpeka Poni",
  "block.minecraft.purple_concrete": "Kimeki Poni",
  "block.minecraft.purple_concrete_powder": "Pauka Kimeki Poni",
  "block.minecraft.purple_glazed_terracotta": "Pālolo Poni ʻIliki ʻia",
  "block.minecraft.purple_shulker_box": "Pahu-o-ke-Shulker Poni",
  "block.minecraft.purple_stained_glass": "Aniani Luaʻehu Poni",
  "block.minecraft.purple_stained_glass_pane": "ʻĀpana Aniani Luaʻehu Poni",
  "block.minecraft.purple_terracotta": "Pālolo Poni",
  "block.minecraft.purple_wool": "Huluhipa Poni",
  "block.minecraft.purpur_block": "Palaka-o-Purpur",
  "block.minecraft.purpur_pillar": "Kia-o-Purpur",
  "block.minecraft.purpur_slab": "Paukū-o-Purpur",
  "block.minecraft.purpur_stairs": "Alapiʻi-o-Purpur",
  "block.minecraft.quartz_block": "Palaka Pōhakuaʻiaʻi",
  "block.minecraft.quartz_bricks": "Pōhakulepo-Aʻiaʻi",
  "block.minecraft.quartz_pillar": "Kia Pōhakuaʻiaʻi",
  "block.minecraft.quartz_slab": "Paukū Pōhakuaʻiaʻi",
  "block.minecraft.quartz_stairs": "Alapiʻi Pōhakuaʻiaʻi",
  "block.minecraft.rail": "Alahao",
  "block.minecraft.raw_copper_block": "Palaka Keleawe Hou",
  "block.minecraft.raw_gold_block": "Palaka Kula Hou",
  "block.minecraft.raw_iron_block": "Palaka Hao Hou",
  "block.minecraft.red_banner": "Lepa ʻUlaʻula",
  "block.minecraft.red_bed": "Moekū ʻUlaʻula",
  "block.minecraft.red_candle": "Ihoiho ʻUlaʻula",
  "block.minecraft.red_candle_cake": "Meaʻono me Ihoiho ʻUlaʻula",
  "block.minecraft.red_carpet": "Kāpeka ʻUlaʻula",
  "block.minecraft.red_concrete": "Kimeki ʻUlaʻula",
  "block.minecraft.red_concrete_powder": "Pauka Kimeki ʻUlaʻula",
  "block.minecraft.red_glazed_terracotta": "Pālolo ʻUlaʻula ʻIliki ʻia",
  "block.minecraft.red_mushroom": "Melehune ʻUlaʻula",
  "block.minecraft.red_mushroom_block": "Palaka Melehune ʻUlaʻula",
  "block.minecraft.red_nether_brick_slab": "Paukū Pōhakulepo-o-ka-Nether ʻUlaʻula",
  "block.minecraft.red_nether_brick_stairs": "Alapiʻi Pōhakulepo-o-ka-Nether ʻUlaʻula",
  "block.minecraft.red_nether_brick_wall": "Pā Pōhakulepo-o-ka-Nether ʻUlaʻula",
  "block.minecraft.red_nether_bricks": "Pōhakulepo-o-ka-Nether ʻUlaʻula",
  "block.minecraft.red_sand": "One Maʻalaea",
  "block.minecraft.red_sandstone": "Kumuone Maʻalaea",
  "block.minecraft.red_sandstone_slab": "Paukū Kumuone Maʻalaea",
  "block.minecraft.red_sandstone_stairs": "Alapiʻi Kumuone Maʻalaea",
  "block.minecraft.red_sandstone_wall": "Pāpōhaku Kumuone Maʻalaea",
  "block.minecraft.red_shulker_box": "Pahu-o-ke-Shulker ʻUlaʻula",
  "block.minecraft.red_stained_glass": "Aniani Luaʻehu ʻUlaʻula",
  "block.minecraft.red_stained_glass_pane": "ʻĀpana Aniani Luaʻehu ʻUlaʻula",
  "block.minecraft.red_terracotta": "Pālolo ʻUlaʻula",
  "block.minecraft.red_tulip": "Kulipa ʻUlaʻula",
  "block.minecraft.red_wool": "Huluhipa ʻUlaʻula",
  "block.minecraft.redstone_block": "Palaka o Redstone",
  "block.minecraft.redstone_lamp": "Kukui o Redstone",
  "block.minecraft.redstone_ore": "Pōhaku ʻAno Redstone",
  "block.minecraft.redstone_torch": "Pūlama ʻAno Redstone",
  "block.minecraft.redstone_wall_torch": "Pūlama Pā ʻAno Redstone",
  "block.minecraft.redstone_wire": "Uea o Redstone",
  "block.minecraft.reinforced_deepslate": "Pōhakuhonu Paʻa",
  "block.minecraft.repeater": "Mea Hoʻomau Uila o Redstone",
  "block.minecraft.repeating_command_block": "Palaka Kauoha Pīnaʻi",
  "block.minecraft.resin_block": "Palaka Hūkaʻa",
  "block.minecraft.resin_brick_slab": "Paukū Pōhaku Hūkaʻa",
  "block.minecraft.resin_brick_stairs": "Alapiʻi Pōhaku Hūkaʻa",
  "block.minecraft.resin_brick_wall": "Pā Pōhaku Hūkaʻa",
  "block.minecraft.resin_bricks": "Pōhaku Hūkaʻa",
  "block.minecraft.resin_clump": "Ōpū Hūkaʻa",
  "block.minecraft.respawn_anchor": "Heleuma Hoʻi",
  "block.minecraft.rooted_dirt": "Lepo Paiaʻa",
  "block.minecraft.rose_bush": "Laʻalāʻau Loke",
  "block.minecraft.sand": "One",
  "block.minecraft.sandstone": "Kumuone",
  "block.minecraft.sandstone_slab": "Paukū Kumuone",
  "block.minecraft.sandstone_stairs": "Alapiʻi Kumuone",
  "block.minecraft.sandstone_wall": "Pāpōhaku Kumuone",
  "block.minecraft.scaffolding": "ʻOlokeʻa",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Mea Hoʻoulu Sculk",
  "block.minecraft.sculk_sensor": "ʻIke-o-ka-Sculk",
  "block.minecraft.sculk_shrieker": "Kekē-o-ka-Sculk",
  "block.minecraft.sculk_vein": "Aʻa-o-ka-Sculk",
  "block.minecraft.sea_lantern": "Kukui Hoʻomalama Kai",
  "block.minecraft.sea_pickle": "Loli",
  "block.minecraft.seagrass": "Nāipoliʻiliʻihoʻokuʻiikapuʻuwai",
  "block.minecraft.set_spawn": "Hoʻokapu ʻia ka wahi hānau hou",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Mauʻu Liʻiliʻi",
  "block.minecraft.shroomlight": "Ao Kūkaelio",
  "block.minecraft.shulker_box": "Pahu-o-ke-Shulker",
  "block.minecraft.skeleton_skull": "Poʻo Kanakaiwi",
  "block.minecraft.skeleton_wall_skull": "Pā Poʻo Kanakaiwi",
  "block.minecraft.slime_block": "Palaka Kelo",
  "block.minecraft.small_amethyst_bud": "Liko ʻAmeki Liʻi",
  "block.minecraft.small_dripleaf": "Lau-luhe Liʻi",
  "block.minecraft.smithing_table": "Papa Kuʻi Hao",
  "block.minecraft.smoker": "Mea Hoʻouahi",
  "block.minecraft.smooth_basalt": "Pōhaku-Paʻa Hinua",
  "block.minecraft.smooth_quartz": "Palaka Pōhakuaʻiaʻi Hinua",
  "block.minecraft.smooth_quartz_slab": "Paukū Pōhakuaʻiaʻi Hinua",
  "block.minecraft.smooth_quartz_stairs": "Alapiʻi Pōhakuaʻiaʻi Hinua",
  "block.minecraft.smooth_red_sandstone": "Kumuone Maʻalaea Hinua",
  "block.minecraft.smooth_red_sandstone_slab": "Paukū Kumuone Maʻalaea Hinua",
  "block.minecraft.smooth_red_sandstone_stairs": "Kumuone Maʻalaea Hinua",
  "block.minecraft.smooth_sandstone": "Kumuone Hinua",
  "block.minecraft.smooth_sandstone_slab": "Paukū Kumuone Hinua",
  "block.minecraft.smooth_sandstone_stairs": "Alapiʻi Kumuone Hinua",
  "block.minecraft.smooth_stone": "Pōhaku Hinua",
  "block.minecraft.smooth_stone_slab": "Paukū Pōhaku Hinua",
  "block.minecraft.sniffer_egg": "Hua Hanuhanu",
  "block.minecraft.snow": "Haukea",
  "block.minecraft.snow_block": "Palaka Haukea",
  "block.minecraft.soul_campfire": "Luaahi ʻUhane",
  "block.minecraft.soul_fire": "Ahi ʻUhane",
  "block.minecraft.soul_lantern": "Lama ʻUhane",
  "block.minecraft.soul_sand": "One ʻUhane",
  "block.minecraft.soul_soil": "Lepo ʻUhane",
  "block.minecraft.soul_torch": "Pūlama ʻAno Pili ʻUhane",
  "block.minecraft.soul_wall_torch": "Paʻa Makapu",
  "block.minecraft.spawn.not_valid": "ʻAʻohe ou moekū home a i ʻole Heleuma Hoʻi me ka uila paha, a i ʻole ua ālai ʻia ia",
  "block.minecraft.spawner": "Mea Hānau Pilikua",
  "block.minecraft.spawner.desc1": "Pā Hua Hānau:",
  "block.minecraft.spawner.desc2": "Koho ʻAno Pilikua",
  "block.minecraft.sponge": "Huʻakai",
  "block.minecraft.spore_blossom": "Pua Pili Ana",
  "block.minecraft.spruce_button": "Pihi Lāʻauhū",
  "block.minecraft.spruce_door": "ʻĪpuka Lāʻauhū",
  "block.minecraft.spruce_fence": "Pālā'au Lāʻauhū",
  "block.minecraft.spruce_fence_gate": "ʻĪpuka Pālā'au Lāʻauhū",
  "block.minecraft.spruce_hanging_sign": "Papa Hōʻike Lāʻauhū Kaulia",
  "block.minecraft.spruce_leaves": "Lau Lāʻauhū",
  "block.minecraft.spruce_log": "Kua Lāʻauhū",
  "block.minecraft.spruce_planks": "Papalāʻau Lāʻauhū",
  "block.minecraft.spruce_pressure_plate": "Papa Kaumaha Lāʻauhū",
  "block.minecraft.spruce_sapling": "Lāʻauhū ʻŌpiopio",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Papa Hōʻike Lāʻauhū",
  "block.minecraft.spruce_slab": "Paukū Lāʻauhū",
  "block.minecraft.spruce_stairs": "Alapiʻi Lāʻauhū",
  "block.minecraft.spruce_trapdoor": "ʻĪpuka ʻŪmiʻi Lāʻauhū",
  "block.minecraft.spruce_wall_hanging_sign": "Papa Hōʻike Lāʻauhū Kūlewa",
  "block.minecraft.spruce_wall_sign": "Papa Hōʻike Lāʻauhū Pili Paia",
  "block.minecraft.spruce_wood": "Lāʻauhū",
  "block.minecraft.sticky_piston": "Hao Kuʻe Pipili",
  "block.minecraft.stone": "Pōhaku",
  "block.minecraft.stone_brick_slab": "Paukū Pōhakulepo",
  "block.minecraft.stone_brick_stairs": "Alapiʻi Pōhakulepo",
  "block.minecraft.stone_brick_wall": "Pā Pōhakulepo",
  "block.minecraft.stone_bricks": "Pōhakulepo",
  "block.minecraft.stone_button": "Pihi Pōhaku",
  "block.minecraft.stone_pressure_plate": "Papa Kaumaha Pōhaku",
  "block.minecraft.stone_slab": "Paukū Pōhaku",
  "block.minecraft.stone_stairs": "Alapiʻi Pōhaku",
  "block.minecraft.stonecutter": "Kālai Pōhaku",
  "block.minecraft.stripped_acacia_log": "Kualāʻau Koa Holea",
  "block.minecraft.stripped_acacia_wood": "Lāʻau Koa Holea",
  "block.minecraft.stripped_bamboo_block": "Paka ʻOhe Holea",
  "block.minecraft.stripped_birch_log": "Kualāʻau Pūkowi Holea",
  "block.minecraft.stripped_birch_wood": "Lāʻau Pūkowi Holea",
  "block.minecraft.stripped_cherry_log": "Kualāʻau Keli Holea",
  "block.minecraft.stripped_cherry_wood": "Lāʻau Keli Holea",
  "block.minecraft.stripped_crimson_hyphae": "Maʻawe Pūkoko Holea",
  "block.minecraft.stripped_crimson_stem": "Hā Pūkoko Holea",
  "block.minecraft.stripped_dark_oak_log": "Kualāʻau ʻOka ʻElemoe Holea",
  "block.minecraft.stripped_dark_oak_wood": "ʻOka ʻElemoe Holea",
  "block.minecraft.stripped_jungle_log": "Kualāʻau Ulunahele Holea",
  "block.minecraft.stripped_jungle_wood": "Lāʻau Ulunahele Holea",
  "block.minecraft.stripped_mangrove_log": "Kua Kukunaokalā Holea",
  "block.minecraft.stripped_mangrove_wood": "ʻO ka lāʻau mangrove i kāʻili ʻia",
  "block.minecraft.stripped_oak_log": "Kualāʻau ʻOka Holea",
  "block.minecraft.stripped_oak_wood": "ʻOka Holea",
  "block.minecraft.stripped_pale_oak_log": "Kualāʻau ʻOka Haʻakea Holea",
  "block.minecraft.stripped_pale_oak_wood": "Lāʻau ʻOka Haʻakea Holea",
  "block.minecraft.stripped_spruce_log": "Kualāʻau Lāʻauhū Holohole ʻia",
  "block.minecraft.stripped_spruce_wood": "Lāʻauhū Holea",
  "block.minecraft.stripped_warped_hyphae": "Maʻawe ʻEʻepa Holea",
  "block.minecraft.stripped_warped_stem": "Hā ʻEʻepa Holea",
  "block.minecraft.structure_block": "Palaka Hale",
  "block.minecraft.structure_void": "Hahalu Hale",
  "block.minecraft.sugar_cane": "Kō",
  "block.minecraft.sunflower": "Nānālā",
  "block.minecraft.suspicious_gravel": "ʻIliʻili Makaliʻi ʻAno ʻĒ",
  "block.minecraft.suspicious_sand": "One ʻAno ʻĒ",
  "block.minecraft.sweet_berry_bush": "Laʻalāʻau Pīʻai",
  "block.minecraft.tall_dry_grass": "Mauʻu Maloʻo Kiʻekiʻe",
  "block.minecraft.tall_grass": "Mauʻu Kiʻekiʻe",
  "block.minecraft.tall_seagrass": "Nāipoliʻiliʻihoʻokuʻiikapuʻuwai Kiʻekiʻe",
  "block.minecraft.target": "Māka",
  "block.minecraft.terracotta": "Pālolo",
  "block.minecraft.test_block": "Palaka Hoʻāʻo",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Aniani Laulā Kala",
  "block.minecraft.tnt": "Kianapauka",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Pūlama",
  "block.minecraft.torchflower": "ʻAwapuhi Koʻokoʻo",
  "block.minecraft.torchflower_crop": "Kanu ʻAwapuhi Koʻokoʻo",
  "block.minecraft.trapped_chest": "Pahu Hoʻohihia",
  "block.minecraft.trial_spawner": "Mea Hānau o ka Hoʻonahoa",
  "block.minecraft.tripwire": "Uea-hoʻōkupe",
  "block.minecraft.tripwire_hook": "Mākau Uea-hoʻōkupe",
  "block.minecraft.tube_coral": "Koʻakoʻa ʻOhe",
  "block.minecraft.tube_coral_block": "Palaka Koʻakoʻa ʻOhe",
  "block.minecraft.tube_coral_fan": "Mākoʻa ʻOhe",
  "block.minecraft.tube_coral_wall_fan": "Mākoʻa ʻOhe",
  "block.minecraft.tuff": "Pākuʻi",
  "block.minecraft.tuff_brick_slab": "Paukū Pōhakuhune Lepo",
  "block.minecraft.tuff_brick_stairs": "Alapiʻi Pōhakuhune Lepo",
  "block.minecraft.tuff_brick_wall": "Pā Pōhakuhune Lepo",
  "block.minecraft.tuff_bricks": "Pōhakuhune Lepo",
  "block.minecraft.tuff_slab": "Paukū Pōhakuhune",
  "block.minecraft.tuff_stairs": "Alapiʻi Pōhakuhune",
  "block.minecraft.tuff_wall": "Pā Pōhakuhune",
  "block.minecraft.turtle_egg": "Ka'Ōlaʻula",
  "block.minecraft.twisting_vines": "Kālī Wili",
  "block.minecraft.twisting_vines_plant": "Lāʻau Kālī Wili",
  "block.minecraft.vault": "Keʻena",
  "block.minecraft.verdant_froglight": "Lamalana Lupalupa",
  "block.minecraft.vine": "Kolokolo",
  "block.minecraft.void_air": "Ea Pō",
  "block.minecraft.wall_torch": "Paʻa Makapu",
  "block.minecraft.warped_button": "Pihi ʻEʻepa",
  "block.minecraft.warped_door": "ʻĪpuka ʻEʻepa",
  "block.minecraft.warped_fence": "Pālāʻau ʻEʻepa",
  "block.minecraft.warped_fence_gate": "ʻĪpuka Pālāʻau ʻEʻepa",
  "block.minecraft.warped_fungus": "Pepeiao ʻEʻepa",
  "block.minecraft.warped_hanging_sign": "Papa Hōʻike ʻEʻepa Kaulia",
  "block.minecraft.warped_hyphae": "Maʻawe ʻEʻepa",
  "block.minecraft.warped_nylium": "Hakuʻula ʻEʻepa",
  "block.minecraft.warped_planks": "Papalāʻau ʻEʻepa",
  "block.minecraft.warped_pressure_plate": "Papa Kaumaha ʻEʻepa",
  "block.minecraft.warped_roots": "Aʻa ʻEʻepa",
  "block.minecraft.warped_shelf": "Hakakau ʻEʻepa",
  "block.minecraft.warped_sign": "Papa Hōʻike ʻEʻepa",
  "block.minecraft.warped_slab": "Paukū ʻEʻepa",
  "block.minecraft.warped_stairs": "Alapiʻi ʻEʻepa",
  "block.minecraft.warped_stem": "Hā ʻEʻepa",
  "block.minecraft.warped_trapdoor": "ʻĪpuka ʻŪmiʻi ʻEʻepa",
  "block.minecraft.warped_wall_hanging_sign": "Papa Hōʻike ʻEʻepa Kūlewa",
  "block.minecraft.warped_wall_sign": "Papa Hōʻike ʻEʻepa Pili Paia",
  "block.minecraft.warped_wart_block": "Palaka Pepeiao ʻEʻepa",
  "block.minecraft.water": "Wai",
  "block.minecraft.water_cauldron": "Ipuhao me ka Wai",
  "block.minecraft.waxed_chiseled_copper": "Keleawe Kālaia Uepaʻia",
  "block.minecraft.waxed_copper_bars": "Kaola Keleawe Uepaʻia",
  "block.minecraft.waxed_copper_block": "Palaka Keleawe Uepaʻia",
  "block.minecraft.waxed_copper_bulb": "ʻŌpuʻu Keleawe Uepaʻia",
  "block.minecraft.waxed_copper_chain": "Kaula Keleawe Uepaʻia",
  "block.minecraft.waxed_copper_chest": "Pahu Keleawe Uepaʻia",
  "block.minecraft.waxed_copper_door": "ʻĪpuka Keleawe Uepaʻia",
  "block.minecraft.waxed_copper_golem_statue": "Kiʻi Akua-nuʻa Keleawe Uepaʻia",
  "block.minecraft.waxed_copper_grate": "Haomanamana Keleawe Uepaʻia",
  "block.minecraft.waxed_copper_lantern": "Ipukukui Keleawe Uepaʻia",
  "block.minecraft.waxed_copper_trapdoor": "ʻĪpuka ʻŪmiʻi Keleawe Uepaʻia",
  "block.minecraft.waxed_cut_copper": "Keleawe ʻŌpaka Uepaʻia",
  "block.minecraft.waxed_cut_copper_slab": "Paukū Keleawe ʻŌpaka Uepaʻia",
  "block.minecraft.waxed_cut_copper_stairs": "Alapiʻi Keleawe ʻŌpaka Uepaʻia",
  "block.minecraft.waxed_exposed_chiseled_copper": "Keleawe Ahuwale Kālaia Uepaʻia",
  "block.minecraft.waxed_exposed_copper": "Keleawe Ahuwale Uepaʻia",
  "block.minecraft.waxed_exposed_copper_bars": "Kaola Keleawe Ahuwale Uepaʻia",
  "block.minecraft.waxed_exposed_copper_bulb": "ʻŌpuʻu Keleawe Ahuwale Uepaʻia",
  "block.minecraft.waxed_exposed_copper_chain": "Kaola Keleawe Ahuwale Uepaʻia",
  "block.minecraft.waxed_exposed_copper_chest": "Pahu Keleawe Ahuwale Uepaʻia",
  "block.minecraft.waxed_exposed_copper_door": "Puka Keleawe Ahuwale Uepaʻia",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Kiʻi Akua-nuʻa Keleawe Ahuwale Uepaʻia",
  "block.minecraft.waxed_exposed_copper_grate": "Haomanamana Keleawe Ahuwale Uepaʻia",
  "block.minecraft.waxed_exposed_copper_lantern": "Ipukukui Keleawe Ahuwale Uepaʻia",
  "block.minecraft.waxed_exposed_copper_trapdoor": "ʻĪpuka ʻŪmiʻi Keleawe Ahuwale Uepaʻia",
  "block.minecraft.waxed_exposed_cut_copper": "Keleawe ʻŌpaka Ahuwale Uepaʻia",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Paukū Keleawe ʻŌpaka Ahuwale Uepaʻia",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Hoʻolaha Hōʻike ʻia ʻoki ʻia nā alapiʻi keleawe",
  "block.minecraft.waxed_exposed_lightning_rod": "Loka Pā Uila Ahuwale Uepaʻia",
  "block.minecraft.waxed_lightning_rod": "Loka Pā Uila Uepaʻia",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Keleawe Kālaia Lepohao Uepaʻia",
  "block.minecraft.waxed_oxidized_copper": "Keleawe Lepohao Uepaʻia",
  "block.minecraft.waxed_oxidized_copper_bars": "Kaola Keleawe Kūkaehao Uepaʻia",
  "block.minecraft.waxed_oxidized_copper_bulb": "ʻŌpuʻu Keleawe Lepohao Uepaʻia",
  "block.minecraft.waxed_oxidized_copper_chain": "Kaola Keleawe Ahuwale Uepaʻia",
  "block.minecraft.waxed_oxidized_copper_chest": "Pahu Keleawe Kūkaehao Uepaʻia",
  "block.minecraft.waxed_oxidized_copper_door": "ʻĪpuka Keleawe Lepohao Uepaʻia",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Kiʻi Akua-nuʻa Keleawe Kūkaehao Uepaʻia",
  "block.minecraft.waxed_oxidized_copper_grate": "Haomanamana Keleawe Lepohao Uepaʻia",
  "block.minecraft.waxed_oxidized_copper_lantern": "Ipukukui Keleawe Kūkaehao Uepaʻia",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "ʻĪpuka ʻŪmiʻi Keleawe Lepohao Uepaʻia",
  "block.minecraft.waxed_oxidized_cut_copper": "Keleawe ʻŌpaka Lepohao Uepaʻia",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Paukū Keleawe ʻŌpaka Lepohao Uepaʻia",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Alapiʻi Keleawe ʻŌpaka Lepohao Uepaʻia",
  "block.minecraft.waxed_oxidized_lightning_rod": "Loka Pā Uila Kūkaehao Uepaʻia",
  "block.minecraft.waxed_weathered_chiseled_copper": "Keleawe Lolea Kālaia Uepaʻia",
  "block.minecraft.waxed_weathered_copper": "Keleawe Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_copper_bars": "Kaola Keleawe Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_copper_bulb": "ʻŌpuʻu Keleawe Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_copper_chain": "Kaola Keleawe Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_copper_chest": "Pahu Keleawe Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_copper_door": "ʻĪpuka Keleawe Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Kiʻi Akua-nuʻa Keleawe Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_copper_grate": "Haomanamana Keleawe Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_copper_lantern": "Ipukukui Keleawe Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_copper_trapdoor": "ʻĪpuka ʻŪkiʻi Keleawe Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_cut_copper": "Keleawe ʻŌpaka Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Paukū Keleawe ʻŌpaka Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Alapiʻi Keleawe ʻŌpaka Lolea Uepaʻia",
  "block.minecraft.waxed_weathered_lightning_rod": "Loka Pā Uila Lolea Uepaʻia",
  "block.minecraft.weathered_chiseled_copper": "Keleawe Kālaia Lolea",
  "block.minecraft.weathered_copper": "Keleawe Lolea",
  "block.minecraft.weathered_copper_bars": "Kaola Keleawe Lolea",
  "block.minecraft.weathered_copper_bulb": "ʻŌpuʻu Keleawe Lolea",
  "block.minecraft.weathered_copper_chain": "Kaula Keleawe Lolea",
  "block.minecraft.weathered_copper_chest": "Pahu Keleawe Lolea",
  "block.minecraft.weathered_copper_door": "ʻĪpuka Keleawe Lolea",
  "block.minecraft.weathered_copper_golem_statue": "Kiʻi Akua-nuʻa Keleawe Lolea",
  "block.minecraft.weathered_copper_grate": "Haomanamana Keleawe Lolea",
  "block.minecraft.weathered_copper_lantern": "Ipukukui Keleawe Lolea",
  "block.minecraft.weathered_copper_trapdoor": "ʻĪpuka ʻŪmiʻi Keleawe Lolea",
  "block.minecraft.weathered_cut_copper": "Keleawe ʻŌpaka Lolea",
  "block.minecraft.weathered_cut_copper_slab": "Paukū Keleawe ʻŌpaka Lolea",
  "block.minecraft.weathered_cut_copper_stairs": "Alapiʻi Keleawe ʻŌpaka Lolea",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Kālī Uē",
  "block.minecraft.weeping_vines_plant": "Lāʻau Kālī Uē",
  "block.minecraft.wet_sponge": "Huʻakai Pulu",
  "block.minecraft.wheat": "Kanu Huika",
  "block.minecraft.white_banner": "Lepa Keʻokeʻo",
  "block.minecraft.white_bed": "Moekū Keʻokeʻo",
  "block.minecraft.white_candle": "Ihoiho Keʻokeʻo",
  "block.minecraft.white_candle_cake": "Meaʻono me Ihoiho Keʻokeʻo",
  "block.minecraft.white_carpet": "Kāpeka Keʻokeʻo",
  "block.minecraft.white_concrete": "Kimeki Keʻokeʻo",
  "block.minecraft.white_concrete_powder": "Pauka Kimeki Keʻokeʻo",
  "block.minecraft.white_glazed_terracotta": "Pālolo Keʻokeʻo ʻIliki ʻia",
  "block.minecraft.white_shulker_box": "Pahu-o-ke-Shulker Keʻokeʻo",
  "block.minecraft.white_stained_glass": "Aniani Luaʻehu Keʻokeʻo",
  "block.minecraft.white_stained_glass_pane": "ʻĀpana Aniani Luaʻehu Keʻokeʻo",
  "block.minecraft.white_terracotta": "Pālolo Keʻokeʻo",
  "block.minecraft.white_tulip": "Kulipa Keʻokeʻo",
  "block.minecraft.white_wool": "Huluhipa Keʻokeʻo",
  "block.minecraft.wildflowers": "Puaʻāhiu",
  "block.minecraft.wither_rose": "Loke-o-ka-Wither",
  "block.minecraft.wither_skeleton_skull": "Poʻo Kanakaiwi Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Pā Poʻo Kanakaiwi Wither",
  "block.minecraft.yellow_banner": "Lepa Melemele",
  "block.minecraft.yellow_bed": "Moekū Melemele",
  "block.minecraft.yellow_candle": "Ihoiho Melemele",
  "block.minecraft.yellow_candle_cake": "Meaʻono me Ihoiho Melemele",
  "block.minecraft.yellow_carpet": "Kāpeka Melemele",
  "block.minecraft.yellow_concrete": "Kimeki Melemele",
  "block.minecraft.yellow_concrete_powder": "Pauka Kimeki Melemele",
  "block.minecraft.yellow_glazed_terracotta": "Pālolo Melemele ʻIliki ʻia",
  "block.minecraft.yellow_shulker_box": "Pahu-o-ke-Shulker Melemele",
  "block.minecraft.yellow_stained_glass": "Aniani Luaʻehu Melemele",
  "block.minecraft.yellow_stained_glass_pane": "ʻĀpana Aniani Luaʻehu Melemele",
  "block.minecraft.yellow_terracotta": "Pālolo Melemele",
  "block.minecraft.yellow_wool": "Huluhipa Melemele",
  "block.minecraft.zombie_head": "Poʻo Iʻaloa",
  "block.minecraft.zombie_wall_head": "Pā Poʻo Iʻaloa",
  "item.minecraft.acacia_boat": "Waʻapā Koa",
  "item.minecraft.acacia_chest_boat": "Waʻapā Koa me Pahu",
  "item.minecraft.allay_spawn_egg": "Hua Hānau Hōʻolu",
  "item.minecraft.amethyst_shard": "Hakina ʻAmeki",
  "item.minecraft.angler_pottery_shard": "ʻO ka ʻāʻī ipu ʻāʻī",
  "item.minecraft.angler_pottery_sherd": "Māʻiʻo Lawaiʻa",
  "item.minecraft.apple": "ʻĀpala",
  "item.minecraft.archer_pottery_shard": "ʻO ka mea pana pua ʻaʻa",
  "item.minecraft.archer_pottery_sherd": "Māʻiʻo Panapua",
  "item.minecraft.armadillo_scute": "Kuapoʻi ʻAmakila",
  "item.minecraft.armadillo_spawn_egg": "Hua Hānau ʻAmakila",
  "item.minecraft.armor_stand": "Hoʻokū ʻĀmala",
  "item.minecraft.arms_up_pottery_shard": "ʻO nā lima i luna o ka ipu lepo",
  "item.minecraft.arms_up_pottery_sherd": "Māʻiʻo Hāpailima",
  "item.minecraft.arrow": "Puapana",
  "item.minecraft.axolotl_bucket": "Pākeke o Moʻo",
  "item.minecraft.axolotl_spawn_egg": "Hua Hānau Moʻo",
  "item.minecraft.baked_potato": "ʻUala Kahiki Kālua",
  "item.minecraft.bamboo_chest_raft": "Huinapapalana ʻOhe me Pahu",
  "item.minecraft.bamboo_raft": "Huinapapalana ʻOhe",
  "item.minecraft.bat_spawn_egg": "Hua Hānau ʻŌpeʻapeʻa",
  "item.minecraft.bee_spawn_egg": "Hua Hānau Nalomeli",
  "item.minecraft.beef": "ʻIʻo Pipi Kole",
  "item.minecraft.beetroot": "Pike",
  "item.minecraft.beetroot_seeds": "ʻAnoʻano Pike",
  "item.minecraft.beetroot_soup": "Kai Pike",
  "item.minecraft.birch_boat": "Waʻapā Pūkowi",
  "item.minecraft.birch_chest_boat": "Waʻapā Pūkowi me Pahu",
  "item.minecraft.black_bundle": "Pūʻolo ʻEleʻele",
  "item.minecraft.black_dye": "Waihoʻoluʻu ʻEleʻele",
  "item.minecraft.black_harness": "ʻIlikaʻa ʻEleʻele",
  "item.minecraft.blade_pottery_shard": "Maʻa ʻAi ʻAi ʻAla",
  "item.minecraft.blade_pottery_sherd": "Māʻiʻo Lapa",
  "item.minecraft.blaze_powder": "Pauka Akua-Lapa-Lele",
  "item.minecraft.blaze_rod": "Kālī Akua-Lapa-Lele",
  "item.minecraft.blaze_spawn_egg": "Hua Hānau Akua-Lapa-Lele",
  "item.minecraft.blue_bundle": "Pūʻolo Uliuli",
  "item.minecraft.blue_dye": "Waihoʻoluʻu Uliuli",
  "item.minecraft.blue_egg": "Hua Uliuli",
  "item.minecraft.blue_harness": "ʻIlikaʻa Uliuli",
  "item.minecraft.bogged_spawn_egg": "Hua Hānau Lapu-nāele",
  "item.minecraft.bolt_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Iwi",
  "item.minecraft.bone_meal": "Pela Iwi",
  "item.minecraft.book": "Puke",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Pana",
  "item.minecraft.bowl": "Pola",
  "item.minecraft.bread": "Palaoa",
  "item.minecraft.breeze_rod": "Kālī Puahio",
  "item.minecraft.breeze_spawn_egg": "Hua Hānau Puahio",
  "item.minecraft.brewer_pottery_shard": "Unu Mea Puhi",
  "item.minecraft.brewer_pottery_sherd": "Māʻiʻo Mea Puhi",
  "item.minecraft.brewing_stand": "Kū Kūʻai",
  "item.minecraft.brick": "Pōhakuʻula",
  "item.minecraft.brown_bundle": "Pūʻolo Mākuʻe",
  "item.minecraft.brown_dye": "Waihoʻoluʻu Mākuʻe",
  "item.minecraft.brown_egg": "Hua Mākuʻe",
  "item.minecraft.brown_harness": "ʻIlikaʻa Mākuʻe",
  "item.minecraft.brush": "Palaki",
  "item.minecraft.bucket": "Pākeke",
  "item.minecraft.bundle": "Pūʻolo",
  "item.minecraft.bundle.empty": "Hakahaka",
  "item.minecraft.bundle.empty.description": "Hiki ke hāpai i kēlā me kēia ʻano mea",
  "item.minecraft.bundle.full": "Piha",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Unu Hoʻā",
  "item.minecraft.burn_pottery_sherd": "Māʻiʻo Hoʻā",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Hua Hānau Kāmelo",
  "item.minecraft.carrot": "Kāloke",
  "item.minecraft.carrot_on_a_stick": "Koi me ke Kāloke",
  "item.minecraft.cat_spawn_egg": "Hua Hānau Pōpoki",
  "item.minecraft.cauldron": "Ipuhao",
  "item.minecraft.cave_spider_spawn_egg": "Hua Hānau Nananana Ana",
  "item.minecraft.chainmail_boots": "Puki Kaulahao",
  "item.minecraft.chainmail_chestplate": "Pale Umauma Kaulahao",
  "item.minecraft.chainmail_helmet": "Mahiole Kaulahao",
  "item.minecraft.chainmail_leggings": "Lole Wāwae Kaulahao",
  "item.minecraft.charcoal": "Nānahu",
  "item.minecraft.cherry_boat": "Waʻapā Keli",
  "item.minecraft.cherry_chest_boat": "Waʻapā Keli me Pahu",
  "item.minecraft.chest_minecart": "Kaʻa-mine me Pahu",
  "item.minecraft.chicken": "ʻIʻo Moa Kole",
  "item.minecraft.chicken_spawn_egg": "Hua Hānau Moa",
  "item.minecraft.chorus_fruit": "Hua Kanikau",
  "item.minecraft.clay_ball": "Pōpō Pālolo",
  "item.minecraft.clock": "Uaki",
  "item.minecraft.coal": "Lānahu",
  "item.minecraft.coast_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "ʻAnoʻano Kōkō",
  "item.minecraft.cod": "Pakaliao Maka",
  "item.minecraft.cod_bucket": "Pākeke o Pakaliao",
  "item.minecraft.cod_spawn_egg": "Hua Hānau Pakaliao",
  "item.minecraft.command_block_minecart": "Kaʻa-mine me Palaka Kauoha",
  "item.minecraft.compass": "Pānānā",
  "item.minecraft.cooked_beef": "Pipi Kōʻala",
  "item.minecraft.cooked_chicken": "Moa Moʻa",
  "item.minecraft.cooked_cod": "Pakaliao Moʻa",
  "item.minecraft.cooked_mutton": "ʻIʻo Hipa Kōʻala",
  "item.minecraft.cooked_porkchop": "ʻIʻo Puaʻa Kōʻala",
  "item.minecraft.cooked_rabbit": "Lāpaki Moʻa",
  "item.minecraft.cooked_salmon": "Kāmano Moʻa",
  "item.minecraft.cookie": "Kuki",
  "item.minecraft.copper_axe": "Koʻi Keleawe",
  "item.minecraft.copper_boots": "Puki Keleawe",
  "item.minecraft.copper_chestplate": "Pale Umauma Keleawe",
  "item.minecraft.copper_golem_spawn_egg": "Hua Hānau Akua-nuʻa Keleawe",
  "item.minecraft.copper_helmet": "Mahiole Keleawe",
  "item.minecraft.copper_hoe": "Hō Keleawe",
  "item.minecraft.copper_horse_armor": "ʻĀmala Lio Keleawe",
  "item.minecraft.copper_ingot": "ʻAukā Keleawe",
  "item.minecraft.copper_leggings": "Lole Wāwae Keleawe",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Puʻupuʻu Keleawe",
  "item.minecraft.copper_pickaxe": "Kipikua Keleawe",
  "item.minecraft.copper_shovel": "Kopalā Keleawe",
  "item.minecraft.copper_spear": "Ihe Keleawe",
  "item.minecraft.copper_sword": "Pahikaua Keleawe",
  "item.minecraft.cow_spawn_egg": "Hua Hānau Pipi",
  "item.minecraft.creaking_spawn_egg": "Hua Hānau Manunu",
  "item.minecraft.creeper_banner_pattern": "Lau Lepa",
  "item.minecraft.creeper_banner_pattern.desc": "Lepa ʻAno Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Lepa ʻAno Creeper",
  "item.minecraft.creeper_spawn_egg": "Hua Hānau Kilīpa",
  "item.minecraft.crossbow": "Kakaka",
  "item.minecraft.crossbow.projectile": "Puapana:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Pūʻolo Mamaʻo",
  "item.minecraft.cyan_dye": "Waihoʻoluʻu Mamaʻo",
  "item.minecraft.cyan_harness": "ʻIlikaʻa Mamaʻo",
  "item.minecraft.danger_pottery_shard": "Unu Makaʻu",
  "item.minecraft.danger_pottery_sherd": "Māʻiʻo Makaʻu",
  "item.minecraft.dark_oak_boat": "Pouli ʻOke lāʻau moku",
  "item.minecraft.dark_oak_chest_boat": "Waʻapā ʻOka ʻElemoe me Pahu",
  "item.minecraft.debug_stick": "Laau Hoʻoiho",
  "item.minecraft.debug_stick.empty": "ʻAʻohe ʻanopili o %s",
  "item.minecraft.debug_stick.select": "koho ʻia \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" i mea e %s",
  "item.minecraft.diamond": "Kaimana",
  "item.minecraft.diamond_axe": "Koʻi Kaimana",
  "item.minecraft.diamond_boots": "Puki Kaimana",
  "item.minecraft.diamond_chestplate": "Pale Umauma Kaimana",
  "item.minecraft.diamond_helmet": "Mahiole Kaimana",
  "item.minecraft.diamond_hoe": "Hō Kaimana",
  "item.minecraft.diamond_horse_armor": "ʻĀmala Lio Kaimana",
  "item.minecraft.diamond_leggings": "Lole Wāwae Kaimana",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Kipikua Kaimana",
  "item.minecraft.diamond_shovel": "Kopalā Kaimana",
  "item.minecraft.diamond_spear": "Ihe Kaimana",
  "item.minecraft.diamond_sword": "Pahikaua Kaimana",
  "item.minecraft.disc_fragment_5": "Māhele Disc",
  "item.minecraft.disc_fragment_5.desc": "Mele mele -ʻelima",
  "item.minecraft.dolphin_spawn_egg": "Hua Hānau Naiʻa",
  "item.minecraft.donkey_spawn_egg": "Hua Hānau Kēkake",
  "item.minecraft.dragon_breath": "Aho-a-ke-Kalekona",
  "item.minecraft.dried_kelp": "Limu Pīkaʻo",
  "item.minecraft.drowned_spawn_egg": "Hua Hānau Piholo",
  "item.minecraft.dune_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Echo Shard",
  "item.minecraft.egg": "Hua",
  "item.minecraft.elder_guardian_spawn_egg": "Hua Hānau Kiaʻi Kahiko",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "ʻŌmaʻomaʻo",
  "item.minecraft.enchanted_book": "Puke Hoʻokalakupua",
  "item.minecraft.enchanted_golden_apple": "ʻĀpala Kula Kalakupua",
  "item.minecraft.end_crystal": "Enekela Aʻiaʻi",
  "item.minecraft.ender_dragon_spawn_egg": "Hua Hānau Kalekona Ender",
  "item.minecraft.ender_eye": "ʻŌnohi-o-Ender",
  "item.minecraft.ender_pearl": "Momi-o-Ender",
  "item.minecraft.enderman_spawn_egg": "Hua Hānau Enderman",
  "item.minecraft.endermite_spawn_egg": "Hua Hānau Endermite",
  "item.minecraft.evoker_spawn_egg": "Hua Hānau Moʻokiko",
  "item.minecraft.experience_bottle": "ʻŌmole Hoʻokalakupua",
  "item.minecraft.explorer_pottery_shard": "Unu ʻImiloa",
  "item.minecraft.explorer_pottery_sherd": "Māʻiʻo ʻImiloa",
  "item.minecraft.eye_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Hulu",
  "item.minecraft.fermented_spider_eye": "Maka Nananana Huaʻā",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Palapalaʻāina",
  "item.minecraft.fire_charge": "Pōpōahi",
  "item.minecraft.firework_rocket": "Ahikao",
  "item.minecraft.firework_rocket.flight": "Lōʻihi Lele:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "ʻŌahi",
  "item.minecraft.firework_star.black": "ʻEleʻele",
  "item.minecraft.firework_star.blue": "Uliuli",
  "item.minecraft.firework_star.brown": "Palaʻunu",
  "item.minecraft.firework_star.custom_color": "Koho",
  "item.minecraft.firework_star.cyan": "Mamaʻo",
  "item.minecraft.firework_star.fade_to": "Mae",
  "item.minecraft.firework_star.flicker": "ʻOaka",
  "item.minecraft.firework_star.gray": "ʻĀhinahina",
  "item.minecraft.firework_star.green": "ʻŌmaʻomaʻo",
  "item.minecraft.firework_star.light_blue": "ʻUkiʻuki",
  "item.minecraft.firework_star.light_gray": "ʻĀhiehie",
  "item.minecraft.firework_star.lime": "Laimi",
  "item.minecraft.firework_star.magenta": "ʻUlamākuʻe",
  "item.minecraft.firework_star.orange": "ʻAlani",
  "item.minecraft.firework_star.pink": "ʻĀkala",
  "item.minecraft.firework_star.purple": "Poni",
  "item.minecraft.firework_star.red": "ʻUlaʻula",
  "item.minecraft.firework_star.shape": "Kino ʻIke ʻOle ʻia",
  "item.minecraft.firework_star.shape.burst": "Pahū",
  "item.minecraft.firework_star.shape.creeper": "Kino-o-ke-Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Pōpō Nui",
  "item.minecraft.firework_star.shape.small_ball": "Pōpō Liʻi",
  "item.minecraft.firework_star.shape.star": "Kino-ʻano-hōkū",
  "item.minecraft.firework_star.trail": "Welowelo",
  "item.minecraft.firework_star.white": "Keʻokeʻo",
  "item.minecraft.firework_star.yellow": "Melemele",
  "item.minecraft.fishing_rod": "Mākoi",
  "item.minecraft.flint": "Pohaku Paea",
  "item.minecraft.flint_and_steel": "Pohaku paea, a me kila",
  "item.minecraft.flow_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Hoʻonani ʻĀmala o ka Nalu",
  "item.minecraft.flow_banner_pattern": "Lau Lepa",
  "item.minecraft.flow_banner_pattern.desc": "Nalu",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Māʻiʻo Nalu",
  "item.minecraft.flower_banner_pattern": "Lau Lepa",
  "item.minecraft.flower_banner_pattern.desc": "Lepa Pua",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Poho Meakanu",
  "item.minecraft.fox_spawn_egg": "Hua Hānau ʻAlopeke",
  "item.minecraft.friend_pottery_shard": "Unu Hoaaloha",
  "item.minecraft.friend_pottery_sherd": "Māʻiʻo Hoaaloha",
  "item.minecraft.frog_spawn_egg": "Hua Hānau Poloka",
  "item.minecraft.furnace_minecart": "Kaʻa-mine me Umu",
  "item.minecraft.ghast_spawn_egg": "Hua Hānau Ghast",
  "item.minecraft.ghast_tear": "Waimaka-o-ka-Ghast",
  "item.minecraft.glass_bottle": "ʻŌmole",
  "item.minecraft.glistering_melon_slice": "ʻĀpana Ipuhaole ʻAnapa",
  "item.minecraft.globe_banner_pattern": "Lau Lepa",
  "item.minecraft.globe_banner_pattern.desc": "Poepoehonua",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Pīʻai ʻAlohi",
  "item.minecraft.glow_ink_sac": "ʻAlaʻala ʻĀlohi",
  "item.minecraft.glow_item_frame": "Glame Item Frame",
  "item.minecraft.glow_squid_spawn_egg": "Hua Hānau Mūheʻe Hāweo",
  "item.minecraft.glowstone_dust": "Pauka Pōhaku-lohi",
  "item.minecraft.goat_horn": "Pū Kiwi Kao",
  "item.minecraft.goat_spawn_egg": "Hua Hānau Kao",
  "item.minecraft.gold_ingot": "ʻAukā Kula",
  "item.minecraft.gold_nugget": "Puʻupuʻu Kula",
  "item.minecraft.golden_apple": "ʻĀpala Kula",
  "item.minecraft.golden_axe": "Koʻi Kula",
  "item.minecraft.golden_boots": "Puki Kula",
  "item.minecraft.golden_carrot": "Kāloke Kula",
  "item.minecraft.golden_chestplate": "Pale Umauma Kula",
  "item.minecraft.golden_helmet": "Mahiole Kula",
  "item.minecraft.golden_hoe": "Hō Kula",
  "item.minecraft.golden_horse_armor": "ʻĀmala Lio Kula",
  "item.minecraft.golden_leggings": "Lole Wāwae Kula",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Kipikua Kula",
  "item.minecraft.golden_shovel": "Kopalā Kula",
  "item.minecraft.golden_spear": "Ihe Kula",
  "item.minecraft.golden_sword": "Pahikaua Kula",
  "item.minecraft.gray_bundle": "Pūʻolo ʻĀhinahina",
  "item.minecraft.gray_dye": "Waihoʻoluʻu ʻĀhinahina",
  "item.minecraft.gray_harness": "ʻIlikaʻa Hinahina",
  "item.minecraft.green_bundle": "Pūʻolo ʻŌmaʻomaʻo",
  "item.minecraft.green_dye": "Waihoʻoluʻu ʻŌmaʻomaʻo",
  "item.minecraft.green_harness": "ʻIlikaʻa ʻŌmaʻomaʻo",
  "item.minecraft.guardian_spawn_egg": "Hua Hānau Kiaʻi",
  "item.minecraft.gunpowder": "Pauka kī pū",
  "item.minecraft.guster_banner_pattern": "Lau Lepa",
  "item.minecraft.guster_banner_pattern.desc": "Hae Puahio",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Māʻiʻo Puahio",
  "item.minecraft.happy_ghast_spawn_egg": "Hua Hānau Ghast-o-Hauʻoli",
  "item.minecraft.harness": "ʻIlikaʻa",
  "item.minecraft.heart_of_the_sea": "Puʻuwai o ke kai",
  "item.minecraft.heart_pottery_shard": "Unu Puʻuwai",
  "item.minecraft.heart_pottery_sherd": "Māʻiʻo Puʻuwai",
  "item.minecraft.heartbreak_pottery_shard": "Unu ʻEha-i-ke-aloha",
  "item.minecraft.heartbreak_pottery_sherd": "Māʻiʻo ʻEha-i-ke-aloha",
  "item.minecraft.hoglin_spawn_egg": "Hua Hānau Hoglin",
  "item.minecraft.honey_bottle": "ʻŌmole Meli",
  "item.minecraft.honeycomb": "Waihona Meli",
  "item.minecraft.hopper_minecart": "Kaʻa-mine me Kānuku",
  "item.minecraft.horse_spawn_egg": "Hua Hānau Lio",
  "item.minecraft.host_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Unu ʻUō",
  "item.minecraft.howl_pottery_sherd": "Māʻiʻo ʻUō",
  "item.minecraft.husk_spawn_egg": "Hua Hānau Iwimaloʻo",
  "item.minecraft.ink_sac": "ʻAlaʻala",
  "item.minecraft.iron_axe": "Koʻi Hao",
  "item.minecraft.iron_boots": "Puki Hao",
  "item.minecraft.iron_chestplate": "Pale Umauma Hao",
  "item.minecraft.iron_golem_spawn_egg": "Hua Hānau Akua-nuʻa Hao",
  "item.minecraft.iron_helmet": "Mahiole Hao",
  "item.minecraft.iron_hoe": "Hō Hao",
  "item.minecraft.iron_horse_armor": "ʻĀmala Lio Hao",
  "item.minecraft.iron_ingot": "ʻAukā Hao",
  "item.minecraft.iron_leggings": "Lole Wāwae Hao",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Puʻupuʻu Hao",
  "item.minecraft.iron_pickaxe": "Kipikua Hao",
  "item.minecraft.iron_shovel": "Kopalā Hao",
  "item.minecraft.iron_spear": "Ihe Hao",
  "item.minecraft.iron_sword": "Pahikaua Hao",
  "item.minecraft.item_frame": "Pākuʻi huahana",
  "item.minecraft.jungle_boat": "Waʻapā Ulunahele",
  "item.minecraft.jungle_chest_boat": "Waʻapā Ulunahele me Pahu",
  "item.minecraft.knowledge_book": "Puke Aʻo",
  "item.minecraft.lapis_lazuli": "Uliuli",
  "item.minecraft.lava_bucket": "Pākeke o Pele",
  "item.minecraft.lead": "Kaulakaʻi",
  "item.minecraft.leather": "ʻIli Holoholona",
  "item.minecraft.leather_boots": "Puki ʻIli",
  "item.minecraft.leather_chestplate": "ʻAʻahu ʻIli",
  "item.minecraft.leather_helmet": "Pāpale ʻIli",
  "item.minecraft.leather_horse_armor": "ʻĀmala Lio ʻIli",
  "item.minecraft.leather_leggings": "Lole Wāwae ʻIli",
  "item.minecraft.light_blue_bundle": "Pūʻolo ʻUkiʻuki",
  "item.minecraft.light_blue_dye": "Waihoʻoluʻu ʻUkiʻuki",
  "item.minecraft.light_blue_harness": "ʻIlikaʻa ʻUkiʻuki",
  "item.minecraft.light_gray_bundle": "Pūʻolo ʻĀhiehie",
  "item.minecraft.light_gray_dye": "Waihoʻoluʻu ʻĀhiehie",
  "item.minecraft.light_gray_harness": "ʻIlikaʻa ʻĀhiehie",
  "item.minecraft.lime_bundle": "Pūʻolo Laimi",
  "item.minecraft.lime_dye": "Waihoʻoluʻu Laimi",
  "item.minecraft.lime_harness": "ʻIlikaʻa Laimi",
  "item.minecraft.lingering_potion": "ʻApu Noe",
  "item.minecraft.lingering_potion.effect.awkward": "ʻApu Kumu Noe",
  "item.minecraft.lingering_potion.effect.empty": "ʻApu Noe Hiki ʻOle ke Hana ʻia",
  "item.minecraft.lingering_potion.effect.fire_resistance": "ʻApu Noe Hōʻalo ʻĀ",
  "item.minecraft.lingering_potion.effect.harming": "ʻApu Noe Hoʻopilikia",
  "item.minecraft.lingering_potion.effect.healing": "ʻApu Noe Hoʻōla",
  "item.minecraft.lingering_potion.effect.infested": "ʻApu Noe Hoʻopopopo",
  "item.minecraft.lingering_potion.effect.invisibility": "ʻApu Noe Hoʻohūnā",
  "item.minecraft.lingering_potion.effect.leaping": "ʻApu Noe Hoʻolele",
  "item.minecraft.lingering_potion.effect.levitation": "ʻApu Noe Hoʻokauaheahe",
  "item.minecraft.lingering_potion.effect.luck": "ʻApu Kali Hoʻolaki",
  "item.minecraft.lingering_potion.effect.mundane": "ʻApu Noe Hana ʻOle",
  "item.minecraft.lingering_potion.effect.night_vision": "ʻApu Kali Hōʻike-i-ka-Pō",
  "item.minecraft.lingering_potion.effect.oozing": "ʻApu Noe Hākelo",
  "item.minecraft.lingering_potion.effect.poison": "ʻApu Noe Kōheoheo",
  "item.minecraft.lingering_potion.effect.regeneration": "ʻApu Noe Pāola",
  "item.minecraft.lingering_potion.effect.slow_falling": "ʻApu Noe Hāʻule Mālie",
  "item.minecraft.lingering_potion.effect.slowness": "ʻApu Noe Hoʻolohi",
  "item.minecraft.lingering_potion.effect.strength": "ʻApu Noe Hoʻoikaika",
  "item.minecraft.lingering_potion.effect.swiftness": "ʻApu Noe Hoʻohikiwawe",
  "item.minecraft.lingering_potion.effect.thick": "ʻApu Noe Kūpū",
  "item.minecraft.lingering_potion.effect.turtle_master": "ʻApu Noe o ke Kahuna Honu",
  "item.minecraft.lingering_potion.effect.water": "ʻApu Kēwai",
  "item.minecraft.lingering_potion.effect.water_breathing": "ʻApu Noe Hoʻohanu-i-ke-Kai",
  "item.minecraft.lingering_potion.effect.weakness": "ʻApu Noe Hoʻonāwali",
  "item.minecraft.lingering_potion.effect.weaving": "ʻApu Noe Hoʻopūnāwelewele",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Hua Hānau ʻAlapaka",
  "item.minecraft.lodestone_compass": "ʻŪpā Pōhaku Mākēneki",
  "item.minecraft.mace": "Koʻokoʻo",
  "item.minecraft.magenta_bundle": "Pūʻolo ʻUlamākuʻe",
  "item.minecraft.magenta_dye": "Waihoʻoluʻu ʻUlamākuʻe",
  "item.minecraft.magenta_harness": "ʻIlikaʻa ʻUlamākuʻe",
  "item.minecraft.magma_cream": "Kalima Pele",
  "item.minecraft.magma_cube_spawn_egg": "Hua Hānau Kupa-o-Pele",
  "item.minecraft.mangrove_boat": "Waʻapā Kukunaokalā",
  "item.minecraft.mangrove_chest_boat": "Waʻapā Kukunaokalā me Pahu",
  "item.minecraft.map": "Palapalaʻāina Hakahaka",
  "item.minecraft.melon_seeds": "ʻAnoʻano Ipuhaole",
  "item.minecraft.melon_slice": "ʻĀpana Ipuhaole",
  "item.minecraft.milk_bucket": "Pākeke o Waiū",
  "item.minecraft.minecart": "Kaʻa-mine",
  "item.minecraft.miner_pottery_shard": "Unu Mine",
  "item.minecraft.miner_pottery_sherd": "Māʻiʻo Mine",
  "item.minecraft.mojang_banner_pattern": "Lau Lepa",
  "item.minecraft.mojang_banner_pattern.desc": "Mea",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Hua Hānau Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Unu Makena",
  "item.minecraft.mourner_pottery_sherd": "Māʻiʻo Makena",
  "item.minecraft.mule_spawn_egg": "Hua Hānau Piula",
  "item.minecraft.mushroom_stew": "Kai Melehune",
  "item.minecraft.music_disc_11": "Disc Music",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Pā hoʻokani",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disc Music",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Pā Sēdē",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Pā Sēdē",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Pā Sēdē",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Pā",
  "item.minecraft.music_disc_creator.desc": "Lena Reine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Pā",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Reine - Creator (Pahu Hoʻokani Pila)",
  "item.minecraft.music_disc_far": "Pā Sēdē",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Pā Sēdē",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Pā Sēdē",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Pā Sēdē",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Pā Hoʻokani Pila",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Pā Sēdē",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Sēdē Hoʻokani Pila",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disc Music",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disc Music",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disc Music",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Pā Hoʻokani Pila",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "ʻIʻo Hipa Kole",
  "item.minecraft.name_tag": "Inoa Mekala",
  "item.minecraft.nautilus_shell": "Kaheilus Hauʻoli",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Pōhakulepo-o-ka-Nether",
  "item.minecraft.nether_star": "Hōkū-o-ka-Nether",
  "item.minecraft.nether_wart": "Pepeiao-o-ka-Nether",
  "item.minecraft.netherite_axe": "Koʻi Hao-o-ka-Nether",
  "item.minecraft.netherite_boots": "Puki Hao-o-ka-Nether",
  "item.minecraft.netherite_chestplate": "Pale Umauma Hao-o-ka-Nether",
  "item.minecraft.netherite_helmet": "Mahiole Hao-o-ka-Nether",
  "item.minecraft.netherite_hoe": "Hō Hao-o-ka-Nether",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "ʻAukā Hao-o-ka-Nether",
  "item.minecraft.netherite_leggings": "Lole Wāwae Hao-o-ka-Nether",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Kipikua Hao-o-ka-Nether",
  "item.minecraft.netherite_scrap": "Huna Hao-o-ka-Nether",
  "item.minecraft.netherite_shovel": "Kopalā Hao-o-ka-Nether",
  "item.minecraft.netherite_spear": "Ihe Hao-o-ka-Nether",
  "item.minecraft.netherite_sword": "Pahikaua Hao-o-ka-Nether",
  "item.minecraft.netherite_upgrade_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Waʻapā ʻOka",
  "item.minecraft.oak_chest_boat": "Waʻapā ʻOka me Pahu",
  "item.minecraft.ocelot_spawn_egg": "Hua Hānau Iākua",
  "item.minecraft.ominous_bottle": "ʻŌmole Pōʻino",
  "item.minecraft.ominous_trial_key": "Kī Hoʻonahoa Pōʻino",
  "item.minecraft.orange_bundle": "Pūʻolo ʻĀlani",
  "item.minecraft.orange_dye": "Waihoʻoluʻu ʻĀlani",
  "item.minecraft.orange_harness": "ʻIlikaʻa ʻAlani",
  "item.minecraft.painting": "Pena",
  "item.minecraft.pale_oak_boat": "Waʻapā ʻOka Haʻakea",
  "item.minecraft.pale_oak_chest_boat": "Waʻapā ʻOka Haʻakea me Pahu",
  "item.minecraft.panda_spawn_egg": "Hua Hānau Pea Kina",
  "item.minecraft.paper": "Pepa",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Hua Hānau Manualoha",
  "item.minecraft.phantom_membrane": "ʻIʻo Aumiha",
  "item.minecraft.phantom_spawn_egg": "Hua Hānau Aumiha",
  "item.minecraft.pig_spawn_egg": "Hua Hānau Puaʻa",
  "item.minecraft.piglin_banner_pattern": "Lau Lepa",
  "item.minecraft.piglin_banner_pattern.desc": "Nuku",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Hua Hānau Piglin Lokoʻino",
  "item.minecraft.piglin_spawn_egg": "Hua Hānau Piglin",
  "item.minecraft.pillager_spawn_egg": "Hua Hānau Kuewa",
  "item.minecraft.pink_bundle": "Pūʻolo ʻĀkala",
  "item.minecraft.pink_dye": "Waihoʻoluʻu ʻĀkala",
  "item.minecraft.pink_harness": "ʻIlikaʻa ʻĀkala",
  "item.minecraft.pitcher_plant": "Kanu Pikele",
  "item.minecraft.pitcher_pod": "Wahī ʻAnoʻano Pikele",
  "item.minecraft.plenty_pottery_shard": "Unu Lawapono",
  "item.minecraft.plenty_pottery_sherd": "Māʻiʻo Lawapono",
  "item.minecraft.poisonous_potato": "ʻUala Alapuka",
  "item.minecraft.polar_bear_spawn_egg": "Hua Hānau Pea ʻĀlika",
  "item.minecraft.popped_chorus_fruit": "Hua Kanikau Pohāpohā",
  "item.minecraft.porkchop": "ʻIʻo Puaʻa Kole",
  "item.minecraft.potato": "ʻUala kahiki",
  "item.minecraft.potion": "ʻApu",
  "item.minecraft.potion.effect.awkward": "ʻApu Kumu",
  "item.minecraft.potion.effect.empty": "ʻApu Hiki ʻOle Ke Hana",
  "item.minecraft.potion.effect.fire_resistance": "ʻApu Hōʻalo ʻĀ",
  "item.minecraft.potion.effect.harming": "ʻApu Hōʻeha",
  "item.minecraft.potion.effect.healing": "Laau Hoola",
  "item.minecraft.potion.effect.infested": "ʻApu Hoʻopopopo",
  "item.minecraft.potion.effect.invisibility": "ʻApu Hoʻohūnā",
  "item.minecraft.potion.effect.leaping": "ʻApu Hoʻolele",
  "item.minecraft.potion.effect.levitation": "ʻApu Hoʻokauaheahe",
  "item.minecraft.potion.effect.luck": "Laki Laki",
  "item.minecraft.potion.effect.mundane": "ʻApu Hana ʻOle",
  "item.minecraft.potion.effect.night_vision": "ʻApu Hōʻike-i-ka-Pō",
  "item.minecraft.potion.effect.oozing": "ʻApu Hākelo",
  "item.minecraft.potion.effect.poison": "ʻApu Kōheoheo",
  "item.minecraft.potion.effect.regeneration": "ʻApu Pāola",
  "item.minecraft.potion.effect.slow_falling": "ʻApu Hoʻolohi Hina",
  "item.minecraft.potion.effect.slowness": "ʻApu Hoʻolohi",
  "item.minecraft.potion.effect.strength": "Laau o ka ikaika",
  "item.minecraft.potion.effect.swiftness": "ʻApu Hoʻohikiwawe",
  "item.minecraft.potion.effect.thick": "ʻApu Kūpū",
  "item.minecraft.potion.effect.turtle_master": "ʻApu o ke Kahuna Honu",
  "item.minecraft.potion.effect.water": "ʻŌmole Wai",
  "item.minecraft.potion.effect.water_breathing": "ʻApu Hoʻohanu-i-ke-Kai",
  "item.minecraft.potion.effect.weakness": "ʻApu Hoʻonāwali",
  "item.minecraft.potion.effect.weaving": "ʻApu Hoʻopūnāwelewele",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Māʻiʻo Panapua",
  "item.minecraft.pottery_shard_arms_up": "Māʻiʻo Hāpailima",
  "item.minecraft.pottery_shard_prize": "Māʻiʻo Waiwai",
  "item.minecraft.pottery_shard_skull": "Māʻiʻo Poʻo Iwi",
  "item.minecraft.powder_snow_bucket": "Pākeke o Haukea",
  "item.minecraft.prismarine_crystals": "Aʻiaʻi Pelikamalina",
  "item.minecraft.prismarine_shard": "Māmala Pelikamalina",
  "item.minecraft.prize_pottery_shard": "Unu Waiwai",
  "item.minecraft.prize_pottery_sherd": "Māʻiʻo Waiwai",
  "item.minecraft.pufferfish": "ʻOʻopuhue",
  "item.minecraft.pufferfish_bucket": "Pākeke o ʻOʻopuhue",
  "item.minecraft.pufferfish_spawn_egg": "Hua Hānau ʻOʻopuhue",
  "item.minecraft.pumpkin_pie": "Pai Palaʻai",
  "item.minecraft.pumpkin_seeds": "ʻAnoʻano Palaʻai",
  "item.minecraft.purple_bundle": "Pūʻolo Poni",
  "item.minecraft.purple_dye": "Waihoʻoluʻu Poni",
  "item.minecraft.purple_harness": "ʻIlikaʻa Poni",
  "item.minecraft.quartz": "Pōhakuaʻiaʻi-o-ka-Nether",
  "item.minecraft.rabbit": "Lāpaki Maka",
  "item.minecraft.rabbit_foot": "Wāwae Lāpaki",
  "item.minecraft.rabbit_hide": "ʻIli Lāpaki",
  "item.minecraft.rabbit_spawn_egg": "Hua Hānau Lāpaki",
  "item.minecraft.rabbit_stew": "Kai Lāpaki",
  "item.minecraft.raiser_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Hua Hānau Pehemo",
  "item.minecraft.raw_copper": "Keleawe Hou",
  "item.minecraft.raw_gold": "Kula Hou",
  "item.minecraft.raw_iron": "Hao Hou",
  "item.minecraft.recovery_compass": "Panana ho'ōla",
  "item.minecraft.red_bundle": "Pūʻolo ʻUlaʻula",
  "item.minecraft.red_dye": "Waihoʻoluʻu ʻUlaʻula",
  "item.minecraft.red_harness": "ʻIlikaʻa ʻUlaʻula",
  "item.minecraft.redstone": "Pauka o Redstone",
  "item.minecraft.resin_brick": "Pōhaku Lepo Hūkaʻa",
  "item.minecraft.resin_clump": "Ōpū Hūkaʻa",
  "item.minecraft.rib_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "ʻIʻo Pilau",
  "item.minecraft.saddle": "Noho Lio",
  "item.minecraft.salmon": "Kāmano Maka",
  "item.minecraft.salmon_bucket": "Pākeke o Kāmano",
  "item.minecraft.salmon_spawn_egg": "Hua Hānau Kāmano",
  "item.minecraft.scrape_pottery_sherd": "Māʻiʻo Māwae",
  "item.minecraft.scute": "Kuapoʻi",
  "item.minecraft.sentry_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Unu Huika",
  "item.minecraft.sheaf_pottery_sherd": "Māʻiʻo Huika",
  "item.minecraft.shears": "ʻŪpā",
  "item.minecraft.sheep_spawn_egg": "Hua Hānau Hipa",
  "item.minecraft.shelter_pottery_shard": "Unu Wahilulu",
  "item.minecraft.shelter_pottery_sherd": "Māʻiʻo Wahilulu",
  "item.minecraft.shield": "Palekaua",
  "item.minecraft.shield.black": "Palekaua ʻEleʻele",
  "item.minecraft.shield.blue": "Palekaua Uliuli",
  "item.minecraft.shield.brown": "Palekaua Mākuʻe",
  "item.minecraft.shield.cyan": "Palekaua Mamaʻo",
  "item.minecraft.shield.gray": "Palekaua ʻĀhinahina",
  "item.minecraft.shield.green": "Palekaua ʻŌmaʻomaʻo",
  "item.minecraft.shield.light_blue": "Palekaua ʻUkiʻuki",
  "item.minecraft.shield.light_gray": "Palekaua ʻĀhiehie",
  "item.minecraft.shield.lime": "Palekaua Laimi",
  "item.minecraft.shield.magenta": "Palekaua ʻUlamākuʻe",
  "item.minecraft.shield.orange": "Palekaua ʻAlani",
  "item.minecraft.shield.pink": "Palekaua ʻUlamākuʻe",
  "item.minecraft.shield.purple": "Palekaua Poni",
  "item.minecraft.shield.red": "Palekaua ʻUlaʻula",
  "item.minecraft.shield.white": "Palekaua Keʻokeʻo",
  "item.minecraft.shield.yellow": "Palekaua Melemele",
  "item.minecraft.shulker_shell": "Iwi-o-ka-Shulker",
  "item.minecraft.shulker_spawn_egg": "Hua Hānau Shulker",
  "item.minecraft.sign": "Papa Hōʻike",
  "item.minecraft.silence_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Hua Hānau Huhu-pōhaku",
  "item.minecraft.skeleton_horse_spawn_egg": "Hua Hānau Lio Kinoiwi",
  "item.minecraft.skeleton_spawn_egg": "Hua Hānau Kanakaiwi",
  "item.minecraft.skull_banner_pattern": "Lau Lepa",
  "item.minecraft.skull_banner_pattern.desc": "Lepa Poʻo Iwi",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Unu Poʻo Iwi",
  "item.minecraft.skull_pottery_sherd": "Māʻiʻo Poʻo Iwi",
  "item.minecraft.slime_ball": "Walewalena",
  "item.minecraft.slime_spawn_egg": "Hua Hānau Kelo",
  "item.minecraft.smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.smithing_template.applies_to": "Pili i:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Hoʻohui i ʻaukā a i ʻole i pōhaku makamae",
  "item.minecraft.smithing_template.armor_trim.applies_to": "ʻĀmala",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Hoʻohui i ʻāpana ʻāmala",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Poʻe ʻAukā & Pōhaku Aʻiaʻi",
  "item.minecraft.smithing_template.ingredients": "Nā mea komo:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Hoʻohui aʻe i ʻAukā Hao-o-ka-Nether",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Lako Kaimana",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Hoʻohui kekahi o ke ʻano kaimana penei: ʻāmala, meakaua, meahana",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "ʻAukā Hao-o-ka-Nether",
  "item.minecraft.smithing_template.upgrade": "Hoʻomaikaʻi: ",
  "item.minecraft.sniffer_spawn_egg": "Hua Hānau Hanuhanu",
  "item.minecraft.snort_pottery_shard": "Unu Hanu",
  "item.minecraft.snort_pottery_sherd": "Māʻiʻo Hanu",
  "item.minecraft.snout_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Hua Hānau Akua-nuʻa Haukea",
  "item.minecraft.snowball": "Pōpōhau",
  "item.minecraft.spectral_arrow": "Puapana Makaʻike",
  "item.minecraft.spider_eye": "Maka Nananana",
  "item.minecraft.spider_spawn_egg": "Hua Hānau Nananana",
  "item.minecraft.spire_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "ʻApu Hoʻopakī",
  "item.minecraft.splash_potion.effect.awkward": "'Apu Kumu Hoʻopakī",
  "item.minecraft.splash_potion.effect.empty": "ʻApu Hoʻopakī ʻAʻole Hiki ke Hana ʻia",
  "item.minecraft.splash_potion.effect.fire_resistance": "ʻApu Hoʻopakī Hōʻalo ʻĀ",
  "item.minecraft.splash_potion.effect.harming": "ʻApu Hoʻopakī Hōʻeha",
  "item.minecraft.splash_potion.effect.healing": "ʻApu Hoʻopakī Hoʻōla",
  "item.minecraft.splash_potion.effect.infested": "ʻApu Hoʻopakī Hoʻopopopo",
  "item.minecraft.splash_potion.effect.invisibility": "ʻApu Hoʻopakī Hoʻohūnā",
  "item.minecraft.splash_potion.effect.leaping": "ʻApu Hoʻopakī Hoʻolele",
  "item.minecraft.splash_potion.effect.levitation": "ʻApu Hoʻopakī Hoʻokauaheahe",
  "item.minecraft.splash_potion.effect.luck": "ʻApu Hoʻopakī Hoʻolaki",
  "item.minecraft.splash_potion.effect.mundane": "ʻApu Hoʻopakī Hana ʻOle",
  "item.minecraft.splash_potion.effect.night_vision": "ʻApu Hoʻopakī Hōʻike-i-ka-Pō",
  "item.minecraft.splash_potion.effect.oozing": "ʻApu Hoʻokapī Hākelo",
  "item.minecraft.splash_potion.effect.poison": "ʻApu Hoʻopakī Kōheoheo",
  "item.minecraft.splash_potion.effect.regeneration": "ʻApu Hoʻopakī Pāola",
  "item.minecraft.splash_potion.effect.slow_falling": "ʻApu Hoʻopakī Hoʻolohi Hina",
  "item.minecraft.splash_potion.effect.slowness": "ʻApu Hoʻopakī Hoʻolohi",
  "item.minecraft.splash_potion.effect.strength": "ʻApu Hoʻopakī Hoʻīkaika",
  "item.minecraft.splash_potion.effect.swiftness": "ʻApu Hoʻopakī Hoʻohikiwawe",
  "item.minecraft.splash_potion.effect.thick": "ʻApu Hoʻopakī Kūpū",
  "item.minecraft.splash_potion.effect.turtle_master": "ʻApu Hoʻopakī o ke Kahuna Honu",
  "item.minecraft.splash_potion.effect.water": "ʻŌmole Wai Hoʻopakī",
  "item.minecraft.splash_potion.effect.water_breathing": "ʻApu Hoʻopakī Hoʻohanu-i-ke-Kai",
  "item.minecraft.splash_potion.effect.weakness": "ʻApu Hoʻopakī Hoʻonāwali",
  "item.minecraft.splash_potion.effect.weaving": "ʻApu Hoʻopakī Hoʻopūnāwelewele",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Waʻapā Lāʻauhū",
  "item.minecraft.spruce_chest_boat": "Waʻapā Lāʻauhū me Pahu",
  "item.minecraft.spyglass": "ʻOhenānā",
  "item.minecraft.squid_spawn_egg": "Hua Hānau Mūheʻe",
  "item.minecraft.stick": "Lāʻau",
  "item.minecraft.stone_axe": "Koʻi Pōhaku",
  "item.minecraft.stone_hoe": "Hō Pōhaku",
  "item.minecraft.stone_pickaxe": "Kipikua Pōhaku",
  "item.minecraft.stone_shovel": "Kopalā Pōhaku",
  "item.minecraft.stone_spear": "Ihe Pōhaku",
  "item.minecraft.stone_sword": "Pahikaua Pōhaku",
  "item.minecraft.stray_spawn_egg": "Hua Hānau ʻAuwana",
  "item.minecraft.strider_spawn_egg": "Hua Hānau Strider",
  "item.minecraft.string": "Kaula",
  "item.minecraft.sugar": "Kōpaʻa",
  "item.minecraft.suspicious_stew": "Kai ʻAno ʻĒ",
  "item.minecraft.sweet_berries": "Nā Huaʻala ʻono",
  "item.minecraft.tadpole_bucket": "Pākeke o Polewao",
  "item.minecraft.tadpole_spawn_egg": "Hua Hānau Polewao",
  "item.minecraft.tide_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Puapana Luʻua",
  "item.minecraft.tipped_arrow.effect.awkward": "Puapana Luʻua",
  "item.minecraft.tipped_arrow.effect.empty": "Puapana Luʻua Hiki ʻOle ke Hana ʻia",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Puapana Hōʻalo ʻĀ",
  "item.minecraft.tipped_arrow.effect.harming": "Puapana Hōʻeha",
  "item.minecraft.tipped_arrow.effect.healing": "Puapana Hōʻola",
  "item.minecraft.tipped_arrow.effect.infested": "Puapana Hoʻopopopo",
  "item.minecraft.tipped_arrow.effect.invisibility": "Puapana Hoʻohūnā",
  "item.minecraft.tipped_arrow.effect.leaping": "Puapana Hoʻolele",
  "item.minecraft.tipped_arrow.effect.levitation": "Puapana Hoʻokauaheahe",
  "item.minecraft.tipped_arrow.effect.luck": "Puapana Hoʻolaki",
  "item.minecraft.tipped_arrow.effect.mundane": "Puapana Luʻua",
  "item.minecraft.tipped_arrow.effect.night_vision": "Puapana Hōʻike-i-ka-Pō",
  "item.minecraft.tipped_arrow.effect.oozing": "Puapana Hākelo",
  "item.minecraft.tipped_arrow.effect.poison": "Puapana Kōheoheo",
  "item.minecraft.tipped_arrow.effect.regeneration": "Puapana Pāola",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Puapana Hoʻolohi Hina",
  "item.minecraft.tipped_arrow.effect.slowness": "Puapana Hoʻolohi",
  "item.minecraft.tipped_arrow.effect.strength": "Puapana Hoʻoikaika",
  "item.minecraft.tipped_arrow.effect.swiftness": "Puapana Hoʻohikiwawe",
  "item.minecraft.tipped_arrow.effect.thick": "Puapana Luʻua",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Puapana o ke Kahuna Honu",
  "item.minecraft.tipped_arrow.effect.water": "Puapana Hoʻopakī",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Panapua Hoʻohanu-i-ke-Kai",
  "item.minecraft.tipped_arrow.effect.weakness": "Puapana Hoʻonāwali",
  "item.minecraft.tipped_arrow.effect.weaving": "Puapana Hoʻopūnāwelewele",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Kaʻa-mine me Kianapauka",
  "item.minecraft.torchflower_seeds": "ʻAnoʻano ʻAwapuhi Koʻokoʻo",
  "item.minecraft.totem_of_undying": "Kiʻi-o-ka-Makeʻole",
  "item.minecraft.trader_llama_spawn_egg": "Hua Hānau ʻAlapaka Kālepa",
  "item.minecraft.trial_key": "Kī Hoʻonahoa",
  "item.minecraft.trident": "ʻŌ-Maka-Kolu",
  "item.minecraft.tropical_fish": "Iʻa Hawaiʻi",
  "item.minecraft.tropical_fish_bucket": "Pākeke o Iʻa Hawaiʻi",
  "item.minecraft.tropical_fish_spawn_egg": "Hua Hānau Iʻa Hawaiʻi",
  "item.minecraft.turtle_helmet": "Una",
  "item.minecraft.turtle_scute": "Una",
  "item.minecraft.turtle_spawn_egg": "Hua Hānau Honu",
  "item.minecraft.vex_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Hua Hānau Akualapu",
  "item.minecraft.villager_spawn_egg": "Hua Hānau Kaʻaka",
  "item.minecraft.vindicator_spawn_egg": "Hua Hānau Mākaia",
  "item.minecraft.wandering_trader_spawn_egg": "Hua Hānau Kālepa Kiʻihele",
  "item.minecraft.ward_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Hua Hānau Kahupōʻele",
  "item.minecraft.warped_fungus_on_a_stick": "Pepeiao ʻEʻepa ma ka Lāʻau",
  "item.minecraft.water_bucket": "Pākeke o Wai",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Huika",
  "item.minecraft.wheat_seeds": "ʻAnoʻano Huika",
  "item.minecraft.white_bundle": "Pūʻolo Keʻokeʻo",
  "item.minecraft.white_dye": "Waihoʻoluʻu Keʻokeʻo",
  "item.minecraft.white_harness": "ʻIlikaʻa Keʻokeʻo",
  "item.minecraft.wild_armor_trim_smithing_template": "Alakaʻi Kuʻi Hao",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Pōkā Puahio",
  "item.minecraft.witch_spawn_egg": "Hua Hānau Hese",
  "item.minecraft.wither_skeleton_spawn_egg": "Hua Hānau Kanakaiwi Wither",
  "item.minecraft.wither_spawn_egg": "Hua Hānau Wither",
  "item.minecraft.wolf_armor": "ʻĀmala ʻĪliohae",
  "item.minecraft.wolf_spawn_egg": "Hua Hānau ʻĪliohae",
  "item.minecraft.wooden_axe": "Koʻi Lāʻau",
  "item.minecraft.wooden_hoe": "Hō Lāʻau",
  "item.minecraft.wooden_pickaxe": "Kipikua Lāʻau",
  "item.minecraft.wooden_shovel": "Kopalā Lāʻau",
  "item.minecraft.wooden_spear": "Ihe Lāʻau",
  "item.minecraft.wooden_sword": "Pahikaua Lāʻau",
  "item.minecraft.writable_book": "Puke me ka Hulu Kākau",
  "item.minecraft.written_book": "Puke Kākau ʻia",
  "item.minecraft.yellow_bundle": "Pūʻolo Melemele",
  "item.minecraft.yellow_dye": "Waihoʻoluʻu Melemele",
  "item.minecraft.yellow_harness": "ʻIlikaʻa Melemele",
  "item.minecraft.zoglin_spawn_egg": "Hua Hānau Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Hua Hānau Lio Iʻaloa",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Hua Hānau Iʻaloa",
  "item.minecraft.zombie_villager_spawn_egg": "Hua Hānau Kaʻaka Iʻaloa",
  "item.minecraft.zombified_piglin_spawn_egg": "Hua Hānau Piglin Iʻaloa"
}
export const haw_us = items; 
